import * as React from "react"
import { SVGProps } from "react"

interface LogoIconProps extends SVGProps<SVGSVGElement> {
  size?: number;
}
const LogoIcon = ({ size = 30, ...props }: LogoIconProps) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    xmlnsXlink="http://www.w3.org/1999/xlink" 
    width={size} 
    height={size} 
    viewBox="0 0 682 812" 
    enableBackground="new 0 0 682 812" 
    xmlSpace="preserve"
    {...props}
  >
    <path fill="#f7f7f710" opacity="1.000000" stroke="none"
      d="
M683.000000,301.000000 
	C683.000000,472.000000 683.000000,642.500000 683.000000,813.000000 
	C455.666656,813.000000 228.333328,813.000000 1.000000,813.000000 
	C1.000000,542.333313 1.000000,271.666656 1.000000,1.000000 
	C228.333328,1.000000 455.666656,1.000000 683.000000,1.000000 
	C683.000000,100.833336 683.000000,200.666672 683.000000,301.000000 
M426.136047,687.089111 
	C426.136047,687.089111 426.172089,687.189880 426.744385,686.907288 
	C426.878876,686.288940 427.013367,685.670532 427.064087,685.038269 
	C427.064087,685.038269 427.086182,685.120300 427.736572,684.797729 
	C428.169769,683.206360 428.602966,681.614929 429.214752,679.282593 
	C430.361359,677.112793 431.812256,675.046326 432.591766,672.751770 
	C434.256744,667.850830 435.574005,662.831665 437.616791,657.554871 
	C438.109833,656.712341 438.602875,655.869751 439.020538,655.013916 
	C439.020538,655.013916 439.052917,655.083252 439.674408,654.778015 
	C439.845428,653.875854 440.016449,652.973755 440.114777,652.055542 
	C440.114777,652.055542 440.148285,652.122131 440.785950,651.736755 
	C441.656769,648.868713 442.527557,646.000610 443.903015,642.612976 
	C444.045380,641.971497 444.152649,641.319885 444.335449,640.690125 
	C448.175293,627.459290 452.023621,614.231018 456.284332,600.337769 
	C458.805267,590.228394 461.326233,580.119080 464.007080,569.209229 
	C465.562653,562.429749 467.297058,555.685303 468.630768,548.862427 
	C470.520721,539.193848 472.115326,529.467468 474.290314,519.142639 
	C474.533875,517.166199 474.777405,515.189697 475.732880,512.758484 
	C477.101807,503.767792 478.470734,494.777100 480.012848,485.201385 
	C479.451538,484.478180 478.890228,483.754974 477.983093,482.409332 
	C475.588623,480.284760 473.194153,478.160156 470.458344,475.297791 
	C472.733673,473.865723 475.009003,472.433624 477.985168,471.013153 
	C487.694580,466.124481 497.403992,461.235779 507.829498,456.138245 
	C514.211670,452.729218 520.593933,449.320190 527.665894,445.814087 
	C538.431885,439.511475 549.197937,433.208862 560.666016,426.831421 
	C564.768677,424.193237 568.871277,421.555054 573.622437,418.929626 
	C574.758606,418.001160 575.894775,417.072723 577.748474,416.028534 
	C581.488770,413.638733 585.229004,411.248932 589.667053,408.821472 
	C597.116028,403.581543 604.565002,398.341614 612.706360,392.907104 
	C618.920593,388.322144 625.134827,383.737152 631.992798,378.984497 
	C638.188965,373.469604 644.851990,368.386597 650.458984,362.326599 
	C656.950867,355.310181 655.030945,348.973663 645.740601,347.170990 
	C637.673218,345.605621 629.270691,345.767487 620.226013,345.009888 
	C618.151367,345.395294 616.076721,345.780701 613.134583,346.014191 
	C603.725220,347.661194 594.315796,349.308197 584.074402,351.002533 
	C578.366577,352.392578 572.658691,353.782593 566.171265,355.092682 
	C558.791748,357.434631 551.326965,359.540314 544.050293,362.167175 
	C528.382812,367.823181 513.010681,374.131378 499.305847,385.144897 
	C493.522980,390.060181 487.740112,394.975464 481.324646,400.142639 
	C473.177612,408.414734 465.030579,416.686798 456.260956,425.200928 
	C452.878052,428.937805 449.390289,432.586517 446.148132,436.441772 
	C443.899841,439.115204 441.989807,442.073151 439.296539,445.140381 
	C437.524963,447.385895 435.753387,449.631439 433.248505,451.988464 
	C427.492401,449.441193 421.736298,446.893921 415.258942,444.026825 
	C403.860779,441.000824 392.462616,437.974823 380.917389,434.454010 
	C380.623322,434.371704 380.329285,434.289368 379.280914,434.046265 
	C378.514648,434.095886 377.748352,434.145477 376.238892,433.865051 
	C373.819519,433.545898 371.400177,433.226746 368.892303,432.443939 
	C368.699432,432.083618 368.432098,432.015686 367.380585,432.089294 
	C366.901825,432.137848 366.423065,432.186371 365.146179,432.050201 
	C363.770081,432.003937 362.394012,431.957672 361.355652,431.191864 
	C362.955811,430.890472 364.573120,430.659790 366.153564,430.276947 
	C387.083496,425.206970 407.172455,417.833771 425.582306,406.623871 
	C435.177979,400.780914 443.965607,393.610870 453.742859,386.783173 
	C455.046295,385.802002 456.538513,384.994263 457.623718,383.812653 
	C467.884094,372.641022 478.633972,361.852814 488.089783,350.031769 
	C494.399902,342.143341 498.838776,332.758026 504.592224,323.909790 
	C504.903473,323.713013 505.046906,323.430908 505.480255,322.877808 
	C505.838501,322.683472 505.933990,322.400482 506.094910,321.373444 
	C510.402863,311.958771 515.070679,302.689911 518.954224,293.103333 
	C533.036926,258.340057 539.757019,221.850021 542.822021,184.694458 
	C544.126709,168.877487 543.553467,152.905609 543.986816,136.079819 
	C543.656982,127.186127 543.531982,118.278282 542.918274,109.404221 
	C542.567200,104.326393 542.023071,99.030708 536.994568,95.089378 
	C536.361572,91.534996 535.448975,88.004288 535.145813,84.421989 
	C534.044189,71.405373 529.460022,59.599743 523.142395,48.335136 
	C506.728973,19.069244 471.044769,19.384575 451.861816,40.857975 
	C436.604401,57.937157 429.222015,78.459328 425.102356,100.957176 
	C424.034973,101.305054 422.987091,101.869606 421.897247,101.967499 
	C410.201233,103.018127 398.453918,103.634392 386.808594,105.078888 
	C370.367554,107.118248 353.956207,109.488747 337.614838,112.213654 
	C322.089020,114.802567 306.648193,117.922722 291.211609,121.016876 
	C282.395142,122.784073 273.661804,124.965858 264.427704,127.001694 
	C264.427704,127.001694 263.985016,127.144363 263.278107,126.997276 
	C262.474030,127.315811 261.669952,127.634346 260.412659,128.010895 
	C260.412659,128.010895 259.979309,128.155792 259.243744,128.003632 
	C258.135101,128.326462 257.026489,128.649307 255.440491,129.008331 
	C255.440491,129.008331 254.982819,129.148712 254.277893,128.999130 
	C253.475006,129.317474 252.672104,129.635834 251.038330,129.993622 
	C243.935822,131.546082 236.810776,133.003021 229.735657,134.671631 
	C216.496658,137.793961 203.286606,141.038986 189.422668,144.142685 
	C188.998871,144.199921 188.575058,144.257156 187.745270,144.043198 
	C187.745270,144.043198 187.269608,143.933105 186.987091,143.306229 
	C170.708939,127.164612 152.761948,113.229591 132.364120,102.661964 
	C112.994881,92.627220 92.812149,86.236023 70.563660,90.025414 
	C48.641735,93.759178 33.429108,108.013084 30.122282,128.492813 
	C26.714275,149.599182 30.646381,169.770096 38.678844,189.730042 
	C38.678844,189.730042 38.984921,189.990417 38.882332,190.764038 
	C39.319397,192.187088 39.662441,193.647217 40.207199,195.027771 
	C56.237972,235.654373 76.521614,274.008698 101.805145,309.652985 
	C127.923027,346.473541 158.086258,379.374817 196.943787,403.056244 
	C210.884567,411.552307 226.272324,417.674133 241.637360,425.280182 
	C248.388763,427.289734 255.140182,429.299255 262.407471,431.901184 
	C268.870056,432.981750 275.332611,434.062317 281.330780,435.694489 
	C278.216492,436.501709 275.102173,437.308929 271.203033,438.088226 
	C269.198059,438.714294 267.198273,439.357544 265.187256,439.963623 
	C253.441925,443.503540 241.693970,447.034729 229.207657,450.807037 
	C215.513290,456.606201 201.818924,462.405334 187.490494,468.127228 
	C187.235504,469.105438 186.980530,470.083679 186.780960,471.944489 
	C187.900177,478.960541 189.019394,485.976562 190.030914,493.787262 
	C190.411133,495.845642 190.791351,497.903992 190.901230,500.599548 
	C188.273834,503.760254 185.283142,506.687805 183.080139,510.120819 
	C171.856689,527.610901 160.495056,545.029053 149.899002,562.897644 
	C145.047760,571.078552 141.843124,580.235779 137.235718,589.281555 
	C135.820160,593.505554 134.404587,597.729492 132.552231,602.150085 
	C132.207870,602.335876 132.108948,602.610229 132.017517,603.677551 
	C131.940308,604.416382 131.863098,605.155273 131.155624,606.336609 
	C129.491119,615.890747 127.826607,625.444946 126.014359,635.900635 
	C125.719788,641.206848 124.988655,646.531189 125.209152,651.815918 
	C125.999466,670.757507 126.542305,689.738525 128.291718,708.601440 
	C129.575958,722.448364 132.336761,736.231812 138.992294,748.763123 
	C144.029083,758.246643 149.481201,758.777283 156.948685,750.180176 
	C158.002258,747.801147 159.055817,745.422058 160.748642,742.783752 
	C161.495499,741.177368 162.242355,739.570984 163.568558,737.523926 
	C166.656860,729.014709 169.745163,720.505432 173.164139,711.303101 
	C174.457016,707.234802 175.749893,703.166565 177.731125,698.717102 
	C178.859406,694.159485 179.987671,689.601807 181.793549,684.681152 
	C183.802872,677.785767 185.812195,670.890381 187.978073,663.191833 
	C192.668335,644.053955 197.368835,624.918640 202.044067,605.777100 
	C204.055710,597.540833 206.014984,589.291809 208.000809,581.858704 
	C208.849289,585.259827 209.697754,588.660889 210.800858,592.844971 
	C212.506363,599.165710 213.857773,605.608398 215.985397,611.783691 
	C221.779388,628.600342 227.901489,645.304016 234.004105,662.801086 
	C235.311279,665.969604 236.522522,669.181702 237.940857,672.299683 
	C249.106735,696.845886 261.528809,720.649597 279.964142,740.706421 
	C293.875763,755.841675 309.933197,767.467896 331.393555,770.830566 
	C331.943268,770.805115 332.492981,770.779724 333.964508,770.903870 
	C342.109711,770.986389 350.365234,772.017212 358.807495,768.017029 
	C363.909210,765.356567 369.010956,762.696106 374.745361,759.791382 
	C377.866852,757.205505 380.988373,754.619690 384.736084,751.750061 
	C386.499939,749.890930 388.263794,748.031860 390.536438,745.990906 
	C390.692322,745.685425 390.848236,745.379944 391.558441,744.774414 
	C391.730804,744.185364 391.903168,743.596375 392.005096,743.033691 
	C392.005096,743.033691 392.041168,743.099670 392.700684,742.914124 
	C406.830017,727.013184 417.079163,708.760132 425.219666,689.224182 
	C425.219666,689.224182 425.245117,689.229736 425.782349,688.919312 
	C425.933868,688.321167 426.085388,687.722961 426.136047,687.089111 
z"/>
    <path fill="#B5DDFE" opacity="1.000000" stroke="none"
      d="
M240.999664,424.879578 
	C226.272324,417.674133 210.884567,411.552307 196.943787,403.056244 
	C158.086258,379.374817 127.923027,346.473541 101.805145,309.652985 
	C76.521614,274.008698 56.237972,235.654373 40.207199,195.027771 
	C39.662441,193.647217 39.319397,192.187088 39.310871,190.341339 
	C46.495140,187.616013 53.250874,185.313370 60.409859,183.006500 
	C71.876022,179.671539 82.938927,176.340805 94.399841,172.998779 
	C100.207619,171.335419 105.617401,169.683319 111.422005,168.013550 
	C115.539848,167.014252 119.262863,166.032654 123.047592,165.462311 
	C123.406105,167.991394 123.903564,170.103241 123.966972,172.228027 
	C124.362877,185.496292 123.924782,198.838455 125.194527,212.018219 
	C126.536400,225.946671 128.802094,239.871521 131.852982,253.532471 
	C138.622864,283.845978 149.987991,312.401276 165.978714,339.152527 
	C184.027115,369.346161 206.070175,395.942291 233.907104,417.616608 
	C236.552551,419.676392 238.648560,422.441772 240.999664,424.879578 
M139.144226,332.472290 
	C139.559158,331.194336 140.574615,329.767700 140.300415,328.660400 
	C134.714828,306.103088 123.141167,287.061951 105.886566,271.568512 
	C101.562653,267.685974 96.532486,264.589935 91.826904,261.132446 
	C91.403244,261.549194 90.979584,261.965942 90.555923,262.382690 
	C100.585358,289.626526 115.957817,313.271912 139.144226,332.472290 
M166.212708,362.287231 
	C163.504410,354.705322 158.927521,348.554932 152.268799,343.341370 
	C151.495697,356.141022 158.976547,367.512238 167.724670,367.260193 
	C167.308060,365.803070 166.905243,364.394257 166.212708,362.287231 
z"/>
    <path fill="#47A4C6" opacity="1.000000" stroke="none"
      d="
M38.621189,189.332367 
	C30.646381,169.770096 26.714275,149.599182 30.122282,128.492813 
	C33.429108,108.013084 48.641735,93.759178 70.563660,90.025414 
	C92.812149,86.236023 112.994881,92.627220 132.364120,102.661964 
	C152.761948,113.229591 170.708939,127.164612 186.651688,143.668640 
	C183.013794,143.798492 179.712189,143.380341 176.408676,143.364807 
	C160.183090,143.288452 143.955948,143.220032 127.731857,143.388901 
	C124.147270,143.426208 120.572830,144.437073 116.568268,144.985092 
	C110.424301,146.055191 104.705772,147.139816 98.611786,148.227478 
	C92.807838,150.090088 87.379349,151.949692 81.578300,153.856049 
	C72.808723,158.675964 64.411705,163.449142 55.710098,168.329803 
	C48.453884,174.312424 42.431553,180.933990 38.621189,189.332367 
z"/>
    <path fill="#BAAAFF" opacity="1.000000" stroke="none"
      d="
M505.022522,323.063507 
	C505.046906,323.430908 504.903473,323.713013 504.000397,323.995667 
	C502.108337,325.054321 500.514771,325.798950 499.553192,327.035156 
	C489.870911,339.482941 477.684418,349.049774 464.265045,356.980103 
	C459.354919,359.881805 454.992859,364.880402 448.462860,363.353912 
	C454.515045,357.420258 460.345581,351.756775 466.461670,345.926300 
	C472.273895,338.766510 478.126556,332.003998 483.261322,324.734375 
	C494.990967,308.128113 502.389954,289.498871 508.122253,269.961548 
	C509.759460,268.060791 511.421539,266.356873 512.247314,264.314728 
	C519.587524,246.163284 523.219299,227.147369 523.831543,207.685867 
	C524.137085,197.974258 523.067993,188.160889 521.926514,178.475357 
	C519.974976,161.916565 515.824890,145.844406 508.338684,130.878937 
	C502.931061,120.068748 496.807007,109.616951 491.439240,99.001984 
	C493.913177,98.994263 495.950317,98.989868 498.441071,98.990601 
	C499.719482,98.997551 500.544312,99.001282 501.369110,99.000916 
	C508.893066,98.997520 510.585480,96.667137 508.201385,89.330154 
	C507.291077,86.528770 506.073181,83.827332 505.388977,81.061859 
	C509.554657,82.276756 513.326843,83.510132 517.067566,85.196304 
	C517.352051,87.925903 518.158569,90.264046 517.883118,92.466904 
	C517.287231,97.232246 519.792419,99.224556 523.665161,100.908195 
	C525.582397,101.741699 527.645386,103.445770 528.511475,105.287735 
	C532.868469,114.553772 536.809509,124.014565 541.014709,133.353745 
	C541.628662,134.717194 542.878174,135.794449 543.833618,137.004120 
	C543.553467,152.905609 544.126709,168.877487 542.822021,184.694458 
	C539.757019,221.850021 533.036926,258.340057 518.954224,293.103333 
	C515.070679,302.689911 510.402863,311.958771 505.751831,321.829163 
	C505.196747,322.503113 505.068024,322.762665 505.022522,323.063507 
z"/>
    <path fill="#47A4C6" opacity="1.000000" stroke="none"
      d="
M517.099060,84.743500 
	C513.326843,83.510132 509.554657,82.276756 505.020203,80.889946 
	C487.940582,77.396263 472.226166,79.785789 456.515076,85.805588 
	C446.366364,90.904861 436.587708,95.920815 426.631256,100.987228 
	C426.453491,101.037697 426.142609,101.237617 426.074463,101.119003 
	C426.006348,101.000389 425.931183,100.737343 425.931183,100.737343 
	C429.222015,78.459328 436.604401,57.937157 451.861816,40.857975 
	C471.044769,19.384575 506.728973,19.069244 523.142395,48.335136 
	C529.460022,59.599743 534.044189,71.405373 535.145813,84.421989 
	C535.448975,88.004288 536.361572,91.534996 536.647583,95.385139 
	C529.900024,92.035103 523.499573,88.389297 517.099060,84.743500 
z"/>
    <path fill="#B7A0FF" opacity="1.000000" stroke="none"
      d="
M137.891724,588.950256 
	C141.843124,580.235779 145.047760,571.078552 149.899002,562.897644 
	C160.495056,545.029053 171.856689,527.610901 183.080139,510.120819 
	C185.283142,506.687805 188.273834,503.760254 191.310333,500.116943 
	C193.160599,497.755890 194.601791,495.877380 196.334534,493.844299 
	C200.026260,490.884369 203.426422,488.079071 207.161255,485.187134 
	C208.024185,484.729309 208.552475,484.358124 209.473068,483.983276 
	C212.242996,484.669983 214.620621,485.360260 216.995026,486.438477 
	C217.331924,488.547058 217.672043,490.267731 217.987961,492.392883 
	C218.062180,493.871307 218.160599,494.945221 218.192413,496.391296 
	C218.037460,497.510620 217.949112,498.257812 217.411255,499.003540 
	C211.661591,499.991302 206.043106,500.181091 201.128296,502.138092 
	C191.229004,506.079803 184.418991,514.067139 178.698761,522.687866 
	C159.873444,551.058594 152.990372,583.167358 151.232819,616.456238 
	C150.502853,630.282227 151.649780,644.319946 153.179916,658.124329 
	C155.144897,675.851990 159.991440,692.939087 168.909531,708.602112 
	C169.716217,710.018921 171.502213,710.878113 172.833435,711.996216 
	C169.745163,720.505432 166.656860,729.014709 163.078979,737.476929 
	C160.914032,734.991882 158.958939,732.699219 157.605728,730.093933 
	C140.741150,697.624634 136.902618,662.407043 136.077637,626.599854 
	C135.963928,621.663940 136.637436,616.706482 137.013626,611.764038 
	C137.213593,609.136597 137.725189,606.524841 137.800568,603.897522 
	C137.943390,598.918335 137.873352,593.933044 137.891724,588.950256 
z"/>
    <path fill="#B69EFE" opacity="1.000000" stroke="none"
      d="
M453.118225,387.040283 
	C443.965607,393.610870 435.177979,400.780914 425.582306,406.623871 
	C407.172455,417.833771 387.083496,425.206970 366.153564,430.276947 
	C364.573120,430.659790 362.955811,430.890472 360.768860,431.582764 
	C355.456207,432.656616 350.730408,433.339508 345.656952,433.862732 
	C319.871155,427.854034 295.926422,418.319550 273.861084,404.324341 
	C270.254395,402.036713 267.286011,398.742645 264.411926,395.924866 
	C268.832855,397.050781 272.864471,398.165588 277.192810,399.500885 
	C287.660431,401.476990 297.831360,403.232635 308.400513,405.112732 
	C318.534760,405.416199 328.270752,405.595215 338.432556,405.829651 
	C346.970856,404.812164 355.083344,403.739258 363.621582,402.628052 
	C370.367218,401.126526 376.687134,399.663269 383.120728,398.578247 
	C384.104584,399.302429 384.964600,399.921143 385.846375,399.953888 
	C401.712128,400.543243 417.283112,398.646515 432.464111,393.975098 
	C439.403107,391.839844 446.236786,389.362488 453.118225,387.040283 
z"/>
    <path fill="#B69EFE" opacity="1.000000" stroke="none"
      d="
M116.993713,144.999634 
	C120.572830,144.437073 124.147270,143.426208 127.731857,143.388901 
	C143.955948,143.220032 160.183090,143.288452 176.408676,143.364807 
	C179.712189,143.380341 183.013794,143.798492 186.792938,143.982071 
	C187.269608,143.933105 187.745270,144.043198 187.895966,144.350159 
	C188.046677,144.657120 188.058121,145.015457 187.985184,145.352463 
	C184.069962,148.891586 181.653641,152.639267 181.863068,157.996414 
	C182.009903,161.752670 181.374512,165.555771 180.914642,169.316711 
	C178.810699,186.523361 179.974136,203.608353 182.739212,220.634583 
	C184.111832,229.086563 185.572418,237.524261 186.767609,246.241333 
	C180.556030,249.088333 174.570023,251.662399 168.223755,254.035492 
	C167.374619,252.796600 166.716431,251.804367 166.422119,250.713928 
	C161.406494,232.131073 158.961502,213.127472 158.134949,193.969452 
	C157.700562,183.901382 158.755234,173.774857 158.972763,163.671188 
	C159.171814,154.425262 159.074112,154.423157 149.632004,157.045990 
	C147.174911,157.729279 145.082001,158.373642 142.623718,159.056519 
	C139.832428,160.055649 137.406479,161.016296 134.607880,161.982086 
	C132.820282,162.337143 131.405304,162.687027 129.622742,163.034058 
	C127.836128,163.353546 126.417114,163.675888 124.725769,163.766602 
	C121.966858,157.356552 119.480286,151.178085 116.993713,144.999634 
z"/>
    <path fill="#D4BAFE" opacity="1.000000" stroke="none"
      d="
M188.124557,468.204468 
	C201.818924,462.405334 215.513290,456.606201 229.777496,451.047211 
	C246.905777,453.583344 263.464203,455.879303 280.015778,458.592529 
	C281.848633,467.696381 283.697632,476.381042 285.522125,485.070831 
	C286.026306,487.472168 286.457489,489.888794 286.484772,492.279480 
	C262.906433,487.870422 239.704193,483.773499 216.653198,478.953339 
	C206.703033,476.872650 196.160339,475.666595 188.124557,468.204468 
z"/>
    <path fill="#F3EDFE" opacity="1.000000" stroke="none"
      d="
M381.064453,434.948853 
	C392.462616,437.974823 403.860779,441.000824 415.621399,444.610077 
	C415.974060,453.888855 416.414032,462.617279 415.781342,471.267242 
	C415.417145,476.246613 413.317169,481.099030 411.762909,486.277100 
	C403.612335,488.561340 399.588715,492.120514 398.729004,497.645325 
	C382.886200,497.847839 367.439423,497.921265 351.990845,497.629883 
	C350.722382,495.406464 349.625244,493.400726 348.160919,491.713654 
	C340.027802,482.343231 334.867981,471.615692 333.459167,459.232239 
	C339.582977,458.361420 345.274689,457.579651 351.010986,457.190308 
	C352.969452,466.079620 356.989288,473.272461 363.570740,479.141998 
	C372.288300,486.916534 384.701355,486.920410 392.781219,478.687195 
	C400.699371,470.618866 402.280914,460.587585 400.390930,450.048126 
	C398.705505,440.649414 397.353333,440.268219 387.623840,439.920990 
	C379.000854,439.613251 370.839020,441.311707 362.519287,443.928467 
	C361.504028,443.169739 360.756927,442.531616 360.079407,441.547546 
	C363.861572,439.791687 367.597809,438.440186 371.277069,436.948151 
	C373.229767,436.156311 375.083618,435.120697 376.982086,434.195099 
	C377.748352,434.145477 378.514648,434.095886 379.779236,434.312500 
	C380.490234,434.807495 380.752533,434.930878 381.064453,434.948853 
z"/>
    <path fill="#B6CAFF" opacity="1.000000" stroke="none"
      d="
M129.990341,163.036926 
	C131.405304,162.687027 132.820282,162.337143 134.937546,162.167221 
	C135.760147,165.489700 135.837448,168.634567 136.007828,171.774368 
	C137.004791,190.145996 137.033157,208.642288 139.346741,226.847656 
	C141.214432,241.544449 145.798477,255.901810 149.334702,270.371338 
	C149.664825,271.722107 151.127243,272.796173 152.246643,274.330261 
	C157.767731,297.037140 167.697922,317.267578 181.028839,336.286438 
	C181.712921,338.319031 182.197266,340.099915 183.129456,341.603027 
	C196.226746,362.721436 212.307846,381.248993 231.013626,397.632080 
	C246.046570,410.798340 262.347748,421.988281 279.872406,431.505737 
	C281.790680,432.547577 283.287964,434.364655 284.645111,435.854431 
	C283.471497,435.638794 282.633362,435.390839 281.795197,435.142883 
	C275.332611,434.062317 268.870056,432.981750 262.141174,431.244934 
	C260.719849,429.464813 259.710754,428.118378 258.387726,427.250610 
	C240.140106,415.282410 223.684799,401.281647 208.693604,385.374420 
	C195.649597,371.533356 184.023422,356.711121 174.071716,340.556915 
	C159.871613,317.506500 148.875381,293.020416 141.473526,266.945892 
	C133.175247,237.713470 129.009033,207.960373 129.978012,177.534821 
	C130.131760,172.706955 129.993561,167.869781 129.990341,163.036926 
z"/>
    <path fill="#B9AAFE" opacity="1.000000" stroke="none"
      d="
M172.998779,711.649658 
	C171.502213,710.878113 169.716217,710.018921 168.909531,708.602112 
	C159.991440,692.939087 155.144897,675.851990 153.179916,658.124329 
	C151.649780,644.319946 150.502853,630.282227 151.232819,616.456238 
	C152.990372,583.167358 159.873444,551.058594 178.698761,522.687866 
	C184.418991,514.067139 191.229004,506.079803 201.128296,502.138092 
	C206.043106,500.181091 211.661591,499.991302 217.477783,499.466064 
	C217.933243,504.954193 217.872665,509.978271 217.415161,514.990112 
	C210.128906,512.593323 204.117752,515.314392 198.745956,518.947937 
	C188.027298,526.198120 180.604202,536.416931 175.061249,547.954285 
	C165.308990,568.253113 160.561295,589.946655 159.159866,612.226685 
	C157.843445,633.155029 158.986084,654.102722 165.157303,674.343872 
	C167.828247,683.104370 169.726288,692.468506 177.042755,699.098267 
	C175.749893,703.166565 174.457016,707.234802 172.998779,711.649658 
z"/>
    <path fill="#BEB5FF" opacity="1.000000" stroke="none"
      d="
M187.821518,663.994995 
	C185.812195,670.890381 183.802872,677.785767 181.092865,684.815369 
	C178.225555,680.996887 175.451157,677.254822 173.995773,673.055664 
	C167.074142,653.084656 164.908478,632.615356 166.817383,611.447388 
	C168.763611,589.865784 173.094513,569.157837 184.356216,550.438538 
	C191.471512,538.611389 200.058105,528.396545 215.880478,529.436279 
	C215.783508,531.484497 215.653030,533.103271 215.462265,534.714844 
	C214.701035,541.145752 213.921036,547.574585 212.866226,553.992371 
	C212.397644,554.001709 212.210815,554.022827 211.777786,553.763672 
	C209.630478,553.680725 207.536499,553.429077 205.859985,554.149231 
	C195.925537,558.416504 191.112946,567.242065 187.074829,576.443115 
	C179.593048,593.490662 177.177536,611.545593 178.166138,629.970398 
	C178.491745,636.038391 180.751541,642.002563 182.093445,648.434875 
	C180.985916,656.883972 178.432404,664.875000 181.502747,673.496521 
	C182.695145,670.020813 183.744293,666.962708 185.171326,663.931030 
	C186.306641,663.969910 187.064072,663.982422 187.821518,663.994995 
z"/>
    <path fill="#B6D3FF" opacity="1.000000" stroke="none"
      d="
M129.622742,163.034058 
	C129.993561,167.869781 130.131760,172.706955 129.978012,177.534821 
	C129.009033,207.960373 133.175247,237.713470 141.473526,266.945892 
	C148.875381,293.020416 159.871613,317.506500 174.071716,340.556915 
	C184.023422,356.711121 195.649597,371.533356 208.693604,385.374420 
	C223.684799,401.281647 240.140106,415.282410 258.387726,427.250610 
	C259.710754,428.118378 260.719849,429.464813 261.883240,430.948730 
	C255.140182,429.299255 248.388763,427.289734 241.318512,425.079895 
	C238.648560,422.441772 236.552551,419.676392 233.907104,417.616608 
	C206.070175,395.942291 184.027115,369.346161 165.978714,339.152527 
	C149.987991,312.401276 138.622864,283.845978 131.852982,253.532471 
	C128.802094,239.871521 126.536400,225.946671 125.194527,212.018219 
	C123.924782,198.838455 124.362877,185.496292 123.966972,172.228027 
	C123.903564,170.103241 123.406105,167.991394 123.345886,165.423065 
	C124.054337,164.647797 124.526215,164.322998 124.998100,163.998215 
	C126.417114,163.675888 127.836128,163.353546 129.622742,163.034058 
z"/>
    <path fill="#9681FF" opacity="1.000000" stroke="none"
      d="
M264.891022,126.960976 
	C273.661804,124.965858 282.395142,122.784073 291.211609,121.016876 
	C306.648193,117.922722 322.089020,114.802567 337.614838,112.213654 
	C353.956207,109.488747 370.367554,107.118248 386.808594,105.078888 
	C398.453918,103.634392 410.201233,103.018127 421.897247,101.967499 
	C422.987091,101.869606 424.034973,101.305054 425.516785,100.847260 
	C425.931183,100.737343 426.006348,101.000389 426.037231,101.412537 
	C426.009552,102.894638 425.951050,103.964577 425.886353,105.381302 
	C425.202850,107.185036 424.525543,108.641991 423.552063,110.130219 
	C422.844360,110.773232 422.432831,111.384987 421.652588,112.154221 
	C419.660309,112.510475 418.019165,112.971024 416.415985,112.863907 
	C408.335083,112.323944 400.262573,111.118607 392.190063,111.142601 
	C383.780823,111.167603 375.380524,112.412521 366.966309,112.974358 
	C352.202759,113.960167 337.804352,116.960327 323.727142,121.296867 
	C311.049438,125.202301 298.688446,129.836609 287.349670,137.135849 
	C277.919952,143.206146 267.660278,147.973892 257.967041,153.657669 
	C255.584274,155.054840 253.976593,157.773834 251.621384,159.876831 
	C245.442383,158.580246 239.654587,157.291977 233.554291,156.019745 
	C232.825531,156.009247 232.409256,155.982697 232.002625,155.594910 
	C234.632858,152.176910 236.800568,148.494354 239.972229,146.199127 
	C245.825302,141.963425 252.277481,138.558151 258.459930,134.774048 
	C261.704376,132.788177 264.906219,130.732697 268.127289,128.708649 
	C267.952362,128.310730 267.777435,127.912811 267.602509,127.514885 
	C266.698700,127.330254 265.794861,127.145615 264.891022,126.960976 
z"/>
    <path fill="#B7A0FF" opacity="1.000000" stroke="none"
      d="
M390.027649,746.172791 
	C388.263794,748.031860 386.499939,749.890930 384.020508,751.838379 
	C378.985504,751.033630 374.594604,750.393188 370.361389,749.195435 
	C361.234406,746.613098 352.188507,743.744141 343.085632,740.576294 
	C344.054230,727.773315 345.046661,715.386353 346.423157,703.006836 
	C363.510162,709.345032 380.532074,714.060608 398.611450,713.655151 
	C395.680237,723.139404 392.713928,732.201660 389.953796,741.326233 
	C389.508148,742.799500 389.979950,744.550293 390.027649,746.172791 
z"/>
    <path fill="#BBADFE" opacity="1.000000" stroke="none"
      d="
M215.819275,529.003479 
	C200.058105,528.396545 191.471512,538.611389 184.356216,550.438538 
	C173.094513,569.157837 168.763611,589.865784 166.817383,611.447388 
	C164.908478,632.615356 167.074142,653.084656 173.995773,673.055664 
	C175.451157,677.254822 178.225555,680.996887 180.754059,684.996887 
	C179.987671,689.601807 178.859406,694.159485 177.386948,698.907715 
	C169.726288,692.468506 167.828247,683.104370 165.157303,674.343872 
	C158.986084,654.102722 157.843445,633.155029 159.159866,612.226685 
	C160.561295,589.946655 165.308990,568.253113 175.061249,547.954285 
	C180.604202,536.416931 188.027298,526.198120 198.745956,518.947937 
	C204.117752,515.314392 210.128906,512.593323 217.438385,515.404114 
	C217.178802,520.221436 216.499039,524.612427 215.819275,529.003479 
z"/>
    <path fill="#C2C3FF" opacity="1.000000" stroke="none"
      d="
M187.899796,663.593384 
	C187.064072,663.982422 186.306641,663.969910 185.215210,663.520752 
	C186.314224,656.991394 187.691376,650.884766 189.194244,644.809265 
	C191.085770,637.162537 193.080048,629.541260 195.029984,621.909058 
	C194.444962,621.708435 193.859924,621.507812 193.274902,621.307190 
	C189.558899,630.209534 185.842896,639.111877 182.126892,648.014221 
	C180.751541,642.002563 178.491745,636.038391 178.166138,629.970398 
	C177.177536,611.545593 179.593048,593.490662 187.074829,576.443115 
	C191.112946,567.242065 195.925537,558.416504 205.859985,554.149231 
	C207.536499,553.429077 209.630478,553.680725 211.753204,554.193115 
	C211.270660,560.208557 210.566467,565.514282 209.586655,571.104187 
	C208.873367,574.608459 208.435715,577.828552 207.998047,581.048584 
	C206.014984,589.291809 204.055710,597.540833 202.044067,605.777100 
	C197.368835,624.918640 192.668335,644.053955 187.899796,663.593384 
M195.575577,619.522156 
	C195.575577,619.522156 195.477371,619.585144 195.575577,619.522156 
z"/>
    <path fill="#B9A5FE" opacity="1.000000" stroke="none"
      d="
M453.430542,386.911743 
	C446.236786,389.362488 439.403107,391.839844 432.464111,393.975098 
	C417.283112,398.646515 401.712128,400.543243 385.846375,399.953888 
	C384.964600,399.921143 384.104584,399.302429 383.451691,398.435791 
	C385.446991,397.229523 387.225006,396.543945 389.374084,395.854034 
	C411.087585,388.454651 430.484283,377.527618 448.241211,363.624084 
	C454.992859,364.880402 459.354919,359.881805 464.265045,356.980103 
	C477.684418,349.049774 489.870911,339.482941 499.553192,327.035156 
	C500.514771,325.798950 502.108337,325.054321 503.761841,324.062073 
	C498.838776,332.758026 494.399902,342.143341 488.089783,350.031769 
	C478.633972,361.852814 467.884094,372.641022 457.623718,383.812653 
	C456.538513,384.994263 455.046295,385.802002 453.430542,386.911743 
z"/>
    <path fill="#8B72CC" opacity="1.000000" stroke="none"
      d="
M280.022644,458.175262 
	C263.464203,455.879303 246.905777,453.583344 230.147125,450.928101 
	C241.693970,447.034729 253.441925,443.503540 265.187256,439.963623 
	C267.198273,439.357544 269.198059,438.714294 271.653412,438.488007 
	C273.278442,439.592834 274.415558,440.829681 275.633881,440.915588 
	C282.893433,441.427673 290.198181,442.231140 297.437866,441.886902 
	C310.288818,441.275787 323.124481,440.104401 335.919617,438.730408 
	C339.037689,438.395569 341.973633,436.364502 345.238770,435.042053 
	C345.646179,434.917633 345.808136,434.864532 346.275757,434.990173 
	C348.757599,436.103638 350.933746,437.038300 353.154785,438.146912 
	C353.199677,438.320831 353.271271,438.672913 353.021423,439.008057 
	C351.910095,439.820679 351.096436,440.573486 350.179657,440.732819 
	C341.635864,442.217804 333.093140,443.736420 324.505951,444.926605 
	C322.086853,445.261932 321.015961,445.811432 320.941833,448.417999 
	C320.834656,452.186096 320.281250,455.941559 319.500122,459.765656 
	C317.389160,459.903076 315.696350,459.977234 313.541656,459.990051 
	C307.733765,459.750854 302.387726,459.573029 296.587189,459.282532 
	C290.762665,458.838348 285.392670,458.506805 280.022644,458.175262 
z"/>
    <path fill="#7B68D5" opacity="1.000000" stroke="none"
      d="
M559.963928,426.906250 
	C549.197937,433.208862 538.431885,439.511475 527.328125,445.488098 
	C527.961670,442.787476 528.932983,440.412811 530.173523,437.379944 
	C506.584808,436.235718 483.400482,435.860504 461.067810,428.787354 
	C461.079651,428.556152 461.132690,428.096375 461.418884,427.928162 
	C464.803802,425.203766 467.902557,422.647583 471.258087,420.350006 
	C477.999878,421.795990 484.457764,423.772308 490.975861,423.996185 
	C502.335327,424.386353 513.809204,424.437958 525.092224,423.261414 
	C537.630249,421.953979 550.008423,419.114136 563.313416,416.791840 
	C561.937683,420.946198 560.950806,423.926208 559.963928,426.906250 
z"/>
    <path fill="#6952CA" opacity="1.000000" stroke="none"
      d="
M507.113403,456.347107 
	C497.403992,461.235779 487.694580,466.124481 477.452850,470.703857 
	C472.278137,467.595520 467.635712,464.796539 462.792450,461.732178 
	C460.435822,460.290924 458.280090,459.115021 455.935455,457.653351 
	C452.654083,455.478027 449.417877,453.780792 446.527222,451.621063 
	C444.988373,450.471313 444.047516,448.521149 443.003876,446.633667 
	C446.704132,443.036377 450.237305,439.737610 453.961243,436.790222 
	C465.066559,439.427612 475.934753,441.977783 486.912567,443.903137 
	C493.759033,445.103943 500.771027,445.361176 508.680969,446.137299 
	C506.254242,449.098938 504.730652,450.958374 503.393616,452.590118 
	C504.802277,454.012878 505.957855,455.179993 507.113403,456.347107 
z"/>
    <path fill="#9A8AEA" opacity="1.000000" stroke="none"
      d="
M588.969238,408.859131 
	C585.229004,411.248932 581.488770,413.638733 577.503052,415.752441 
	C580.432495,410.449219 583.655579,405.451324 586.736389,400.367249 
	C587.268494,399.489166 587.197144,398.245453 587.404602,397.170624 
	C586.371826,397.042114 585.281067,396.630310 584.315063,396.828033 
	C571.565857,399.437744 558.916382,402.691956 546.064941,404.581146 
	C539.220886,405.587250 532.035095,404.268890 525.270142,403.717865 
	C535.326721,400.470154 545.081116,397.378418 554.922791,394.595062 
	C559.392883,393.330872 559.834473,391.324280 557.235474,387.740082 
	C562.643066,385.312073 567.823975,383.157257 573.384399,380.958557 
	C583.917908,377.867249 594.071960,374.819855 605.413086,371.416168 
	C604.812317,375.907684 604.404968,378.953308 603.957947,382.356079 
	C599.588135,389.659515 595.199402,396.570404 590.972534,403.578949 
	C590.016052,405.164856 589.622131,407.090088 588.969238,408.859131 
z"/>
    <path fill="#B3D7FB" opacity="1.000000" stroke="none"
      d="
M330.977844,770.452759 
	C309.933197,767.467896 293.875763,755.841675 279.964142,740.706421 
	C261.528809,720.649597 249.106735,696.845886 237.940857,672.299683 
	C236.522522,669.181702 235.311279,665.969604 234.132751,662.078125 
	C234.543594,659.252869 234.825821,657.150696 235.404205,655.216553 
	C237.797195,659.594055 239.894028,663.803589 242.031570,668.377869 
	C246.380371,677.164246 250.688477,685.585754 255.035004,694.365967 
	C259.986389,705.960938 266.573151,716.025696 276.295258,723.676819 
	C280.628204,727.086792 285.424438,729.908081 290.278870,733.190247 
	C301.024780,746.956787 312.125641,759.871765 327.780029,768.096069 
	C324.511292,763.733032 321.242554,759.369934 318.354736,755.009521 
	C324.106964,757.002319 329.478210,758.992310 334.778046,761.330505 
	C333.463684,764.603394 332.220795,767.528076 330.977844,770.452759 
z"/>
    <path fill="#B0A2FD" opacity="1.000000" stroke="none"
      d="
M425.237213,689.239502 
	C417.079163,708.760132 406.830017,727.013184 392.296539,742.601685 
	C392.129333,741.156067 392.240387,739.978638 392.621521,738.896240 
	C405.101044,703.456421 417.559296,668.008850 430.151550,632.608948 
	C432.414124,626.248352 435.244598,620.089722 437.870239,614.239380 
	C432.900391,629.123047 427.873260,643.605286 422.846100,658.087463 
	C423.382599,658.310791 423.919098,658.534119 424.455566,658.757385 
	C425.283173,657.070190 426.203888,655.421509 426.921753,653.688782 
	C429.635345,647.139221 432.283142,640.562439 435.246643,634.260132 
	C435.478912,639.270020 436.937256,642.731934 442.479279,642.780701 
	C442.786621,642.783447 443.092041,643.010132 443.398346,643.132568 
	C442.527557,646.000610 441.656769,648.868713 440.401978,651.515503 
	C440.312775,648.865723 440.607544,646.437195 440.936584,643.726196 
	C432.024353,654.700989 414.278107,697.249451 414.830994,707.115051 
	C416.757629,703.351624 418.201233,700.213562 419.932373,697.242981 
	C421.541260,694.482300 423.456726,691.900208 425.237213,689.239502 
z"/>
    <path fill="#B3D7FB" opacity="1.000000" stroke="none"
      d="
M156.522919,750.768494 
	C149.481201,758.777283 144.029083,758.246643 138.992294,748.763123 
	C132.336761,736.231812 129.575958,722.448364 128.291718,708.601440 
	C126.542305,689.738525 125.999466,670.757507 125.209152,651.815918 
	C124.988655,646.531189 125.719788,641.206848 126.469696,635.558899 
	C127.283012,636.243591 127.849152,637.246521 127.968025,638.299927 
	C130.018143,656.468506 131.038864,674.819031 134.276901,692.770447 
	C137.985397,713.330017 144.612701,733.163391 156.522919,750.768494 
z"/>
    <path fill="#8A79DF" opacity="1.000000" stroke="none"
      d="
M560.314941,426.868835 
	C560.950806,423.926208 561.937683,420.946198 563.313416,416.791840 
	C550.008423,419.114136 537.630249,421.953979 525.092224,423.261414 
	C513.809204,424.437958 502.335327,424.386353 490.975861,423.996185 
	C484.457764,423.772308 477.999878,421.795990 471.438293,420.063416 
	C475.589294,416.351288 479.816864,413.184357 484.380615,410.171753 
	C490.509796,411.550690 496.310486,413.843933 502.094269,413.802032 
	C520.346802,413.669861 538.593506,412.673828 556.841248,411.980530 
	C559.284302,411.887726 561.732971,411.713135 564.157593,411.406464 
	C572.734802,410.321503 573.034973,410.551697 572.973938,418.916840 
	C568.871277,421.555054 564.768677,424.193237 560.314941,426.868835 
z"/>
    <path fill="#9086E0" opacity="1.000000" stroke="none"
      d="
M573.298218,418.923218 
	C573.034973,410.551697 572.734802,410.321503 564.157593,411.406464 
	C561.732971,411.713135 559.284302,411.887726 556.841248,411.980530 
	C538.593506,412.673828 520.346802,413.669861 502.094269,413.802032 
	C496.310486,413.843933 490.509796,411.550690 484.382385,409.952942 
	C484.047974,409.579834 484.040955,409.142609 484.379578,409.057800 
	C489.125854,406.247528 493.533539,403.522095 498.112244,401.154419 
	C499.271179,402.022217 500.237671,402.924927 501.250427,402.980133 
	C509.163116,403.411774 517.084717,403.680573 525.003540,403.999634 
	C532.035095,404.268890 539.220886,405.587250 546.064941,404.581146 
	C558.916382,402.691956 571.565857,399.437744 584.315063,396.828033 
	C585.281067,396.630310 586.371826,397.042114 587.404602,397.170624 
	C587.197144,398.245453 587.268494,399.489166 586.736389,400.367249 
	C583.655579,405.451324 580.432495,410.449219 577.144287,415.810303 
	C575.894775,417.072723 574.758606,418.001160 573.298218,418.923218 
z"/>
    <path fill="#B3D7FB" opacity="1.000000" stroke="none"
      d="
M621.016235,345.166016 
	C629.270691,345.767487 637.673218,345.605621 645.740601,347.170990 
	C655.030945,348.973663 656.950867,355.310181 650.458984,362.326599 
	C644.851990,368.386597 638.188965,373.469604 631.258179,379.021606 
	C620.980652,376.784454 620.980591,376.784454 620.997864,367.012695 
	C620.998474,366.687012 621.002502,366.361298 621.003296,365.563446 
	C621.006531,358.449524 621.011414,351.807770 621.016235,345.166016 
z"/>
    <path fill="#725ED0" opacity="1.000000" stroke="none"
      d="
M507.471436,456.242676 
	C505.957855,455.179993 504.802277,454.012878 503.393616,452.590118 
	C504.730652,450.958374 506.254242,449.098938 508.680969,446.137299 
	C500.771027,445.361176 493.759033,445.103943 486.912567,443.903137 
	C475.934753,441.977783 465.066559,439.427612 454.067413,436.510559 
	C456.340515,433.592560 458.698242,431.305542 461.055969,429.018555 
	C483.400482,435.860504 506.584808,436.235718 530.173523,437.379944 
	C528.932983,440.412811 527.961670,442.787476 526.983276,445.536621 
	C520.593933,449.320190 514.211670,452.729218 507.471436,456.242676 
z"/>
    <path fill="#9479FF" opacity="1.000000" stroke="none"
      d="
M264.659363,126.981339 
	C265.794861,127.145615 266.698700,127.330254 267.602509,127.514885 
	C267.777435,127.912811 267.952362,128.310730 268.127289,128.708649 
	C264.906219,130.732697 261.704376,132.788177 258.459930,134.774048 
	C252.277481,138.558151 245.825302,141.963425 239.972229,146.199127 
	C236.800568,148.494354 234.632858,152.176910 231.662766,155.604767 
	C230.859894,155.959793 230.406509,155.943710 229.721390,155.649231 
	C216.347931,151.658218 203.206238,147.945602 190.064529,144.233002 
	C203.286606,141.038986 216.496658,137.793961 229.735657,134.671631 
	C236.810776,133.003021 243.935822,131.546082 251.793365,129.987946 
	C253.359863,129.704407 254.171341,129.426559 254.982819,129.148712 
	C254.982819,129.148712 255.440491,129.008331 256.042236,128.999146 
	C257.755737,128.711914 258.867523,128.433853 259.979309,128.155792 
	C259.979309,128.155792 260.412659,128.010895 260.979645,127.996521 
	C262.359436,127.702881 263.172211,127.423615 263.985016,127.144363 
	C263.985016,127.144363 264.427704,127.001694 264.659363,126.981339 
z"/>
    <path fill="#BBADFE" opacity="1.000000" stroke="none"
      d="
M479.839661,485.786407 
	C478.470734,494.777100 477.101807,503.767792 475.059631,513.090088 
	C471.381012,520.349182 468.375702,527.276733 465.017029,534.026855 
	C462.825836,529.344788 461.090057,524.795105 459.127106,520.345642 
	C455.826599,512.864380 452.381714,505.446808 449.245117,497.729248 
	C453.995117,495.970703 458.497559,494.485352 463.294617,492.998657 
	C464.090698,492.902954 464.592163,492.808563 465.093658,492.714172 
	C465.007629,492.483459 464.921600,492.252747 464.835602,492.022034 
	C464.223724,492.348022 463.611877,492.674042 462.577179,492.998901 
	C459.567535,493.443787 456.995331,494.021759 454.391052,494.309814 
	C447.968597,495.020172 441.531403,495.597443 435.506805,496.151215 
	C450.555511,492.644928 465.197601,489.215668 479.839661,485.786407 
z"/>
    <path fill="#4FE0BF" opacity="1.000000" stroke="none"
      d="
M479.926270,485.493896 
	C465.197601,489.215668 450.555511,492.644928 435.090759,496.137756 
	C411.920624,497.778992 389.591156,500.183044 367.219910,500.671295 
	C349.503204,501.057983 331.735229,499.094604 313.559601,498.101746 
	C308.387115,497.479950 303.638275,496.983765 298.904358,496.372040 
	C287.319733,494.875031 275.742035,493.324646 264.136810,491.812012 
	C264.112091,491.828217 264.079651,491.877716 263.930328,491.617004 
	C263.196411,491.273346 262.611816,491.190399 261.636719,491.003601 
	C250.534073,488.819794 239.821884,486.739868 228.794403,484.463806 
	C225.707260,483.747101 222.935425,483.226471 219.868011,482.490540 
	C214.423645,481.131012 209.274811,479.986755 203.965973,478.654022 
	C203.396912,478.501160 202.987869,478.536774 202.578827,478.572388 
	C202.994034,478.779480 203.409241,478.986572 203.997009,479.471954 
	C205.806656,481.162476 207.443710,482.574707 209.080765,483.986938 
	C208.552475,484.358124 208.024185,484.729309 206.831512,485.092957 
	C204.085327,483.688782 202.003555,482.292206 199.787659,480.595306 
	C195.344177,477.217316 191.034866,474.139587 186.725540,471.061890 
	C186.980530,470.083679 187.235504,469.105438 187.807526,468.165863 
	C196.160339,475.666595 206.703033,476.872650 216.653198,478.953339 
	C239.704193,483.773499 262.906433,487.870422 286.821472,492.477264 
	C293.731445,493.401031 299.867249,494.108093 306.433868,494.892883 
	C313.244965,495.567749 319.625244,496.164886 326.459137,496.837708 
	C335.272736,497.273834 343.632690,497.634247 351.992676,497.994690 
	C367.439423,497.921265 382.886200,497.847839 399.187622,497.619415 
	C413.668762,495.897278 427.295227,494.330109 441.309509,492.781891 
	C444.466400,492.168213 447.235504,491.535614 450.402344,490.926880 
	C459.976349,488.311066 469.152649,485.671417 478.328918,483.031769 
	C478.890228,483.754974 479.451538,484.478180 479.926270,485.493896 
z"/>
    <path fill="#B6B2FF" opacity="1.000000" stroke="none"
      d="
M137.563721,589.115906 
	C137.873352,593.933044 137.943390,598.918335 137.800568,603.897522 
	C137.725189,606.524841 137.213593,609.136597 137.013626,611.764038 
	C136.637436,616.706482 135.963928,621.663940 136.077637,626.599854 
	C136.902618,662.407043 140.741150,697.624634 157.605728,730.093933 
	C158.958939,732.699219 160.914032,734.991882 162.789307,737.697266 
	C162.242355,739.570984 161.495499,741.177368 160.070099,742.866882 
	C158.480988,742.064819 157.291748,741.334167 156.702179,740.270996 
	C149.250458,726.833740 143.612076,712.675537 139.960571,697.732422 
	C136.061844,681.777588 133.169250,665.675232 133.015060,649.197510 
	C132.902069,637.123962 133.055389,625.047852 132.936890,612.974426 
	C132.913666,610.610779 132.187714,608.254028 131.785889,605.894104 
	C131.863098,605.155273 131.940308,604.416382 132.302887,603.190430 
	C132.780441,602.484741 132.914017,602.234802 132.989014,601.953491 
	C134.404587,597.729492 135.820160,593.505554 137.563721,589.115906 
z"/>
    <path fill="#FAF7FF" opacity="1.000000" stroke="none"
      d="
M499.961945,384.900848 
	C513.010681,374.131378 528.382812,367.823181 544.050293,362.167175 
	C551.326965,359.540314 558.791748,357.434631 566.544434,355.476013 
	C565.603088,357.739685 564.488586,359.807434 562.935059,361.463531 
	C558.981018,365.678833 554.830688,369.710052 550.418213,373.886902 
	C543.429871,376.377106 536.782288,378.795349 529.728149,381.157867 
	C522.850098,382.336639 516.406250,383.757294 509.895294,384.726898 
	C506.647552,385.210571 503.276978,384.869080 499.961945,384.900848 
z"/>
    <path fill="#ECDFFF" opacity="1.000000" stroke="none"
      d="
M411.998566,486.008606 
	C413.317169,481.099030 415.417145,476.246613 415.781342,471.267242 
	C416.414032,462.617279 415.974060,453.888855 415.982025,444.769989 
	C421.736298,446.893921 427.492401,449.441193 433.514404,452.051422 
	C433.780334,452.114380 433.955811,452.372009 433.971283,452.813354 
	C432.984070,464.850159 431.981415,476.445618 430.559265,488.032135 
	C424.092712,487.351685 418.045624,486.680145 411.998566,486.008606 
z"/>
    <path fill="#B5C7FE" opacity="1.000000" stroke="none"
      d="
M131.470764,606.115356 
	C132.187714,608.254028 132.913666,610.610779 132.936890,612.974426 
	C133.055389,625.047852 132.902069,637.123962 133.015060,649.197510 
	C133.169250,665.675232 136.061844,681.777588 139.960571,697.732422 
	C143.612076,712.675537 149.250458,726.833740 156.702179,740.270996 
	C157.291748,741.334167 158.480988,742.064819 159.750473,742.996521 
	C159.055817,745.422058 158.002258,747.801147 156.735809,750.474365 
	C144.612701,733.163391 137.985397,713.330017 134.276901,692.770447 
	C131.038864,674.819031 130.018143,656.468506 127.968025,638.299927 
	C127.849152,637.246521 127.283012,636.243591 126.543564,635.108154 
	C127.826607,625.444946 129.491119,615.890747 131.470764,606.115356 
z"/>
    <path fill="#4FE0BF" opacity="1.000000" stroke="none"
      d="
M331.185730,770.641663 
	C332.220795,767.528076 333.463684,764.603394 334.965363,761.014343 
	C335.835541,758.233887 336.446960,756.117737 337.217804,753.684326 
	C337.974213,751.329102 338.571228,749.291199 339.400635,746.945679 
	C340.191711,743.802673 340.750397,740.967285 341.509766,737.791504 
	C342.403442,724.967651 343.096436,712.484375 343.837402,699.573425 
	C343.400543,694.694946 343.033234,690.227539 342.410797,685.795959 
	C339.547760,665.410522 333.697174,645.840393 324.765289,627.359741 
	C319.010406,615.452515 311.960327,604.171326 305.392517,592.281372 
	C303.679260,589.515381 302.064240,587.077576 300.346558,584.349121 
	C299.639374,583.255615 299.034851,582.452759 298.323547,581.392029 
	C297.887085,580.687927 297.557373,580.241699 297.150330,579.508179 
	C296.481506,578.446594 295.889923,577.672424 295.196045,576.618652 
	C294.733948,575.888245 294.374146,575.437317 293.942871,574.746582 
	C293.616180,574.303101 293.361023,574.099548 293.037323,573.593750 
	C292.324646,572.516235 291.680481,571.740906 290.959381,570.728516 
	C290.713776,570.183472 290.461914,569.976990 290.058411,569.568237 
	C289.330627,568.501770 288.671295,567.739014 288.004456,566.987793 
	C287.996948,566.999390 288.024017,566.995239 287.941772,566.749939 
	C287.584564,566.313293 287.309662,566.121948 287.021027,565.963135 
	C287.007294,565.995605 287.070801,565.965088 286.989258,565.714478 
	C286.623260,565.281616 286.338776,565.099304 286.044830,564.957031 
	C286.035339,564.997070 286.103210,564.950500 286.086151,564.651978 
	C285.709076,563.906311 285.349091,563.459167 284.994537,563.005981 
	C285.000000,563.000000 284.986786,563.007751 284.907837,562.766113 
	C284.560974,562.332153 284.293091,562.139832 284.022888,561.976868 
	C284.020538,562.006226 284.055695,561.958801 283.996490,561.736389 
	C283.801300,561.220154 283.583313,561.012329 283.140564,560.664551 
	C282.703156,560.258240 282.408508,560.077942 282.071960,559.905090 
	C282.030090,559.912537 282.107025,559.948730 282.097839,559.643311 
	C281.719452,558.877319 281.350250,558.416748 280.906799,557.746704 
	C280.682800,557.262207 280.458435,557.078064 280.038696,556.742065 
	C279.622925,556.309204 279.327881,556.119080 279.021362,555.962280 
	C279.009857,555.995605 279.073120,555.964661 278.996521,555.709961 
	C278.629486,555.277832 278.338989,555.100281 278.029968,554.959473 
	C278.011444,554.996155 278.079742,554.950317 278.019623,554.685852 
	C277.659058,554.255127 277.358643,554.088867 277.050964,553.963806 
	C277.043762,554.005005 277.102020,553.944946 277.111633,553.633301 
	C276.747681,552.846985 276.374146,552.372437 275.895081,551.650024 
	C275.274750,550.923218 274.759949,550.444092 274.135071,549.745850 
	C273.842224,549.246521 273.604675,549.025146 273.189331,548.558960 
	C271.866821,547.037354 270.667358,545.819336 269.326630,544.310852 
	C267.779999,542.647217 266.374603,541.274048 264.887909,539.704468 
	C264.639404,539.258850 264.408203,539.106873 263.953125,538.750732 
	C251.765091,526.621887 239.737045,514.794434 227.683792,502.775391 
	C227.520569,502.337158 227.310394,502.205292 226.805237,502.034119 
	C226.418808,501.803314 226.255203,501.726715 225.914871,501.389404 
	C223.402451,499.451355 221.066772,497.774017 218.612885,496.078491 
	C218.494675,496.060303 218.259033,496.019165 218.259033,496.019165 
	C218.160599,494.945221 218.062180,493.871307 218.333710,492.405090 
	C221.435608,494.082703 224.167557,496.152557 227.069992,498.496887 
	C237.466644,508.527618 247.692825,518.283875 258.079163,528.333618 
	C266.776428,538.204346 275.313507,547.781555 283.945740,557.665527 
	C288.621552,564.003235 293.202179,570.034241 297.865540,576.344238 
	C298.298798,577.058350 298.649292,577.493408 298.993713,577.966064 
	C298.987640,578.003723 299.062286,578.019592 299.127869,578.253784 
	C299.353149,578.804749 299.608826,578.986755 299.980225,579.017212 
	C300.000000,579.000488 299.964478,579.039185 300.040710,579.285278 
	C300.393372,579.708862 300.669861,579.886353 300.961609,580.027222 
	C300.976898,579.990601 300.920624,580.046753 300.920074,580.347229 
	C301.266174,581.102966 301.612823,581.558228 301.974121,582.009827 
	C301.988800,582.006165 301.979828,582.034973 302.053162,582.280762 
	C302.399597,582.705261 302.672699,582.884033 302.961029,583.026367 
	C302.976288,582.989990 302.921204,583.046936 302.919250,583.348633 
	C303.262421,584.107361 303.607574,584.564392 303.973633,585.013367 
	C303.994568,585.005249 303.964569,585.038879 304.002869,585.352051 
	C304.675720,586.455872 305.310272,587.246643 305.963837,588.017334 
	C305.982819,587.997253 305.957581,588.041809 306.031311,588.291260 
	C306.384338,588.715393 306.663696,588.890137 306.957489,589.026978 
	C306.971954,588.989197 306.917206,589.049194 306.900696,589.355225 
	C307.234406,590.122192 307.584656,590.583252 307.958801,591.020386 
	C307.982666,590.996582 307.946136,591.048401 308.011963,591.305176 
	C308.365051,591.730347 308.652283,591.898804 308.947021,592.027649 
	C308.954559,591.988037 308.908630,592.054565 308.872620,592.364014 
	C309.198944,593.132996 309.561249,593.592407 309.961761,594.027161 
	C310.000000,594.002441 309.922363,594.047974 309.914490,594.352173 
	C310.251007,595.117065 310.595428,595.577759 310.966980,596.038818 
	C310.994141,596.039185 310.941864,596.060852 310.972473,596.377319 
	C311.642120,597.481445 312.281128,598.269104 312.958984,599.037476 
	C312.997833,599.018127 312.921021,599.047241 312.912964,599.352417 
	C313.247864,600.120361 313.590881,600.583252 313.959290,601.049561 
	C313.984680,601.053040 313.931061,601.067017 313.958740,601.405029 
	C314.964203,603.180908 315.942017,604.618713 316.958313,606.040527 
	C316.996857,606.024536 316.921082,606.044983 316.913147,606.366821 
	C317.234985,607.224060 317.564789,607.759521 317.910187,608.472412 
	C317.925751,608.649963 318.087433,608.967590 318.163879,609.310181 
	C321.134308,615.120239 324.028229,620.587769 326.937897,626.026733 
	C326.953613,625.998108 326.907898,626.054688 326.897491,626.420715 
	C327.899719,628.876587 328.912384,630.966370 329.947144,633.021729 
	C329.969299,632.987305 329.910706,633.049561 329.902954,633.405151 
	C330.571594,635.193298 331.247955,636.625916 331.942505,638.021362 
	C331.960693,637.984253 331.906647,638.050293 331.902435,638.427246 
	C332.906281,641.222839 333.914307,643.641479 334.955383,646.026978 
	C334.988403,645.993958 334.906250,646.038879 334.884003,646.379272 
	C335.216736,647.500671 335.571747,648.281799 335.957825,649.031128 
	C335.988953,648.999329 335.907257,649.034607 335.892944,649.375732 
	C336.226562,650.498901 336.574463,651.280945 336.954987,652.029419 
	C336.987579,651.995789 336.904083,652.038269 336.887512,652.424316 
	C337.560944,654.893677 338.250977,656.976990 338.964294,659.029724 
	C338.987579,658.999084 338.914978,659.024780 338.907837,659.384094 
	C339.225952,660.625244 339.551239,661.507080 339.845398,662.531616 
	C339.814270,662.674377 339.928436,662.943298 339.932892,663.308960 
	C340.251709,664.573669 340.566040,665.472717 340.850037,666.517151 
	C340.819672,666.662598 340.908600,666.946167 340.915436,667.365051 
	C342.627869,679.522461 344.333466,691.260925 346.039062,702.999451 
	C345.046661,715.386353 344.054230,727.773315 342.969910,740.947510 
	C342.176880,744.804626 341.475800,747.874451 340.549988,751.206299 
	C339.575684,753.975037 338.826141,756.481628 337.888733,759.297668 
	C336.148163,763.322815 334.595428,767.038574 333.042725,770.754272 
	C332.492981,770.779724 331.943268,770.805115 331.185730,770.641663 
z"/>
    <path fill="#B7A0FF" opacity="1.000000" stroke="none"
      d="
M517.067566,85.196297 
	C523.499573,88.389297 529.900024,92.035103 536.600098,95.814728 
	C542.023071,99.030708 542.567200,104.326393 542.918274,109.404221 
	C543.531982,118.278282 543.656982,127.186127 543.910217,136.541962 
	C542.878174,135.794449 541.628662,134.717194 541.014709,133.353745 
	C536.809509,124.014565 532.868469,114.553772 528.511475,105.287735 
	C527.645386,103.445770 525.582397,101.741699 523.665161,100.908195 
	C519.792419,99.224556 517.287231,97.232246 517.883118,92.466904 
	C518.158569,90.264046 517.352051,87.925903 517.067566,85.196297 
z"/>
    <path fill="#4FE0BF" opacity="1.000000" stroke="none"
      d="
M465.370361,534.204224 
	C468.375702,527.276733 471.381012,520.349182 474.703674,513.317505 
	C474.777405,515.189697 474.533875,517.166199 473.812561,519.720459 
	C467.321625,535.535645 461.308411,550.772949 455.160034,566.355164 
	C454.316956,568.789856 453.609009,570.879700 452.655334,573.214783 
	C451.594086,575.966553 450.778534,578.473145 449.978821,580.991089 
	C449.994629,581.002441 449.971588,580.975586 449.701691,581.173218 
	C449.266693,582.239075 449.101562,583.107239 448.967590,583.987549 
	C448.998779,583.999756 448.946686,583.957581 448.662323,584.142578 
	C448.225739,585.207764 448.073547,586.087830 447.960480,586.980591 
	C447.999603,586.993225 447.931824,586.946228 447.655457,587.082581 
	C447.234619,587.805420 447.090149,588.391968 446.971283,588.991089 
	C446.996887,589.003601 446.957611,588.962891 446.682617,589.156982 
	C446.248291,590.225098 446.088898,591.099060 445.963501,591.986572 
	C445.997498,592.000183 445.940979,591.953735 445.654541,592.137390 
	C445.218872,593.203003 445.069672,594.084900 444.959930,594.980835 
	C444.999390,594.994812 444.930573,594.946838 444.653015,595.081787 
	C444.230927,595.804077 444.086365,596.391479 443.968933,596.991211 
	C443.996063,597.003601 443.956421,596.959473 443.681549,597.154297 
	C443.246124,598.223389 443.085541,599.097778 442.961060,599.985596 
	C442.997162,599.999146 442.937927,599.949890 442.643188,600.134277 
	C441.876984,601.869934 441.405487,603.421265 440.961182,604.990784 
	C440.988373,605.008972 440.952179,604.955017 440.661133,605.161255 
	C439.550964,608.231262 438.731873,611.095032 437.904938,613.914429 
	C437.897125,613.869995 437.812866,613.837830 437.812866,613.837830 
	C435.244598,620.089722 432.414124,626.248352 430.151550,632.608948 
	C417.559296,668.008850 405.101044,703.456421 392.621521,738.896240 
	C392.240387,739.978638 392.129333,741.156067 391.966797,742.694458 
	C392.041168,743.099670 392.005096,743.033691 391.733124,743.121826 
	C391.308807,743.831482 391.156464,744.453003 391.004150,745.074463 
	C390.848236,745.379944 390.692322,745.685425 390.282043,746.081848 
	C389.979950,744.550293 389.508148,742.799500 389.953796,741.326233 
	C392.713928,732.201660 395.680237,723.139404 398.886353,713.492432 
	C402.770691,702.618103 406.346741,692.307922 410.114746,681.681519 
	C415.254852,667.256409 420.203033,653.147400 425.422729,638.817505 
	C428.144287,632.069580 430.594299,625.542603 433.044434,619.015625 
	C440.044281,600.368713 447.044189,581.721802 454.298859,562.821899 
	C458.159210,553.114014 461.764771,543.659119 465.370361,534.204224 
z"/>
    <path fill="#AE98FF" opacity="1.000000" stroke="none"
      d="
M443.650696,642.872803 
	C443.092041,643.010132 442.786621,642.783447 442.479279,642.780701 
	C436.937256,642.731934 435.478912,639.270020 435.266479,633.875977 
	C436.049744,630.110168 437.051697,626.973816 438.168793,623.878967 
	C441.410156,614.898560 444.697693,605.934753 448.125092,597.276367 
	C450.812134,598.726318 453.341217,599.864258 455.870300,601.002197 
	C452.023621,614.231018 448.175293,627.459290 444.335449,640.690125 
	C444.152649,641.319885 444.045380,641.971497 443.650696,642.872803 
z"/>
    <path fill="#DDC6FF" opacity="1.000000" stroke="none"
      d="
M478.156006,482.720551 
	C469.152649,485.671417 459.976349,488.311066 450.400879,490.491455 
	C450.656555,480.759064 451.311432,471.485992 452.283783,462.301514 
	C454.705841,463.649933 456.810425,464.909729 459.093628,466.450806 
	C463.114716,469.833221 466.957214,472.934387 470.799713,476.035583 
	C473.194153,478.160156 475.588623,480.284760 478.156006,482.720551 
z"/>
    <path fill="#C6CFFF" opacity="1.000000" stroke="none"
      d="
M499.633911,385.022888 
	C503.276978,384.869080 506.647552,385.210571 509.895294,384.726898 
	C516.406250,383.757294 522.850098,382.336639 529.631653,381.479309 
	C524.637024,384.909576 519.332397,387.962708 513.701172,391.141418 
	C508.230164,394.443573 503.085693,397.620117 497.941254,400.796692 
	C493.533539,403.522095 489.125854,406.247528 484.329285,408.665039 
	C483.279388,405.535004 482.618347,402.712891 481.957275,399.890778 
	C487.740112,394.975464 493.522980,390.060181 499.633911,385.022888 
z"/>
    <path fill="#BDB2FF" opacity="1.000000" stroke="none"
      d="
M550.758911,373.814941 
	C554.830688,369.710052 558.981018,365.678833 562.935059,361.463531 
	C564.488586,359.807434 565.603088,357.739685 566.934204,355.515991 
	C572.658691,353.782593 578.366577,352.392578 584.812805,351.143616 
	C586.700012,355.188965 587.848816,359.093262 588.642700,363.151978 
	C584.192993,364.533691 580.098267,365.760986 575.593201,366.992676 
	C574.216370,367.128510 573.214355,367.139130 572.288818,367.410461 
	C565.103882,369.516937 557.933655,371.673737 550.758911,373.814941 
z"/>
    <path fill="#B5AEFF" opacity="1.000000" stroke="none"
      d="
M340.774719,750.944214 
	C341.475800,747.874451 342.176880,744.804626 342.993683,741.363647 
	C352.188507,743.744141 361.234406,746.613098 370.361389,749.195435 
	C374.594604,750.393188 378.985504,751.033630 383.707397,751.980347 
	C380.988373,754.619690 377.866852,757.205505 374.021484,759.895508 
	C364.535583,757.375244 355.784729,754.712524 347.003204,752.155090 
	C344.980957,751.566223 342.853668,751.338257 340.774719,750.944214 
z"/>
    <path fill="#B7A0FF" opacity="1.000000" stroke="none"
      d="
M588.997559,362.997559 
	C587.848816,359.093262 586.700012,355.188965 585.228821,351.119934 
	C594.315796,349.308197 603.725220,347.661194 613.627930,346.482849 
	C613.968750,352.987579 613.842224,359.024689 613.594177,365.056824 
	C613.580383,365.393158 612.562683,365.688202 612.006592,365.594971 
	C612.113220,360.357269 609.598267,359.442657 605.329895,360.316010 
	C599.929016,361.421051 594.445435,362.122223 588.997559,362.997559 
z"/>
    <path fill="#9086E0" opacity="1.000000" stroke="none"
      d="
M235.108063,655.048462 
	C234.825821,657.150696 234.543594,659.252869 234.077469,661.703735 
	C227.901489,645.304016 221.779388,628.600342 215.985397,611.783691 
	C213.857773,605.608398 212.506363,599.165710 211.107361,592.438721 
	C212.276535,592.006287 213.139206,591.980042 214.273758,592.212036 
	C220.760117,611.038818 226.950623,629.615540 233.251617,648.154602 
	C233.611038,649.212097 234.874237,649.962463 235.762344,651.210205 
	C235.574615,652.725952 235.341339,653.887207 235.108063,655.048462 
z"/>
    <path fill="#7A68A9" opacity="1.000000" stroke="none"
      d="
M344.993317,435.113342 
	C341.973633,436.364502 339.037689,438.395569 335.919617,438.730408 
	C323.124481,440.104401 310.288818,441.275787 297.437866,441.886902 
	C290.198181,442.231140 282.893433,441.427673 275.633881,440.915588 
	C274.415558,440.829681 273.278442,439.592834 272.045837,438.501984 
	C275.102173,437.308929 278.216492,436.501709 281.562988,435.418701 
	C282.633362,435.390839 283.471497,435.638794 285.088928,435.913940 
	C293.905609,436.239532 301.943024,436.537964 310.447021,436.892639 
	C322.273499,436.337067 333.633423,435.725189 344.993317,435.113342 
z"/>
    <path fill="#DDC6FF" opacity="1.000000" stroke="none"
      d="
M425.228455,689.231812 
	C423.456726,691.900208 421.541260,694.482300 419.932373,697.242981 
	C418.201233,700.213562 416.757629,703.351624 414.830994,707.115051 
	C414.278107,697.249451 432.024353,654.700989 440.936584,643.726196 
	C440.607544,646.437195 440.312775,648.865723 440.083130,651.708191 
	C440.148285,652.122131 440.114777,652.055542 439.832153,652.216675 
	C439.384003,653.279663 439.218475,654.181458 439.052917,655.083252 
	C439.052917,655.083252 439.020538,655.013916 438.780701,655.146667 
	C438.038452,656.139954 437.536072,657.000427 437.033691,657.860962 
	C435.574005,662.831665 434.256744,667.850830 432.591766,672.751770 
	C431.812256,675.046326 430.361359,677.112793 428.826660,679.841370 
	C427.987732,681.973511 427.536957,683.546936 427.086182,685.120300 
	C427.086182,685.120300 427.064087,685.038269 426.807861,685.187744 
	C426.425079,685.954712 426.298584,686.572327 426.172089,687.189880 
	C426.172089,687.189880 426.136047,687.089111 425.869385,687.221680 
	C425.483521,687.979431 425.364319,688.604614 425.245117,689.229736 
	C425.245117,689.229736 425.219666,689.224182 425.228455,689.231812 
z"/>
    <path fill="#A092FF" opacity="1.000000" stroke="none"
      d="
M456.077332,600.669983 
	C453.341217,599.864258 450.812134,598.726318 448.142334,596.886353 
	C449.347839,590.753967 450.694061,585.323730 452.035645,579.702271 
	C452.030975,579.511169 452.007874,579.129578 452.255005,578.938721 
	C452.680725,578.163086 452.859314,577.578247 453.295349,576.773804 
	C453.335571,575.359253 453.118317,574.164429 452.901062,572.969543 
	C453.609009,570.879700 454.316956,568.789856 455.477173,566.401550 
	C459.007599,566.515808 459.436890,572.296997 463.847168,570.009705 
	C461.326233,580.119080 458.805267,590.228394 456.077332,600.669983 
z"/>
    <path fill="#B5BFFF" opacity="1.000000" stroke="none"
      d="
M340.549988,751.206299 
	C342.853668,751.338257 344.980957,751.566223 347.003204,752.155090 
	C355.784729,754.712524 364.535583,757.375244 373.705139,760.017639 
	C369.010956,762.696106 363.909210,765.356567 358.361938,767.699341 
	C357.058746,766.668091 356.311646,765.664917 355.325348,765.288513 
	C349.606964,763.106689 343.832245,761.072449 338.076599,758.988281 
	C338.826141,756.481628 339.575684,753.975037 340.549988,751.206299 
z"/>
    <path fill="#A8A1EF" opacity="1.000000" stroke="none"
      d="
M589.318115,408.840271 
	C589.622131,407.090088 590.016052,405.164856 590.972534,403.578949 
	C595.199402,396.570404 599.588135,389.659515 604.295227,382.304504 
	C606.778992,379.923279 608.885803,377.950806 611.200867,376.227814 
	C612.931152,376.324707 614.453247,376.172119 615.937927,376.387573 
	C614.716797,379.594421 613.192688,382.347992 612.454346,385.298248 
	C611.833008,387.780640 612.125854,390.491791 612.014038,393.101685 
	C604.565002,398.341614 597.116028,403.581543 589.318115,408.840271 
z"/>
    <path fill="#9886FF" opacity="1.000000" stroke="none"
      d="
M463.927124,569.609497 
	C459.436890,572.296997 459.007599,566.515808 455.612366,566.056702 
	C461.308411,550.772949 467.321625,535.535645 473.585510,520.032043 
	C472.115326,529.467468 470.520721,539.193848 468.630768,548.862427 
	C467.297058,555.685303 465.562653,562.429749 463.927124,569.609497 
z"/>
    <path fill="#BFB8FF" opacity="1.000000" stroke="none"
      d="
M481.640961,400.016724 
	C482.618347,402.712891 483.279388,405.535004 483.990692,408.749878 
	C484.040955,409.142609 484.047974,409.579834 484.046204,409.798645 
	C479.816864,413.184357 475.589294,416.351288 471.181519,419.804810 
	C467.902557,422.647583 464.803802,425.203766 461.116730,427.776733 
	C459.313446,426.848602 458.098480,425.903748 456.883484,424.958862 
	C465.030579,416.686798 473.177612,408.414734 481.640961,400.016724 
z"/>
    <path fill="#C0BEFF" opacity="1.000000" stroke="none"
      d="
M38.650017,189.531204 
	C42.431553,180.933990 48.453884,174.312424 55.705708,168.733307 
	C57.339474,173.689774 58.673038,178.350235 60.006607,183.010712 
	C53.250874,185.313370 46.495140,187.616013 39.362167,189.954529 
	C38.984921,189.990417 38.678844,189.730042 38.650017,189.531204 
z"/>
    <path fill="#A4D3EB" opacity="1.000000" stroke="none"
      d="
M612.360229,393.004395 
	C612.125854,390.491791 611.833008,387.780640 612.454346,385.298248 
	C613.192688,382.347992 614.716797,379.594421 615.990540,376.018921 
	C617.721985,372.200043 619.363403,369.117828 621.004883,366.035614 
	C621.002502,366.361298 620.998474,366.687012 620.997864,367.012695 
	C620.980591,376.784454 620.980652,376.784454 630.936279,379.105438 
	C625.134827,383.737152 618.920593,388.322144 612.360229,393.004395 
z"/>
    <path fill="#B6B2FF" opacity="1.000000" stroke="none"
      d="
M621.003296,365.563446 
	C619.363403,369.117828 617.721985,372.200043 616.027954,375.650909 
	C614.453247,376.172119 612.931152,376.324707 611.213257,375.818024 
	C611.349121,372.106659 611.680664,369.054535 612.012207,366.002441 
	C612.562683,365.688202 613.580383,365.393158 613.594177,365.056824 
	C613.842224,359.024689 613.968750,352.987579 614.061707,346.558777 
	C616.076721,345.780701 618.151367,345.395294 620.621155,345.087952 
	C621.011414,351.807770 621.006531,358.449524 621.003296,365.563446 
z"/>
    <path fill="#B6D3FF" opacity="1.000000" stroke="none"
      d="
M337.888733,759.297668 
	C343.832245,761.072449 349.606964,763.106689 355.325348,765.288513 
	C356.311646,765.664917 357.058746,766.668091 357.980835,767.741943 
	C350.365234,772.017212 342.109711,770.986389 333.503601,770.829102 
	C334.595428,767.038574 336.148163,763.322815 337.888733,759.297668 
z"/>
    <path fill="#B3D7FB" opacity="1.000000" stroke="none"
      d="
M186.753250,471.503174 
	C191.034866,474.139587 195.344177,477.217316 199.373550,480.673767 
	C198.078217,481.899109 196.418732,482.594604 196.177444,483.622864 
	C195.622787,485.986664 195.758499,488.512482 195.289520,491.031189 
	C193.356216,491.724091 191.747421,492.358337 190.138626,492.992615 
	C189.019394,485.976562 187.900177,478.960541 186.753250,471.503174 
z"/>
    <path fill="#B9A5FE" opacity="1.000000" stroke="none"
      d="
M456.572205,425.079895 
	C458.098480,425.903748 459.313446,426.848602 460.830566,427.944946 
	C461.132690,428.096375 461.079651,428.556152 461.067810,428.787354 
	C458.698242,431.305542 456.340515,433.592560 453.876648,436.159210 
	C450.237305,439.737610 446.704132,443.036377 442.689941,446.622192 
	C441.448822,446.240814 440.688751,445.572388 439.928650,444.903992 
	C441.989807,442.073151 443.899841,439.115204 446.148132,436.441772 
	C449.390289,432.586517 452.878052,428.937805 456.572205,425.079895 
z"/>
    <path fill="#9F90CE" opacity="1.000000" stroke="none"
      d="
M439.612610,445.022186 
	C440.688751,445.572388 441.448822,446.240814 442.522827,446.920715 
	C444.047516,448.521149 444.988373,450.471313 446.527222,451.621063 
	C449.417877,453.780792 452.654083,455.478027 455.545715,457.671692 
	C453.883606,459.047150 452.422363,460.118469 450.616882,461.092346 
	C444.833679,458.120636 439.394745,455.246338 433.955811,452.372009 
	C433.955811,452.372009 433.780334,452.114380 433.881104,451.995667 
	C435.753387,449.631439 437.524963,447.385895 439.612610,445.022186 
z"/>
    <path fill="#A8A1EF" opacity="1.000000" stroke="none"
      d="
M470.629028,475.666687 
	C466.957214,472.934387 463.114716,469.833221 459.239868,466.146240 
	C460.469421,464.372803 461.731384,463.185181 462.993317,461.997528 
	C467.635712,464.796539 472.278137,467.595520 477.102448,470.698029 
	C475.009003,472.433624 472.733673,473.865723 470.629028,475.666687 
z"/>
    <path fill="#E6D6FF" opacity="1.000000" stroke="none"
      d="
M353.271271,438.672913 
	C353.271271,438.672913 353.199677,438.320831 353.477966,437.996735 
	C356.325348,436.804016 358.952911,436.073212 361.442627,435.017334 
	C363.047791,434.336578 364.450745,433.178894 365.944336,432.234924 
	C366.423065,432.186371 366.901825,432.137848 367.827026,432.341492 
	C368.458588,432.812500 368.694366,432.917114 368.980804,432.907593 
	C371.400177,433.226746 373.819519,433.545898 376.610474,434.030090 
	C375.083618,435.120697 373.229767,436.156311 371.277069,436.948151 
	C367.597809,438.440186 363.861572,439.791687 359.755066,441.449280 
	C357.331146,440.688965 355.301208,439.680939 353.271271,438.672913 
z"/>
    <path fill="#725CFF" opacity="1.000000" stroke="none"
      d="
M189.743591,144.187836 
	C203.206238,147.945602 216.347931,151.658218 229.306976,155.699753 
	C221.751251,154.386200 214.378189,152.743729 206.664490,150.927826 
	C200.235275,148.841431 194.146698,146.928452 188.058121,145.015457 
	C188.058121,145.015457 188.046677,144.657120 188.098969,144.485748 
	C188.575058,144.257156 188.998871,144.199921 189.743591,144.187836 
z"/>
    <path fill="#8B72CC" opacity="1.000000" stroke="none"
      d="
M214.001892,591.953796 
	C213.139206,591.980042 212.276535,592.006287 210.980042,592.047241 
	C209.697754,588.660889 208.849289,585.259827 207.999435,581.453613 
	C208.435715,577.828552 208.873367,574.608459 209.625275,571.537231 
	C210.964386,575.790283 211.989258,579.894653 213.007629,584.405945 
	C213.334717,587.193237 213.668304,589.573486 214.001892,591.953796 
z"/>
    <path fill="#BFC7FC" opacity="1.000000" stroke="none"
      d="
M365.545258,432.142578 
	C364.450745,433.178894 363.047791,434.336578 361.442627,435.017334 
	C358.952911,436.073212 356.325348,436.804016 353.433044,437.822815 
	C350.933746,437.038300 348.757599,436.103638 346.288452,434.793762 
	C345.995392,434.418549 346.004578,434.022430 346.004578,434.022430 
	C350.730408,433.339508 355.456207,432.656616 360.599976,431.942566 
	C362.394012,431.957672 363.770081,432.003937 365.545258,432.142578 
z"/>
    <path fill="#A4D3EB" opacity="1.000000" stroke="none"
      d="
M190.084778,493.389923 
	C191.747421,492.358337 193.356216,491.724091 195.420654,491.393250 
	C195.931839,492.464081 195.987411,493.231476 196.042969,493.998901 
	C194.601791,495.877380 193.160599,497.755890 191.445496,499.798370 
	C190.791351,497.903992 190.411133,495.845642 190.084778,493.389923 
z"/>
    <path fill="#B0A2FD" opacity="1.000000" stroke="none"
      d="
M427.411377,684.958984 
	C427.536957,683.546936 427.987732,681.973511 428.737366,680.211853 
	C428.602966,681.614929 428.169769,683.206360 427.411377,684.958984 
z"/>
    <path fill="#B0A2FD" opacity="1.000000" stroke="none"
      d="
M437.325256,657.707886 
	C437.536072,657.000427 438.038452,656.139954 438.818359,655.153320 
	C438.602875,655.869751 438.109833,656.712341 437.325256,657.707886 
z"/>
    <path fill="#9681FF" opacity="1.000000" stroke="none"
      d="
M259.611511,128.079712 
	C258.867523,128.433853 257.755737,128.711914 256.280884,128.981064 
	C257.026489,128.649307 258.135101,128.326462 259.611511,128.079712 
z"/>
    <path fill="#B0A2FD" opacity="1.000000" stroke="none"
      d="
M439.363678,654.930664 
	C439.218475,654.181458 439.384003,653.279663 439.868469,652.224731 
	C440.016449,652.973755 439.845428,653.875854 439.363678,654.930664 
z"/>
    <path fill="#9681FF" opacity="1.000000" stroke="none"
      d="
M254.630356,129.073914 
	C254.171341,129.426559 253.359863,129.704407 252.208801,129.968231 
	C252.672104,129.635834 253.475006,129.317474 254.630356,129.073914 
z"/>
    <path fill="#9681FF" opacity="1.000000" stroke="none"
      d="
M263.631561,127.070816 
	C263.172211,127.423615 262.359436,127.702881 261.206238,127.967506 
	C261.669952,127.634346 262.474030,127.315811 263.631561,127.070816 
z"/>
    <path fill="#B0A2FD" opacity="1.000000" stroke="none"
      d="
M426.458252,687.048584 
	C426.298584,686.572327 426.425079,685.954712 426.849731,685.194702 
	C427.013367,685.670532 426.878876,686.288940 426.458252,687.048584 
z"/>
    <path fill="#B0A2FD" opacity="1.000000" stroke="none"
      d="
M425.513733,689.074524 
	C425.364319,688.604614 425.483521,687.979431 425.919830,687.239563 
	C426.085388,687.722961 425.933868,688.321167 425.513733,689.074524 
z"/>
    <path fill="#B0A2FD" opacity="1.000000" stroke="none"
      d="
M391.281311,744.924438 
	C391.156464,744.453003 391.308807,743.831482 391.768341,743.108643 
	C391.903168,743.596375 391.730804,744.185364 391.281311,744.924438 
z"/>
    <path fill="#E6D6FF" opacity="1.000000" stroke="none"
      d="
M380.990906,434.701416 
	C380.752533,434.930878 380.490234,434.807495 380.156372,434.392883 
	C380.329285,434.289368 380.623322,434.371704 380.990906,434.701416 
z"/>
    <path fill="#B5C7FE" opacity="1.000000" stroke="none"
      d="
M132.770615,602.051758 
	C132.914017,602.234802 132.780441,602.484741 132.421875,602.838196 
	C132.108948,602.610229 132.207870,602.335876 132.770615,602.051758 
z"/>
    <path fill="#BFC7FC" opacity="1.000000" stroke="none"
      d="
M368.936554,432.675781 
	C368.694366,432.917114 368.458588,432.812500 368.181885,432.416901 
	C368.432098,432.015686 368.699432,432.083618 368.936554,432.675781 
z"/>
    <path fill="#B9A5FE" opacity="1.000000" stroke="none"
      d="
M505.251404,322.970642 
	C505.068024,322.762665 505.196747,322.503113 505.587769,322.156860 
	C505.933990,322.400482 505.838501,322.683472 505.251404,322.970642 
z"/>
    <path fill="#FDFEFF" opacity="1.000000" stroke="none"
      d="
M138.853455,332.259338 
	C115.957817,313.271912 100.585358,289.626526 90.555923,262.382690 
	C90.979584,261.965942 91.403244,261.549194 91.826904,261.132446 
	C96.532486,264.589935 101.562653,267.685974 105.886566,271.568512 
	C123.141167,287.061951 134.714828,306.103088 140.300415,328.660400 
	C140.574615,329.767700 139.559158,331.194336 138.853455,332.259338 
z"/>
    <path fill="#C3C7FF" opacity="1.000000" stroke="none"
      d="
M60.409859,183.006500 
	C58.673038,178.350235 57.339474,173.689774 56.010300,168.625793 
	C64.411705,163.449142 72.808723,158.675964 81.635742,154.218414 
	C82.883583,155.278793 83.578178,156.379974 84.538696,156.712097 
	C92.433281,159.441772 94.820129,165.272964 94.001831,173.010071 
	C82.938927,176.340805 71.876022,179.671539 60.409859,183.006500 
z"/>
    <path fill="#C0BEFF" opacity="1.000000" stroke="none"
      d="
M94.399841,172.998779 
	C94.820129,165.272964 92.433281,159.441772 84.538696,156.712097 
	C83.578178,156.379974 82.883583,155.278793 82.008301,154.171661 
	C87.379349,151.949692 92.807838,150.090088 98.661911,148.551483 
	C103.884377,154.078552 108.352142,159.466125 109.572845,166.786285 
	C109.653297,167.268692 110.524033,167.619324 111.027176,168.031235 
	C105.617401,169.683319 100.207619,171.335419 94.399841,172.998779 
z"/>
    <path fill="#BBADFE" opacity="1.000000" stroke="none"
      d="
M111.422005,168.013550 
	C110.524033,167.619324 109.653297,167.268692 109.572845,166.786285 
	C108.352142,159.466125 103.884377,154.078552 99.037384,148.548462 
	C104.705772,147.139816 110.424301,146.055191 116.568268,144.985092 
	C119.480286,151.178085 121.966858,157.356552 124.725769,163.766602 
	C124.526215,164.322998 124.054337,164.647797 123.284164,165.011810 
	C119.262863,166.032654 115.539848,167.014252 111.422005,168.013550 
z"/>
    <path fill="#FDFEFF" opacity="1.000000" stroke="none"
      d="
M166.357574,362.636322 
	C166.905243,364.394257 167.308060,365.803070 167.724670,367.260193 
	C158.976547,367.512238 151.495697,356.141022 152.268799,343.341370 
	C158.927521,348.554932 163.504410,354.705322 166.357574,362.636322 
z"/>
    <path fill="#BDB2FF" opacity="1.000000" stroke="none"
      d="
M491.002441,99.005310 
	C496.807007,109.616951 502.931061,120.068748 508.338684,130.878937 
	C515.824890,145.844406 519.974976,161.916565 521.926514,178.475357 
	C523.067993,188.160889 524.137085,197.974258 523.831543,207.685867 
	C523.219299,227.147369 519.587524,246.163284 512.247314,264.314728 
	C511.421539,266.356873 509.759460,268.060791 508.137268,269.544403 
	C509.157776,258.045990 510.362549,246.901428 511.940857,235.810013 
	C513.505371,224.815125 510.116913,217.116806 499.061218,213.881500 
	C499.248962,202.684036 500.228821,191.611237 498.727844,180.885620 
	C495.271729,156.188889 486.168793,133.505341 471.006592,113.463654 
	C467.637390,109.010193 464.332214,104.508301 461.458801,100.020378 
	C465.950775,99.674965 469.981476,99.337868 474.477539,99.000687 
	C479.627625,98.997826 484.312408,98.995041 489.330933,98.995117 
	C490.109711,98.995605 490.554688,98.993248 491.000153,98.994797 
	C491.000641,98.998703 491.002441,99.005318 491.002441,99.005310 
z"/>
    <path fill="#2E008C" opacity="1.000000" stroke="none"
      d="
M448.462860,363.353912 
	C430.484283,377.527618 411.087585,388.454651 389.371765,395.439026 
	C387.888062,386.510529 386.659485,378.006042 385.695862,369.471649 
	C384.361328,357.652283 383.226044,345.810364 382.392273,334.031860 
	C384.320435,333.453888 385.861755,332.822205 387.533203,332.137207 
	C386.884918,330.185577 386.393799,328.707062 386.021057,326.973389 
	C386.423157,326.480438 386.706848,326.242645 387.392181,325.889038 
	C388.045105,325.652954 388.296387,325.532654 388.516052,325.528870 
	C388.484436,325.645325 388.276398,325.767731 388.273712,326.059296 
	C388.542419,326.620728 388.813782,326.890594 389.311279,327.355255 
	C390.309082,328.618042 391.080750,329.686005 391.979919,331.076569 
	C393.397369,332.935699 394.687347,334.472260 396.128113,336.305786 
	C400.357605,340.729248 403.995636,345.457428 408.617401,348.842560 
	C415.723053,354.047028 423.504272,358.329163 431.245300,363.278503 
	C435.523621,365.385986 438.988281,365.672180 442.667389,362.064117 
	C449.466614,355.396210 456.793335,349.266174 463.952881,343.255188 
	C464.729034,344.429962 465.452576,345.261597 466.176147,346.093262 
	C460.345581,351.756775 454.515045,357.420258 448.462860,363.353912 
z"/>
    <path fill="#230470" opacity="1.000000" stroke="none"
      d="
M466.461670,345.926270 
	C465.452576,345.261597 464.729034,344.429962 464.099121,342.978241 
	C464.507874,341.592529 464.822968,340.826874 465.423340,339.898071 
	C468.491150,336.454041 471.520905,333.350281 474.017426,329.864594 
	C495.685272,299.611664 506.654846,266.071045 505.119507,228.636841 
	C504.978027,225.187439 503.733704,223.545731 500.795990,222.399719 
	C483.485138,215.646790 465.405975,212.949585 446.987671,212.035461 
	C447.000183,212.015869 447.019653,211.973663 447.010010,211.598877 
	C447.681671,210.139252 448.363007,209.054398 449.503662,207.898590 
	C458.899872,208.459000 467.836792,209.090347 477.141998,209.837570 
	C484.582397,211.356918 491.654449,212.760391 498.726532,214.163879 
	C510.116913,217.116806 513.505371,224.815125 511.940857,235.810013 
	C510.362549,246.901428 509.157776,258.045990 507.774353,269.584412 
	C502.389954,289.498871 494.990967,308.128113 483.261322,324.734375 
	C478.126556,332.003998 472.273895,338.766510 466.461670,345.926270 
z"/>
    <path fill="#BFB8FF" opacity="1.000000" stroke="none"
      d="
M456.885071,85.722260 
	C472.226166,79.785789 487.940582,77.396263 504.626740,80.908424 
	C506.073181,83.827332 507.291077,86.528770 508.201385,89.330154 
	C510.585480,96.667137 508.893066,98.997520 501.369110,99.000916 
	C500.544312,99.001282 499.719482,98.997551 498.445251,98.562241 
	C497.984650,88.191704 493.732025,83.963142 483.784607,83.997948 
	C473.998108,84.032188 468.012726,89.714325 467.542572,98.982010 
	C462.720886,98.987144 458.364716,98.985428 454.005493,98.569626 
	C454.963318,94.011124 455.924194,89.866692 456.885071,85.722260 
z"/>
    <path fill="#C3C7FF" opacity="1.000000" stroke="none"
      d="
M468.008087,98.975166 
	C468.012726,89.714325 473.998108,84.032188 483.784607,83.997948 
	C493.732025,83.963142 497.984650,88.191704 497.991638,98.557106 
	C495.950317,98.989868 493.913177,98.994263 491.439240,99.001984 
	C491.002441,99.005318 491.000641,98.998703 490.852234,98.774231 
	C490.134918,98.697258 489.566040,98.844757 488.997162,98.992264 
	C484.312408,98.995041 479.627625,98.997826 474.048035,98.998215 
	C471.438141,98.988945 469.723114,98.982056 468.008087,98.975166 
z"/>
    <path fill="#BFB8FF" opacity="1.000000" stroke="none"
      d="
M499.061218,213.881500 
	C491.654449,212.760391 484.582397,211.356918 477.202972,209.319977 
	C476.558136,199.568024 477.103760,190.312943 475.718567,181.356491 
	C471.461884,153.833389 458.872314,130.475800 438.107544,111.828018 
	C434.727936,108.792915 429.998199,107.261169 425.892548,105.034531 
	C425.951050,103.964577 426.009552,102.894638 426.105347,101.531158 
	C426.142609,101.237617 426.453491,101.037697 427.087494,101.008797 
	C429.814850,100.987473 431.908234,100.995056 434.464844,101.002243 
	C439.288422,100.671082 443.648743,100.340317 448.380768,100.005249 
	C449.495819,99.999695 450.239227,99.998444 451.438477,99.999481 
	C454.928741,100.010735 457.963165,100.019714 460.997559,100.028702 
	C464.332214,104.508301 467.637390,109.010193 471.006592,113.463654 
	C486.168793,133.505341 495.271729,156.188889 498.727844,180.885620 
	C500.228821,191.611237 499.248962,202.684036 499.061218,213.881500 
z"/>
    <path fill="#B8A2FF" opacity="1.000000" stroke="none"
      d="
M434.001587,101.002640 
	C431.908234,100.995056 429.814850,100.987473 427.265259,100.958328 
	C436.587708,95.920815 446.366364,90.904861 456.515076,85.805588 
	C455.924194,89.866692 454.963318,94.011124 453.665771,98.576088 
	C452.546936,99.330147 451.764771,99.663666 450.982605,99.997192 
	C450.239227,99.998444 449.495819,99.999695 447.916443,100.001442 
	C442.720825,100.335503 438.361206,100.669075 434.001587,101.002640 
z"/>
    <path fill="#34239B" opacity="1.000000" stroke="none"
      d="
M218.192429,496.391296 
	C218.259033,496.019165 218.494675,496.060303 218.722900,496.410187 
	C220.589615,499.179413 222.228119,501.598755 223.935242,504.381958 
	C230.576233,518.390686 233.048767,532.908447 233.091125,548.345032 
	C232.420654,555.297363 231.855377,561.825867 231.214233,569.230347 
	C227.631683,566.731445 224.852524,564.792908 221.959595,562.640625 
	C221.634399,562.171753 221.373383,561.986450 220.911163,561.575928 
	C218.222366,558.855347 215.685181,556.429749 213.147995,554.004150 
	C213.921036,547.574585 214.701035,541.145752 215.462265,534.714844 
	C215.653030,533.103271 215.783508,531.484497 215.880463,529.436279 
	C216.499039,524.612427 217.178802,520.221436 217.835327,515.416382 
	C217.872665,509.978271 217.933243,504.954193 217.927292,499.467560 
	C217.949112,498.257812 218.037460,497.510620 218.192429,496.391296 
z"/>
    <path fill="#B5AEFF" opacity="1.000000" stroke="none"
      d="
M226.899506,498.222412 
	C224.167557,496.152557 221.435608,494.082703 218.357910,492.000610 
	C217.672043,490.267731 217.331924,488.547058 217.281372,486.273254 
	C218.435135,484.715332 219.299347,483.710602 220.163574,482.705872 
	C222.935425,483.226471 225.707260,483.747101 228.753998,484.911377 
	C228.319092,489.777496 227.609299,493.999939 226.899506,498.222412 
z"/>
    <path fill="#34239B" opacity="1.000000" stroke="none"
      d="
M196.334534,493.844299 
	C195.987411,493.231476 195.931839,492.464081 195.745148,491.334595 
	C195.758499,488.512482 195.622787,485.986664 196.177444,483.622864 
	C196.418732,482.594604 198.078217,481.899109 199.507690,480.974060 
	C202.003555,482.292206 204.085327,483.688782 206.496841,485.179565 
	C203.426422,488.079071 200.026260,490.884369 196.334534,493.844299 
z"/>
    <path fill="#A4D3EB" opacity="1.000000" stroke="none"
      d="
M219.868011,482.490570 
	C219.299347,483.710602 218.435135,484.715332 217.284576,485.885315 
	C214.620621,485.360260 212.242996,484.669983 209.473068,483.983307 
	C207.443710,482.574707 205.806656,481.162476 204.073364,479.384949 
	C203.977127,479.019684 204.125992,478.842499 204.125992,478.842499 
	C209.274811,479.986755 214.423645,481.131012 219.868011,482.490570 
z"/>
    <path fill="#3D01AB" opacity="1.000000" stroke="none"
      d="
M308.002258,404.988281 
	C297.831360,403.232635 287.660431,401.476990 277.216797,399.065063 
	C275.632172,389.000427 274.230743,379.603394 273.040161,370.179718 
	C272.260956,364.012177 271.787109,357.806030 271.555969,351.781677 
	C272.995148,351.033325 275.072571,349.486176 274.959351,349.304535 
	C273.626587,347.166382 275.484344,342.188354 269.990967,343.054596 
	C269.579681,341.864471 269.178772,341.097595 269.080658,340.293762 
	C267.681122,328.827057 266.381500,317.347900 264.938202,305.886841 
	C263.330414,293.119629 261.932251,280.309021 259.688721,267.650970 
	C259.135193,264.528046 261.151062,259.978485 256.520081,257.671295 
	C256.399231,256.882416 256.286133,256.439606 256.537109,255.943298 
	C257.807251,255.517548 258.713226,255.145294 259.822083,255.019775 
	C261.305145,255.129532 262.585358,254.992569 264.250214,254.814453 
	C263.267548,251.570175 262.474487,248.951874 261.582916,246.008270 
	C259.898895,246.535461 258.539734,246.960953 257.134033,246.989838 
	C257.740265,245.050995 258.393036,243.508743 259.484497,241.969727 
	C263.645447,242.710556 267.367676,243.448120 270.712250,244.201126 
	C269.098022,244.512207 267.861450,244.807831 266.676178,245.091202 
	C267.521271,253.891953 267.521271,253.891953 272.120117,252.606155 
	C271.845673,249.878662 271.564850,247.087433 271.787262,244.207520 
	C273.648956,244.151184 275.007385,244.183533 276.304443,244.644196 
	C277.098877,247.890060 273.376709,252.654907 279.762634,253.822845 
	C280.407318,250.784760 280.920197,248.367691 281.814941,245.958649 
	C283.469788,246.013443 284.742737,246.060196 285.959717,246.472412 
	C285.208069,249.299271 284.512390,251.760666 283.742859,254.483536 
	C285.327271,255.035461 286.520966,255.451279 288.038147,256.112305 
	C289.573242,264.307831 290.859406,272.247711 291.978973,280.211029 
	C293.650482,292.100586 295.316956,303.992950 296.766479,315.910797 
	C297.639343,323.087616 298.096649,330.314972 298.384216,337.484314 
	C296.801270,337.704498 295.574799,337.960052 293.649445,338.361206 
	C296.289734,341.058899 292.023376,346.578827 298.910034,346.849579 
	C299.882599,348.201019 300.756104,349.391022 300.950714,350.683258 
	C302.321594,359.786469 303.629242,368.900879 304.806854,378.031067 
	C305.964294,387.004883 306.944366,396.001617 308.002258,404.988281 
M277.967865,344.763763 
	C278.502045,346.437958 279.036194,348.112152 279.567780,349.778229 
	C283.906219,348.440063 283.981659,347.873840 279.783142,340.009644 
	C279.124146,341.350433 278.465118,342.691193 277.967865,344.763763 
M287.234924,347.226074 
	C288.484955,347.026276 290.825287,346.795746 290.820648,346.631317 
	C290.756104,344.341187 290.624573,341.974976 289.905518,339.829742 
	C289.695740,339.203888 287.587708,339.214294 285.621216,338.767548 
	C286.194916,341.931061 286.601715,344.174133 287.234924,347.226074 
z"/>
    <path fill="#4001B2" opacity="1.000000" stroke="none"
      d="
M256.527832,258.017365 
	C261.151062,259.978485 259.135193,264.528046 259.688721,267.650970 
	C261.932251,280.309021 263.330414,293.119629 264.938202,305.886841 
	C266.381500,317.347900 267.681122,328.827057 269.080658,340.293762 
	C269.178772,341.097595 269.579681,341.864471 269.735870,343.271973 
	C270.146820,346.469360 270.661652,349.043274 271.176483,351.617188 
	C271.787109,357.806030 272.260956,364.012177 273.040161,370.179718 
	C274.230743,379.603394 275.632172,389.000427 276.920074,398.844604 
	C272.864471,398.165588 268.832855,397.050781 264.156799,395.680603 
	C257.676788,392.904114 251.841263,390.382996 246.002579,387.447327 
	C244.667786,376.846405 243.336136,366.660004 242.297272,356.263184 
	C244.522034,354.425568 246.453995,352.798431 248.227493,351.304749 
	C246.492126,346.398987 244.257065,348.314301 241.905640,349.804871 
	C241.521179,348.402130 241.264908,347.315399 241.278137,345.984924 
	C244.103043,343.157959 243.705292,341.537018 239.988785,340.602905 
	C239.471069,339.385315 238.965134,338.558563 238.681519,337.420959 
	C238.847275,335.916779 238.790680,334.723511 238.798737,333.126038 
	C238.133774,331.435516 237.404129,330.149200 236.683502,328.652649 
	C236.613464,328.168579 236.599503,327.891418 236.826233,327.225464 
	C236.999466,323.952545 237.399765,320.994385 236.907486,318.193085 
	C235.996368,313.008392 234.562851,307.915466 233.327789,302.491516 
	C233.353378,301.434387 233.398132,300.670105 233.578430,299.431610 
	C233.812622,297.648041 233.911301,296.338684 234.046341,294.715118 
	C233.665817,293.117096 233.248932,291.833221 232.878571,290.069214 
	C232.977524,288.625702 233.029968,287.662292 233.447052,286.733795 
	C234.944061,285.794708 236.076431,284.820740 237.540634,283.561371 
	C234.906662,282.305084 233.454956,281.612671 232.002441,280.502258 
	C232.027359,278.970123 232.053085,277.855957 232.442993,276.820312 
	C235.337784,277.323639 238.949753,282.035919 239.879395,275.081879 
	C237.267822,273.742188 234.805618,272.479126 232.018951,270.978607 
	C230.879227,267.254822 229.415375,263.774139 229.385040,260.280975 
	C229.323669,253.216690 225.043335,245.965820 230.468796,239.049896 
	C237.637253,239.378159 244.360687,239.579102 251.055679,240.127518 
	C253.751175,240.348312 256.384277,241.330704 259.045776,241.966492 
	C258.393036,243.508743 257.740265,245.050995 257.114990,247.336182 
	C257.968048,250.310425 258.793640,252.541733 259.619232,254.773041 
	C258.713226,255.145294 257.807251,255.517548 256.305206,255.684601 
	C254.617294,253.713486 253.525406,251.947586 252.394073,250.117874 
	C251.371841,250.659988 250.811325,251.002426 250.214798,251.262283 
	C249.440460,251.599625 248.637497,251.871277 248.197449,252.038208 
	C252.657928,259.892731 252.657928,259.892731 256.527832,258.017365 
M235.359650,267.155609 
	C237.629257,268.737305 239.898865,270.319000 242.113235,271.862183 
	C246.782745,267.401001 241.802460,266.529968 239.972549,264.752655 
	C237.439301,262.292175 235.960403,263.644531 235.359650,267.155609 
M245.042221,256.571411 
	C243.650909,257.296112 242.259598,258.020844 240.409225,258.984680 
	C243.087997,261.458221 245.102615,263.318481 247.206329,265.261017 
	C248.493500,264.369415 249.513321,263.663025 250.712967,262.832062 
	C248.584747,260.446564 247.068710,258.747223 245.042221,256.571411 
M245.117828,361.131958 
	C246.179413,362.374359 247.240997,363.616760 248.356842,364.922668 
	C250.323349,363.732361 252.099533,362.657227 254.089035,361.453003 
	C252.834717,359.561584 251.854065,358.082855 250.604660,356.198822 
	C248.559341,357.753052 246.821365,359.073761 245.117828,361.131958 
M261.105865,348.510925 
	C264.465576,356.265717 264.738281,356.433624 268.060364,353.447845 
	C267.018341,351.053436 265.934723,348.563446 264.682709,345.686493 
	C263.292145,346.507599 262.223389,347.138702 261.105865,348.510925 
M256.518097,358.003723 
	C257.893707,358.003723 259.269318,358.003723 261.366730,358.003723 
	C259.482910,354.494812 258.256775,352.210907 256.827148,349.548004 
	C255.349930,350.446442 254.223434,351.131561 253.012421,351.868103 
	C254.192734,353.971222 255.154160,355.684357 256.518097,358.003723 
z"/>
    <path fill="#3902A3" opacity="1.000000" stroke="none"
      d="
M308.400513,405.112732 
	C306.944366,396.001617 305.964294,387.004883 304.806854,378.031067 
	C303.629242,368.900879 302.321594,359.786469 300.950714,350.683258 
	C300.756104,349.391022 299.882599,348.201019 299.137573,346.476318 
	C298.881470,343.165833 298.811096,340.342743 298.740692,337.519623 
	C298.096649,330.314972 297.639343,323.087616 296.766479,315.910797 
	C295.316956,303.992950 293.650482,292.100586 291.978973,280.211029 
	C290.859406,272.247711 289.573242,264.307831 288.146362,255.766174 
	C288.957153,252.790283 289.983215,250.405716 291.308289,248.144669 
	C292.735901,248.805725 293.864471,249.343262 294.738373,250.118805 
	C293.646973,252.114182 292.643280,253.817108 292.044983,255.652191 
	C291.752411,256.549500 291.882294,258.289642 292.412506,258.584412 
	C293.202362,259.023529 295.162994,258.906342 295.493134,258.351807 
	C296.847260,256.076996 297.772675,253.546982 299.261078,251.069153 
	C306.443695,253.690384 313.221039,256.353333 319.997864,259.420898 
	C319.611877,263.565277 319.226410,267.304993 318.569122,270.870361 
	C313.532501,267.295105 312.933807,273.328491 309.961060,274.775604 
	C311.606079,275.816254 313.229309,276.160492 314.706329,275.837067 
	C316.084839,275.535217 317.308075,274.524109 318.975708,273.903412 
	C319.902557,274.993683 320.453278,276.005737 320.783508,277.293152 
	C318.756622,279.620972 312.574341,279.021790 316.025848,284.669617 
	C318.114075,283.954773 319.826630,283.368561 321.881989,283.013611 
	C322.517944,284.286194 322.811096,285.327545 322.835144,286.587219 
	C320.032867,287.962097 315.783234,288.246979 319.452545,292.668976 
	C321.022980,292.263733 322.439453,291.898224 323.897980,291.943756 
	C324.396973,293.286133 324.853943,294.217407 325.026062,295.382507 
	C323.343903,296.036713 321.946625,296.457123 320.537140,296.881226 
	C320.183472,300.713562 321.988007,301.386261 324.979187,301.058411 
	C325.040558,302.552094 325.090454,303.547485 324.800842,304.674561 
	C323.648224,305.549835 322.835114,306.293396 322.021973,307.036957 
	C323.016113,307.834625 324.010223,308.632324 325.004150,309.811279 
	C325.000427,311.209412 324.996857,312.226257 324.682068,313.365936 
	C323.769501,314.459991 323.168182,315.431183 322.566833,316.402405 
	C323.712494,317.013672 324.858185,317.624939 326.003082,318.617737 
	C326.000977,320.016693 325.999664,321.034149 325.599426,322.111023 
	C324.141113,322.961365 323.081665,323.752197 322.022247,324.543060 
	C322.957092,325.342590 323.791901,326.336975 324.856628,326.883575 
	C325.807373,327.371704 327.011932,327.365417 328.077026,327.994354 
	C328.034943,329.525726 328.020294,330.640015 327.618225,331.750458 
	C324.576630,331.581390 320.752808,328.588318 320.306091,334.833862 
	C323.316589,335.531647 326.124329,336.182434 328.951965,337.274811 
	C331.983459,360.402344 334.995117,383.088287 338.006775,405.774231 
	C328.270752,405.595215 318.534760,405.416199 308.400513,405.112732 
M323.840454,340.381836 
	C322.605896,340.142578 321.371307,339.903320 318.502563,339.347351 
	C319.782684,342.472443 320.475372,344.706451 321.701324,346.594086 
	C321.893982,346.890808 324.996246,346.027191 325.876312,344.970093 
	C327.072418,343.533325 327.972198,341.217102 323.840454,340.381836 
M307.630920,342.339905 
	C307.433289,336.578430 307.433289,336.578430 303.380737,337.753693 
	C303.380737,340.435944 303.380737,343.033600 303.380737,345.631256 
	C303.832672,345.918854 304.284607,346.206451 304.736542,346.494080 
	C305.705414,345.392975 306.674255,344.291901 307.630920,342.339905 
M312.560577,266.244812 
	C312.256073,264.692078 311.951569,263.139343 311.647095,261.586609 
	C311.119385,261.646179 310.591644,261.705719 310.063934,261.765289 
	C309.330688,264.621674 302.257782,265.068634 307.174377,270.659119 
	C309.020844,269.158783 310.529236,267.933136 312.560577,266.244812 
M305.420166,256.183594 
	C300.864441,253.963974 301.528625,259.303589 299.356995,260.585632 
	C299.087128,260.744934 300.106995,263.088898 300.529266,264.420532 
	C301.246796,264.451843 301.964355,264.483124 302.681885,264.514404 
	C303.764221,261.894379 304.846558,259.274353 305.420166,256.183594 
M315.905273,343.174225 
	C316.129639,336.871002 316.129639,336.871002 311.816071,337.698975 
	C311.684235,340.244812 311.550781,342.821381 311.323547,347.209167 
	C313.586487,345.628082 314.718506,344.837158 315.905273,343.174225 
z"/>
    <path fill="#35009A" opacity="1.000000" stroke="none"
      d="
M338.432556,405.829651 
	C334.995117,383.088287 331.983459,360.402344 328.991760,336.933380 
	C328.676331,334.685028 328.341003,333.219666 328.005676,331.754333 
	C328.020294,330.640015 328.034943,329.525726 328.455017,327.992920 
	C329.797882,326.332306 330.735260,325.090179 332.062012,323.332153 
	C329.191010,322.725830 327.594696,322.388702 325.998352,322.051575 
	C325.999664,321.034149 326.000977,320.016693 326.426239,318.559937 
	C328.304840,318.054932 329.759521,317.989258 331.637054,317.904510 
	C331.546753,316.255432 331.472382,314.897339 331.381805,313.243103 
	C328.938812,313.243103 326.966064,313.243103 324.993317,313.243103 
	C324.996857,312.226257 325.000427,311.209412 325.428192,309.698181 
	C327.443542,309.046478 329.034668,308.889130 330.974243,308.697357 
	C330.893616,307.094208 330.825317,305.735962 330.740112,304.042297 
	C328.627441,304.231140 326.883911,304.386993 325.140381,304.542847 
	C325.090454,303.547485 325.040558,302.552094 325.298798,300.902466 
	C326.976746,299.923157 328.346588,299.598145 329.586548,299.303925 
	C329.899048,295.617645 328.438019,294.414734 325.310913,295.148712 
	C324.853943,294.217407 324.396973,293.286133 324.198792,291.763184 
	C325.255249,290.096344 326.052948,289.021088 326.850647,287.945862 
	C325.601837,287.420197 324.353058,286.894531 323.104248,286.368896 
	C322.811096,285.327545 322.517944,284.286194 322.117310,282.771606 
	C325.563812,279.797394 322.715271,278.515900 321.004028,277.017792 
	C320.453278,276.005737 319.902557,274.993683 319.123108,273.568237 
	C318.876617,272.451508 318.858795,271.748108 318.840942,271.044739 
	C319.226410,267.304993 319.611877,263.565277 320.349792,259.457794 
	C324.112976,260.744904 327.523651,262.399719 331.107544,264.347290 
	C338.205200,270.085724 345.129669,275.531403 351.655762,280.991333 
	C347.492828,281.323914 347.911591,283.855865 348.282562,286.475220 
	C349.552704,295.442993 350.828674,304.410797 351.983826,313.393829 
	C353.770447,327.287567 355.448639,341.195221 357.192596,355.094482 
	C359.182373,370.953186 361.193817,386.809174 363.195862,402.666321 
	C355.083344,403.739258 346.970856,404.812164 338.432556,405.829651 
z"/>
    <path fill="#320194" opacity="1.000000" stroke="none"
      d="
M363.621582,402.628052 
	C361.193817,386.809174 359.182373,370.953186 357.192596,355.094482 
	C355.448639,341.195221 353.770447,327.287567 351.983826,313.393829 
	C350.828674,304.410797 349.552704,295.442993 348.282562,286.475220 
	C347.911591,283.855865 347.492828,281.323914 351.950256,281.142883 
	C357.149689,286.208862 361.656311,291.137604 366.138672,296.461243 
	C366.303711,298.772858 365.693024,301.264893 369.134766,301.203979 
	C369.844055,302.311371 370.452332,303.129517 370.735779,304.105072 
	C369.355591,304.606873 368.300262,304.951263 367.445282,305.230286 
	C368.092010,310.374939 371.167603,309.031708 374.192810,308.459961 
	C374.578186,309.506104 374.823303,310.278015 374.907867,311.370728 
	C373.188568,312.455475 371.629822,313.219452 369.902649,314.065979 
	C370.827637,315.504364 371.592743,316.694122 372.340271,317.856537 
	C374.971954,316.852020 377.387268,315.930084 379.851349,315.386475 
	C379.957703,316.525330 380.015289,317.285828 379.910370,318.371368 
	C373.971893,321.472626 373.826874,321.840515 377.090759,325.813324 
	C379.300385,324.507690 381.532715,323.188660 384.043884,322.047913 
	C385.211975,323.485748 386.101257,324.745300 386.990540,326.004822 
	C386.706848,326.242645 386.423157,326.480438 385.660522,326.918396 
	C383.340302,327.971039 381.499054,328.823486 379.429871,329.781464 
	C380.501312,331.527252 381.253387,332.752686 382.005432,333.978119 
	C383.226044,345.810364 384.361328,357.652283 385.695862,369.471649 
	C386.659485,378.006042 387.888062,386.510529 389.000732,395.443359 
	C387.225006,396.543945 385.446991,397.229523 383.338013,398.057556 
	C376.687134,399.663269 370.367218,401.126526 363.621582,402.628052 
z"/>
    <path fill="#B5AEFF" opacity="1.000000" stroke="none"
      d="
M246.005737,387.861877 
	C251.841263,390.382996 257.676788,392.904114 263.767456,395.669495 
	C267.286011,398.742645 270.254395,402.036713 273.861084,404.324341 
	C295.926422,418.319550 319.871155,427.854034 345.656952,433.862732 
	C346.004578,434.022430 345.995392,434.418549 345.982727,434.614990 
	C345.808136,434.864532 345.646179,434.917633 345.238770,435.042053 
	C333.633423,435.725189 322.273499,436.337067 310.383118,436.556946 
	C306.506958,434.470215 303.241608,432.588562 299.802887,431.110138 
	C271.590271,418.980438 247.087463,401.383057 224.956955,380.322052 
	C223.529465,378.963562 223.023361,376.636932 222.427811,374.854919 
	C230.513245,379.253418 238.259491,383.557648 246.005737,387.861877 
z"/>
    <path fill="#B8A2FF" opacity="1.000000" stroke="none"
      d="
M187.985184,145.352463 
	C194.146698,146.928452 200.235275,148.841431 206.606964,151.318024 
	C205.929184,157.886795 204.268066,163.876083 204.131699,169.899902 
	C203.611694,192.872238 203.220444,215.887787 209.789017,238.476028 
	C202.350769,241.181366 195.179230,243.654083 187.756989,246.068512 
	C187.335266,245.996307 187.164246,245.982361 186.993210,245.968414 
	C185.572418,237.524261 184.111832,229.086563 182.739212,220.634583 
	C179.974136,203.608353 178.810699,186.523361 180.914642,169.316711 
	C181.374512,165.555771 182.009903,161.752670 181.863068,157.996414 
	C181.653641,152.639267 184.069962,148.891586 187.985184,145.352463 
z"/>
    <path fill="#4A02C4" opacity="1.000000" stroke="none"
      d="
M186.767609,246.241333 
	C187.164246,245.982361 187.335266,245.996307 187.787766,246.385498 
	C188.387543,247.545242 188.705841,248.329742 188.782593,249.363052 
	C181.544510,252.740356 174.547958,255.868835 167.551422,258.997314 
	C167.640869,259.435211 167.730316,259.873108 167.819778,260.311005 
	C170.548264,260.617249 173.276733,260.923492 176.005829,261.640198 
	C177.006866,269.745850 177.973724,277.445618 179.015579,285.135223 
	C180.589432,296.751373 182.394989,308.339508 183.750046,319.980530 
	C184.523453,326.624756 184.598709,333.350281 184.704193,339.888000 
	C183.292496,338.459747 182.164917,337.182617 181.037338,335.905518 
	C167.697922,317.267578 157.767731,297.037140 152.268082,273.922211 
	C152.764938,270.525360 153.423080,267.868042 154.369904,265.043640 
	C156.435760,263.185455 158.212921,261.494446 160.306427,259.708832 
	C163.276520,257.821655 165.930283,256.029083 168.584030,254.236465 
	C174.570023,251.662399 180.556030,249.088333 186.767609,246.241333 
z"/>
    <path fill="#B9AAFE" opacity="1.000000" stroke="none"
      d="
M168.223755,254.035492 
	C165.930283,256.029083 163.276520,257.821655 160.298950,259.329010 
	C156.658493,240.560776 152.520569,222.175278 150.311066,203.560867 
	C148.813416,190.943497 150.026505,178.004578 150.023453,165.209457 
	C150.022797,162.475327 150.005707,159.741211 149.996185,157.007080 
	C159.074112,154.423157 159.171814,154.425262 158.972763,163.671188 
	C158.755234,173.774857 157.700562,183.901382 158.134949,193.969452 
	C158.961502,213.127472 161.406494,232.131073 166.422119,250.713928 
	C166.716431,251.804367 167.374619,252.796600 168.223755,254.035492 
z"/>
    <path fill="#B6B2FF" opacity="1.000000" stroke="none"
      d="
M149.632004,157.045990 
	C150.005707,159.741211 150.022797,162.475327 150.023453,165.209457 
	C150.026505,178.004578 148.813416,190.943497 150.311066,203.560867 
	C152.520569,222.175278 156.658493,240.560776 159.982605,259.423584 
	C158.212921,261.494446 156.435760,263.185455 154.310287,264.648682 
	C146.217514,240.321243 143.190460,215.428802 142.129227,190.297470 
	C141.690216,179.901627 142.660004,169.446304 142.989090,159.018021 
	C145.082001,158.373642 147.174911,157.729279 149.632004,157.045990 
z"/>
    <path fill="#B5BFFF" opacity="1.000000" stroke="none"
      d="
M142.623718,159.056519 
	C142.660004,169.446304 141.690216,179.901627 142.129227,190.297470 
	C143.190460,215.428802 146.217514,240.321243 154.021606,264.815796 
	C153.423080,267.868042 152.764938,270.525360 152.085358,273.590698 
	C151.127243,272.796173 149.664825,271.722107 149.334702,270.371338 
	C145.798477,255.901810 141.214432,241.544449 139.346741,226.847656 
	C137.033157,208.642288 137.004791,190.145996 136.007828,171.774368 
	C135.837448,168.634567 135.760147,165.489700 135.310181,162.162048 
	C137.406479,161.016296 139.832428,160.055649 142.623718,159.056519 
z"/>
    <path fill="#DDC6FF" opacity="1.000000" stroke="none"
      d="
M306.003052,494.815125 
	C299.867249,494.108093 293.731445,493.401031 287.258911,492.496185 
	C286.457489,489.888794 286.026306,487.472168 285.522125,485.070831 
	C283.697632,476.381042 281.848633,467.696381 280.015778,458.592529 
	C285.392670,458.506805 290.762665,458.838348 296.577454,459.678131 
	C297.560516,463.572601 297.789429,467.044434 298.697937,470.328247 
	C300.968628,478.536011 303.547729,486.658447 306.003052,494.815125 
z"/>
    <path fill="#FAF7FF" opacity="1.000000" stroke="none"
      d="
M362.787384,444.049042 
	C370.839020,441.311707 379.000854,439.613251 387.623840,439.920990 
	C397.353333,440.268219 398.705505,440.649414 400.390930,450.048126 
	C402.280914,460.587585 400.699371,470.618866 392.781219,478.687195 
	C384.701355,486.920410 372.288300,486.916534 363.570740,479.141998 
	C356.989288,473.272461 352.969452,466.079620 351.326141,457.025574 
	C354.335144,455.358795 357.082367,454.270233 359.810059,453.134705 
	C364.301147,451.265106 365.217773,448.199280 362.787384,444.049042 
z"/>
    <path fill="#ECDFFF" opacity="1.000000" stroke="none"
      d="
M351.990845,497.629883 
	C343.632690,497.634247 335.272736,497.273834 326.449951,496.477448 
	C324.881317,493.467743 323.555450,490.964050 322.709412,488.307526 
	C319.718719,478.917084 316.892273,469.474335 314.003540,460.051422 
	C315.696350,459.977234 317.389160,459.903076 319.952087,459.860992 
	C324.890472,459.702454 328.958771,459.511841 333.027069,459.321228 
	C334.867981,471.615692 340.027802,482.343231 348.160919,491.713654 
	C349.625244,493.400726 350.722382,495.406464 351.990845,497.629883 
z"/>
    <path fill="#9F90CE" opacity="1.000000" stroke="none"
      d="
M333.459167,459.232208 
	C328.958771,459.511841 324.890472,459.702454 320.370178,459.797729 
	C320.281250,455.941559 320.834656,452.186096 320.941833,448.417999 
	C321.015961,445.811432 322.086853,445.261932 324.505951,444.926605 
	C333.093140,443.736420 341.635864,442.217804 350.179657,440.732819 
	C351.096436,440.573486 351.910095,439.820679 353.021423,439.008057 
	C355.301208,439.680939 357.331146,440.688965 359.685455,441.795227 
	C360.756927,442.531616 361.504028,443.169739 362.519287,443.928467 
	C365.217773,448.199280 364.301147,451.265106 359.810059,453.134705 
	C357.082367,454.270233 354.335144,455.358795 351.281525,456.633179 
	C345.274689,457.579651 339.582977,458.361420 333.459167,459.232208 
z"/>
    <path fill="#FDFEFF" opacity="1.000000" stroke="none"
      d="
M411.762909,486.277100 
	C418.045624,486.680145 424.092712,487.351685 430.790771,488.292969 
	C434.601776,489.962799 437.761749,491.362885 440.921722,492.762939 
	C427.295227,494.330109 413.668762,495.897278 399.583649,497.490326 
	C399.588715,492.120514 403.612335,488.561340 411.762909,486.277100 
z"/>
    <path fill="#B5BFFF" opacity="1.000000" stroke="none"
      d="
M181.028839,336.286438 
	C182.164917,337.182617 183.292496,338.459747 184.817200,340.202332 
	C194.512222,351.918701 204.762070,362.157684 217.043549,370.685608 
	C218.849716,372.210663 220.469162,373.485657 222.088623,374.760651 
	C223.023361,376.636932 223.529465,378.963562 224.956955,380.322052 
	C247.087463,401.383057 271.590271,418.980438 299.802887,431.110138 
	C303.241608,432.588562 306.506958,434.470215 309.916534,436.500671 
	C301.943024,436.537964 293.905609,436.239532 285.424377,435.881653 
	C283.287964,434.364655 281.790680,432.547577 279.872406,431.505737 
	C262.347748,421.988281 246.046570,410.798340 231.013626,397.632080 
	C212.307846,381.248993 196.226746,362.721436 183.129456,341.603027 
	C182.197266,340.099915 181.712921,338.319031 181.028839,336.286438 
z"/>
    <path fill="#FAF7FF" opacity="1.000000" stroke="none"
      d="
M182.093445,648.434875 
	C185.842896,639.111877 189.558899,630.209534 193.274902,621.307190 
	C193.859924,621.507812 194.444962,621.708435 195.029984,621.909058 
	C193.080048,629.541260 191.085770,637.162537 189.194244,644.809265 
	C187.691376,650.884766 186.314224,656.991394 184.837341,663.494385 
	C183.744293,666.962708 182.695145,670.020813 181.502747,673.496521 
	C178.432404,664.875000 180.985916,656.883972 182.093445,648.434875 
z"/>
    <path fill="#725ED0" opacity="1.000000" stroke="none"
      d="
M212.866226,553.992371 
	C215.685181,556.429749 218.222366,558.855347 220.756363,561.934570 
	C219.470886,567.285278 218.384232,572.048279 216.829727,576.653442 
	C215.957657,579.236877 214.311523,581.559082 213.014130,583.998962 
	C211.989258,579.894653 210.964386,575.790283 209.900894,571.252930 
	C210.566467,565.514282 211.270660,560.208557 211.999420,554.473389 
	C212.210815,554.022827 212.397644,554.001709 212.866226,553.992371 
z"/>
    <path fill="#C1BFFF" opacity="1.000000" stroke="none"
      d="
M425.886353,105.381302 
	C429.998199,107.261169 434.727936,108.792915 438.107544,111.828018 
	C458.872314,130.475800 471.461884,153.833389 475.718567,181.356491 
	C477.103760,190.312943 476.558136,199.568024 476.834656,209.204102 
	C467.836792,209.090347 458.899872,208.459000 449.456238,207.755096 
	C448.949493,207.682556 448.882477,207.387619 448.915710,206.937836 
	C451.418121,174.388489 439.495544,148.917801 413.751038,129.576309 
	C413.952026,128.910141 414.055298,128.526154 414.428741,127.954857 
	C415.859741,125.898399 417.020569,124.029243 418.442871,121.967278 
	C419.228058,120.601913 419.751770,119.429375 420.491943,118.062149 
	C420.888153,117.319656 421.067902,116.771851 421.477692,116.017700 
	C421.826660,115.216560 421.945618,114.621773 422.039001,114.010635 
	C422.013458,113.994270 422.024292,114.053970 422.322754,113.912514 
	C423.030182,112.547020 423.439209,111.322983 423.848236,110.098953 
	C424.525543,108.641991 425.202850,107.185036 425.886353,105.381302 
z"/>
    <path fill="#BAAAFF" opacity="1.000000" stroke="none"
      d="
M210.055740,238.243423 
	C203.220444,215.887787 203.611694,192.872238 204.131699,169.899902 
	C204.268066,163.876083 205.929184,157.886795 206.947601,151.491455 
	C214.378189,152.743729 221.751251,154.386200 229.538727,155.978149 
	C230.406509,155.943710 230.859894,155.959793 231.653107,155.966019 
	C232.409256,155.982697 232.825531,156.009247 233.616165,156.353714 
	C234.666107,157.173721 235.341705,157.675827 235.999237,158.576660 
	C234.987671,166.969070 233.239197,174.957779 233.186310,182.957672 
	C233.115662,193.645538 233.999176,204.382797 235.195786,215.017502 
	C235.781372,220.221939 237.999954,225.242615 239.155334,230.560226 
	C229.239410,233.263794 219.647568,235.753616 210.055740,238.243423 
z"/>
    <path fill="#9886FF" opacity="1.000000" stroke="none"
      d="
M252.012573,159.885132 
	C253.976593,157.773834 255.584274,155.054840 257.967041,153.657669 
	C267.660278,147.973892 277.919952,143.206146 287.349670,137.135849 
	C298.688446,129.836609 311.049438,125.202301 323.727142,121.296867 
	C337.804352,116.960327 352.202759,113.960167 366.966309,112.974358 
	C375.380524,112.412521 383.780823,111.167603 392.190063,111.142601 
	C400.262573,111.118607 408.335083,112.323944 416.415985,112.863907 
	C418.019165,112.971024 419.660309,112.510475 421.652222,112.497124 
	C422.021759,113.139687 422.023041,113.596832 422.024292,114.053970 
	C422.024292,114.053970 422.013458,113.994270 421.796631,114.007568 
	C421.579834,114.020866 421.096283,113.987656 420.824127,114.145966 
	C420.370758,114.889748 420.189545,115.475212 420.000519,116.029068 
	C419.992706,115.997475 420.056793,115.986046 419.780853,116.137733 
	C419.339294,116.879570 419.173706,117.469727 419.001221,118.029121 
	C418.994293,117.998360 419.057129,117.993126 418.806702,118.078171 
	C418.375092,118.453773 418.193878,118.744339 418.015503,119.013885 
	C418.018311,118.992851 418.044495,119.026459 417.699188,119.022217 
	C415.553406,120.676231 413.752930,122.334496 411.532471,123.983406 
	C409.159668,123.649628 407.214569,123.102715 405.252808,123.034721 
	C381.954773,122.227196 358.971252,123.653290 336.275513,129.944031 
	C314.622589,135.945740 294.556702,144.969864 275.988434,157.467239 
	C273.785126,158.950180 271.999817,161.054199 269.615936,162.853668 
	C263.478271,161.853043 257.745422,160.869095 252.012573,159.885132 
z"/>
    <path fill="#725CFF" opacity="1.000000" stroke="none"
      d="
M251.621384,159.876831 
	C257.745422,160.869095 263.478271,161.853043 270.043396,162.892258 
	C279.256439,163.916946 287.637146,164.886368 296.479401,165.895767 
	C311.634125,165.958084 326.327362,165.980453 340.811584,166.352692 
	C332.445831,167.263626 324.289062,167.824661 315.667786,168.275436 
	C301.805389,167.174179 288.407501,166.183197 274.587646,165.124344 
	C261.449585,162.763626 248.733444,160.470764 236.017303,158.177917 
	C235.341705,157.675827 234.666107,157.173721 233.928650,156.337677 
	C239.654587,157.291977 245.442383,158.580246 251.621384,159.876831 
z"/>
    <path fill="#725CFF" opacity="1.000000" stroke="none"
      d="
M422.322754,113.912514 
	C422.023041,113.596832 422.021759,113.139687 422.020874,112.339645 
	C422.432831,111.384987 422.844360,110.773232 423.552063,110.130211 
	C423.439209,111.322983 423.030182,112.547020 422.322754,113.912514 
z"/>
    <path fill="#B9AAFE" opacity="1.000000" stroke="none"
      d="
M409.922821,681.997681 
	C406.346741,692.307922 402.770691,702.618103 398.919739,713.091064 
	C380.532074,714.060608 363.510162,709.345032 346.423157,703.006836 
	C344.333466,691.260925 342.627869,679.522461 341.201965,667.555786 
	C357.833923,680.320435 376.695496,684.691284 397.154419,683.412537 
	C401.423370,683.145630 405.667328,682.479675 409.922821,681.997681 
z"/>
    <path fill="#FAF7FF" opacity="1.000000" stroke="none"
      d="
M195.526474,619.553650 
	C195.477371,619.585144 195.575577,619.522156 195.526474,619.553650 
z"/>
    <path fill="#E6D6FF" opacity="1.000000" stroke="none"
      d="
M313.541687,459.990051 
	C316.892273,469.474335 319.718719,478.917084 322.709412,488.307526 
	C323.555450,490.964050 324.881317,493.467743 325.996338,496.401764 
	C319.625244,496.164886 313.244965,495.567749 306.433868,494.892883 
	C303.547729,486.658447 300.968628,478.536011 298.697937,470.328247 
	C297.789429,467.044434 297.560516,463.572601 297.031982,459.790771 
	C302.387726,459.573029 307.733765,459.750854 313.541687,459.990051 
z"/>
    <path fill="#9B96E6" opacity="1.000000" stroke="none"
      d="
M462.792450,461.732178 
	C461.731384,463.185181 460.469421,464.372803 459.061218,465.864990 
	C456.810425,464.909729 454.705841,463.649933 452.076477,462.169800 
	C451.272980,461.759857 451.076111,461.506622 450.961121,461.189789 
	C452.422363,460.118469 453.883606,459.047150 455.734589,457.957458 
	C458.280090,459.115021 460.435822,460.290924 462.792450,461.732178 
z"/>
    <path fill="#A8A1EF" opacity="1.000000" stroke="none"
      d="
M550.418213,373.886932 
	C557.933655,371.673737 565.103882,369.516937 572.288818,367.410461 
	C573.214355,367.139130 574.216370,367.128510 575.545166,367.386414 
	C574.939880,372.184631 573.972351,376.593536 573.004883,381.002441 
	C567.823975,383.157257 562.643066,385.312073 556.814026,387.736511 
	C544.052246,389.337433 531.945251,390.737122 519.817871,391.928284 
	C517.935852,392.113129 515.960144,391.343903 514.027771,391.015839 
	C519.332397,387.962708 524.637024,384.909576 530.038147,381.535004 
	C536.782288,378.795349 543.429871,376.377106 550.418213,373.886932 
z"/>
    <path fill="#9B96E6" opacity="1.000000" stroke="none"
      d="
M513.701172,391.141418 
	C515.960144,391.343903 517.935852,392.113129 519.817871,391.928284 
	C531.945251,390.737122 544.052246,389.337433 556.587280,388.009705 
	C559.834473,391.324280 559.392883,393.330872 554.922791,394.595062 
	C545.081116,397.378418 535.326721,400.470154 525.270142,403.717834 
	C517.084717,403.680573 509.163116,403.411774 501.250427,402.980133 
	C500.237671,402.924927 499.271179,402.022217 498.112244,401.154388 
	C503.085693,397.620117 508.230164,394.443573 513.701172,391.141418 
z"/>
    <path fill="#AE98FF" opacity="1.000000" stroke="none"
      d="
M573.384399,380.958557 
	C573.972351,376.593536 574.939880,372.184631 575.955444,367.382019 
	C580.098267,365.760986 584.192993,364.533691 588.642700,363.151978 
	C594.445435,362.122223 599.929016,361.421051 605.329895,360.316010 
	C609.598267,359.442657 612.113220,360.357269 612.006592,365.594971 
	C611.680664,369.054535 611.349121,372.106659 611.005127,375.568542 
	C608.885803,377.950806 606.778992,379.923279 604.334839,381.947327 
	C604.404968,378.953308 604.812317,375.907684 605.413086,371.416168 
	C594.071960,374.819855 583.917908,377.867249 573.384399,380.958557 
z"/>
    <path fill="#B6B2FF" opacity="1.000000" stroke="none"
      d="
M235.404205,655.216553 
	C235.341339,653.887207 235.574615,652.725952 235.833603,650.815002 
	C235.932388,648.713379 236.005463,647.361389 236.421234,646.051270 
	C240.036224,650.782104 243.312073,655.468689 246.579926,660.160828 
	C250.723099,666.109741 254.859787,672.063171 259.042603,678.331787 
	C259.719879,679.098572 260.353851,679.548218 261.232819,680.167847 
	C261.652557,680.895203 261.827271,681.452454 262.038391,682.358398 
	C262.371490,683.289612 262.587372,683.933716 262.976685,684.445923 
	C273.307739,698.036682 284.781586,710.516724 298.196320,721.171204 
	C301.062286,723.447388 303.411530,726.374329 305.649170,728.964844 
	C300.410095,725.330505 295.586700,721.637695 290.604950,718.172729 
	C287.857239,716.261414 284.843781,714.732300 281.654175,712.872681 
	C277.915466,709.494751 274.472656,706.275085 271.019409,702.666931 
	C270.517151,700.959961 270.346100,699.362854 269.481812,698.367981 
	C263.578369,691.572571 257.554962,684.880432 251.516586,678.203552 
	C248.398117,674.755432 245.169647,671.406677 241.990875,668.013062 
	C239.894028,663.803589 237.797195,659.594055 235.404205,655.216553 
z"/>
    <path fill="#D4E3FF" opacity="1.000000" stroke="none"
      d="
M271.029785,703.055420 
	C274.472656,706.275085 277.915466,709.494751 281.809814,713.170715 
	C289.171570,721.751892 296.081848,729.876831 303.138855,738.303101 
	C308.181641,744.071960 313.077728,749.539368 317.973816,755.006836 
	C321.242554,759.369934 324.511292,763.733032 327.780029,768.096069 
	C312.125641,759.871765 301.024780,746.956787 290.139709,732.878174 
	C285.166168,725.584045 280.600220,718.795715 275.896545,711.690613 
	C274.182495,708.601074 272.606140,705.828247 271.029785,703.055420 
z"/>
    <path fill="#B5BFFF" opacity="1.000000" stroke="none"
      d="
M271.019379,702.666931 
	C272.606140,705.828247 274.182495,708.601074 275.527496,711.684082 
	C273.683990,710.982849 271.863983,710.194519 270.496429,708.920471 
	C265.251099,704.033936 260.150909,698.991577 254.996582,694.007324 
	C250.688477,685.585754 246.380371,677.164246 242.031586,668.377869 
	C245.169647,671.406677 248.398117,674.755432 251.516586,678.203552 
	C257.554962,684.880432 263.578369,691.572571 269.481812,698.367981 
	C270.346100,699.362854 270.517151,700.959961 271.019379,702.666931 
z"/>
    <path fill="#B6CAFF" opacity="1.000000" stroke="none"
      d="
M255.034988,694.365967 
	C260.150909,698.991577 265.251099,704.033936 270.496429,708.920471 
	C271.863983,710.194519 273.683990,710.982849 275.665222,712.000793 
	C280.600220,718.795715 285.166168,725.584045 289.871277,732.684448 
	C285.424438,729.908081 280.628204,727.086792 276.295258,723.676819 
	C266.573151,716.025696 259.986389,705.960938 255.034988,694.365967 
z"/>
    <path fill="#B6CAFF" opacity="1.000000" stroke="none"
      d="
M318.354736,755.009521 
	C313.077728,749.539368 308.181641,744.071960 303.511047,738.307373 
	C306.351318,739.361328 308.929688,740.789185 311.587555,742.049316 
	C320.061951,746.066956 328.565857,750.022217 337.058380,754.001587 
	C336.446960,756.117737 335.835541,758.233887 335.036804,760.666199 
	C329.478210,758.992310 324.106964,757.002319 318.354736,755.009521 
z"/>
    <path fill="#C0BEFF" opacity="1.000000" stroke="none"
      d="
M452.040283,579.893433 
	C450.694061,585.323730 449.347839,590.753967 447.984375,596.574341 
	C444.697693,605.934753 441.410156,614.898560 438.168793,623.878967 
	C437.051697,626.973816 436.049744,630.110168 434.975372,633.611694 
	C432.283142,640.562439 429.635345,647.139221 426.921753,653.688782 
	C426.203888,655.421509 425.283173,657.070190 424.455566,658.757385 
	C423.919098,658.534119 423.382599,658.310791 422.846100,658.087463 
	C427.873260,643.605286 432.900391,629.123047 437.870209,614.239380 
	C437.812866,613.837830 437.897125,613.869995 438.210754,613.726013 
	C439.333618,610.706360 440.142883,607.830688 440.952179,604.955017 
	C440.952179,604.955017 440.988373,605.008972 441.295135,604.841675 
	C442.047241,603.099548 442.492584,601.524719 442.937927,599.949890 
	C442.937927,599.949890 442.997162,599.999146 443.246918,599.798340 
	C443.649902,598.718201 443.803162,597.838806 443.956421,596.959473 
	C443.956421,596.959473 443.996063,597.003601 444.234924,596.837708 
	C444.626068,596.096802 444.778320,595.521851 444.930573,594.946838 
	C444.930573,594.946838 444.999390,594.994812 445.245422,594.792969 
	C445.641296,593.711975 445.791138,592.832886 445.940979,591.953735 
	C445.940979,591.953735 445.997498,592.000183 446.248749,591.799255 
	C446.652527,590.719849 446.805084,589.841370 446.957642,588.962891 
	C446.957611,588.962891 446.996887,589.003601 447.236877,588.837402 
	C447.628540,588.096191 447.780182,587.521240 447.931824,586.946228 
	C447.931824,586.946228 447.999603,586.993225 448.244812,586.791992 
	C448.642242,585.713013 448.794464,584.835327 448.946716,583.957581 
	C448.946686,583.957581 448.998779,583.999756 449.251221,583.800476 
	C449.659637,582.726013 449.815613,581.850769 449.971588,580.975586 
	C449.971588,580.975586 449.994629,581.002441 450.257294,580.898132 
	C451.026733,580.493713 451.533539,580.193542 452.040283,579.893433 
z"/>
    <path fill="#BAB9FC" opacity="1.000000" stroke="none"
      d="
M465.017029,534.026855 
	C461.764771,543.659119 458.159210,553.114014 454.146271,562.480835 
	C452.877838,560.229248 452.016754,558.065735 451.155701,555.902161 
	C450.550995,555.577515 449.946289,555.252869 449.341583,554.928223 
	C447.566101,557.288696 445.790649,559.649231 443.982361,561.700317 
	C443.595795,560.917847 443.242035,560.444885 442.934296,559.584106 
	C443.519470,557.451050 444.095612,555.716187 444.591766,553.958679 
	C447.826538,542.499329 446.390137,531.870056 438.675446,522.510986 
	C436.697113,520.110962 434.253296,518.094727 431.957581,515.568237 
	C431.015015,514.526001 430.112274,513.847290 429.266113,513.104187 
	C426.144897,510.363007 423.042389,507.600555 420.194092,504.603210 
	C424.930817,503.216827 429.406342,502.073242 434.288757,500.945557 
	C439.462982,499.975098 444.230286,498.988770 448.997559,498.002441 
	C452.381714,505.446808 455.826599,512.864380 459.127106,520.345642 
	C461.090057,524.795105 462.825836,529.344788 465.017029,534.026855 
z"/>
    <path fill="#C2C3FF" opacity="1.000000" stroke="none"
      d="
M449.245117,497.729248 
	C444.230286,498.988770 439.462982,499.975098 434.365326,500.641937 
	C434.400970,499.639862 434.766968,498.957245 435.125946,498.287781 
	C420.836487,499.643036 406.691833,500.946045 392.557251,502.350281 
	C388.671326,502.736328 384.815430,503.424957 380.482666,503.977722 
	C361.520569,503.653107 343.019196,503.414612 324.524658,502.919586 
	C321.003479,502.825378 317.509430,501.716797 314.001801,500.712952 
	C313.997162,499.624695 313.993591,498.899750 313.990021,498.174774 
	C331.735229,499.094604 349.503204,501.057983 367.219910,500.671295 
	C389.591156,500.183044 411.920624,497.778992 434.684143,496.214783 
	C441.531403,495.597443 447.968597,495.020172 454.391052,494.309814 
	C456.995331,494.021759 459.567535,493.443787 462.577179,492.998871 
	C458.497559,494.485352 453.995117,495.970703 449.245117,497.729248 
z"/>
    <path fill="#C2C3FF" opacity="1.000000" stroke="none"
      d="
M463.294617,492.998688 
	C463.611877,492.674042 464.223724,492.348022 464.835602,492.022034 
	C464.921600,492.252747 465.007629,492.483459 465.093658,492.714172 
	C464.592163,492.808563 464.090698,492.902954 463.294617,492.998688 
z"/>
    <path fill="#BBADFE" opacity="1.000000" stroke="none"
      d="
M313.559601,498.101746 
	C313.993591,498.899750 313.997162,499.624695 313.547974,500.694946 
	C300.957764,499.383728 288.820343,497.727234 275.466003,495.904663 
	C281.107635,497.846313 285.569946,499.382111 290.022705,501.343567 
	C289.012207,506.281464 288.122833,510.821838 286.989624,515.300537 
	C283.486816,529.144287 284.052155,543.277100 283.850616,557.358765 
	C275.313507,547.781555 266.776428,538.204346 258.418640,528.150024 
	C259.055542,526.834290 259.758331,526.043701 259.933044,525.149841 
	C261.823181,515.480225 263.707977,505.807587 265.369232,496.097321 
	C265.596100,494.771179 264.594421,493.234802 264.161530,491.795776 
	C275.742035,493.324646 287.319733,494.875031 298.904358,496.372040 
	C303.638275,496.983765 308.387115,497.479950 313.559601,498.101746 
z"/>
    <path fill="#B7A0FF" opacity="1.000000" stroke="none"
      d="
M264.136810,491.812012 
	C264.594421,493.234802 265.596100,494.771179 265.369232,496.097321 
	C263.707977,505.807587 261.823181,515.480225 259.933044,525.149841 
	C259.758331,526.043701 259.055542,526.834290 258.258484,527.856445 
	C247.692825,518.283875 237.466644,508.527618 227.069992,498.496887 
	C227.609299,493.999939 228.319092,489.777496 229.069305,485.107483 
	C239.821884,486.739868 250.534073,488.819794 261.821228,491.229889 
	C262.957336,491.665955 263.518494,491.771851 264.079651,491.877716 
	C264.079651,491.877716 264.112091,491.828217 264.136810,491.812012 
z"/>
    <path fill="#E6D6FF" opacity="1.000000" stroke="none"
      d="
M450.616882,461.092346 
	C451.076111,461.506622 451.272980,461.759857 451.759003,462.081177 
	C451.311432,471.485992 450.656555,480.759064 450.003174,490.467590 
	C447.235504,491.535614 444.466400,492.168213 441.309509,492.781860 
	C437.761749,491.362885 434.601776,489.962799 431.210266,488.301880 
	C431.981415,476.445618 432.984070,464.850159 433.971283,452.813385 
	C439.394745,455.246338 444.833679,458.120636 450.616882,461.092346 
z"/>
    <path fill="#BBADFE" opacity="1.000000" stroke="none"
      d="
M263.930328,491.617004 
	C263.518494,491.771851 262.957336,491.665955 262.211700,491.333740 
	C262.611816,491.190399 263.196411,491.273346 263.930328,491.617004 
z"/>
    <path fill="#A4D3EB" opacity="1.000000" stroke="none"
      d="
M203.900787,479.106689 
	C203.409241,478.986572 202.994034,478.779480 202.578827,478.572388 
	C202.987869,478.536774 203.396912,478.501160 203.965973,478.654022 
	C204.125992,478.842499 203.977127,479.019684 203.900787,479.106689 
z"/>
    <path fill="#BEB5FF" opacity="1.000000" stroke="none"
      d="
M283.945740,557.665527 
	C284.052155,543.277100 283.486816,529.144287 286.989624,515.300537 
	C288.122833,510.821838 289.012207,506.281464 290.444519,501.358948 
	C298.581238,502.307861 306.286560,503.667175 313.993286,505.426636 
	C313.608154,507.599152 313.484985,509.482056 312.794525,511.126770 
	C305.518555,528.459412 304.508698,546.479187 306.974121,564.825378 
	C310.611664,591.894165 321.765961,615.117493 342.686310,633.174744 
	C364.684753,652.162598 394.135803,658.385193 420.645264,640.690796 
	C421.938629,639.827454 423.639923,639.575195 425.151245,639.038330 
	C420.203033,653.147400 415.254852,667.256409 410.114746,681.681519 
	C405.667328,682.479675 401.423370,683.145630 397.154419,683.412537 
	C376.695496,684.691284 357.833923,680.320435 341.195129,667.136902 
	C340.908600,666.946167 340.819672,666.662598 340.884644,666.129700 
	C340.609253,664.712280 340.268860,663.827820 339.928436,662.943298 
	C339.928436,662.943298 339.814270,662.674377 339.880310,662.146118 
	C339.602570,660.753479 339.258759,659.889099 338.914978,659.024780 
	C338.914978,659.024780 338.987579,658.999084 338.985291,658.629272 
	C338.290009,656.185791 337.597046,654.112000 336.904083,652.038269 
	C336.904083,652.038269 336.987579,651.995789 336.978882,651.682373 
	C336.615906,650.590820 336.261566,649.812744 335.907257,649.034607 
	C335.907257,649.034607 335.988953,648.999329 335.980713,648.684143 
	C335.617096,647.592285 335.261658,646.815552 334.906250,646.038879 
	C334.906250,646.038879 334.988403,645.993958 334.981201,645.631836 
	C333.951569,642.863281 332.929108,640.456787 331.906647,638.050293 
	C331.906647,638.050293 331.960693,637.984253 331.968719,637.645020 
	C331.288055,635.887024 330.599396,634.468323 329.910706,633.049561 
	C329.910706,633.049561 329.969299,632.987305 329.973175,632.635986 
	C328.954010,630.208069 327.930939,628.131348 326.907898,626.054688 
	C326.907898,626.054688 326.953613,625.998108 326.959137,625.637695 
	C326.191803,622.945190 325.766205,620.413269 324.566101,618.326843 
	C322.680908,615.049255 320.273621,612.072021 318.087402,608.967590 
	C318.087433,608.967590 317.925751,608.649963 317.929352,608.133667 
	C317.595673,607.093201 317.258362,606.569092 316.921082,606.044983 
	C316.921082,606.044983 316.996857,606.024536 316.981812,605.668335 
	C315.954865,603.897156 314.942963,602.482056 313.931061,601.067017 
	C313.931061,601.067017 313.984680,601.053040 313.961548,600.743408 
	C313.599274,599.971558 313.260162,599.509399 312.921021,599.047241 
	C312.921021,599.047241 312.997833,599.018127 312.981567,598.677124 
	C312.290833,597.577759 311.616364,596.819275 310.941864,596.060852 
	C310.941864,596.060852 310.994141,596.039185 310.967773,595.733582 
	C310.601715,594.967957 310.262024,594.507996 309.922363,594.047974 
	C309.922363,594.047974 310.000000,594.002441 309.965515,593.720459 
	C309.590240,592.977112 309.249451,592.515869 308.908630,592.054565 
	C308.908630,592.054565 308.954559,591.988037 308.855865,591.793945 
	C308.486816,591.416077 308.216492,591.232239 307.946136,591.048401 
	C307.946136,591.048401 307.982666,590.996582 307.960388,590.714355 
	C307.597809,589.971130 307.257507,589.510132 306.917206,589.049194 
	C306.917206,589.049194 306.971954,588.989197 306.867371,588.793701 
	C306.571136,588.301758 306.302734,588.116272 305.957581,588.041809 
	C305.957581,588.041809 305.982819,587.997253 305.960083,587.690918 
	C305.279785,586.602722 304.622162,585.820801 303.964569,585.038879 
	C303.964569,585.038879 303.994568,585.005249 303.970337,584.709717 
	C303.604462,583.958496 303.262817,583.502686 302.921204,583.046936 
	C302.921204,583.046936 302.976288,582.989990 302.872955,582.794556 
	C302.583191,582.303589 302.319916,582.115540 301.979828,582.034973 
	C301.979828,582.034973 301.988800,582.006165 301.968323,581.707092 
	C301.605438,580.954285 301.263031,580.500488 300.920624,580.046753 
	C300.920624,580.046753 300.976898,579.990601 300.871521,579.794373 
	C300.575104,579.302551 300.307892,579.116211 299.964478,579.039185 
	C299.964478,579.039185 300.000000,579.000488 299.897583,578.795288 
	C299.623169,578.307129 299.378845,578.116943 299.062286,578.019592 
	C299.062286,578.019592 298.987640,578.003723 298.968170,577.662109 
	C298.560059,576.902100 298.171417,576.483643 297.782806,576.065186 
	C293.202179,570.034241 288.621552,564.003235 283.945740,557.665527 
z"/>
    <path fill="#AE98FF" opacity="1.000000" stroke="none"
      d="
M343.789459,700.001038 
	C343.096436,712.484375 342.403442,724.967651 341.182129,737.748047 
	C340.435516,738.030090 340.217133,738.015076 339.945679,737.654968 
	C338.437012,736.290100 337.065613,735.113098 335.509949,734.280334 
	C330.966736,731.848145 326.189056,729.819519 321.789642,727.159119 
	C301.831665,715.090027 285.218231,699.155762 270.180664,681.528809 
	C266.360413,677.050720 263.371094,671.863708 260.346466,667.038086 
	C261.392822,667.493835 262.224518,667.786316 262.772827,668.352966 
	C270.596619,676.439087 278.214569,684.733154 286.247772,692.604004 
	C290.244019,696.519409 294.851715,699.867126 299.466827,703.061401 
	C300.919525,704.066833 303.295685,703.738037 305.249176,704.019958 
	C304.867126,701.901550 304.705170,699.711670 304.046295,697.683167 
	C303.255920,695.249756 301.184082,692.960632 301.165771,690.597351 
	C301.100403,682.156128 301.786652,673.712036 301.928680,665.264648 
	C301.972046,662.685059 300.998779,660.103149 300.831787,657.500427 
	C300.715729,655.691284 300.740845,653.642883 301.469269,652.052368 
	C303.783875,646.998352 307.566711,642.346069 304.306641,636.254883 
	C303.952728,635.593750 304.462769,634.326538 304.828979,633.447449 
	C306.842743,628.613281 308.936493,623.812317 311.279846,619.207458 
	C317.382355,633.161133 323.536346,646.779968 328.931488,660.692993 
	C333.421295,672.271423 337.019775,684.195374 341.138123,696.279297 
	C342.105286,697.728516 342.947357,698.864807 343.789459,700.001038 
z"/>
    <path fill="#9D81FF" opacity="1.000000" stroke="none"
      d="
M273.312347,548.862549 
	C273.604675,549.025146 273.842224,549.246521 273.811157,549.879333 
	C273.591248,551.571045 273.122345,553.148804 273.666656,554.203857 
	C275.236725,557.247437 277.215332,560.080261 278.686279,563.048523 
	C275.764069,566.698730 272.865479,570.111816 270.686066,573.934937 
	C266.934784,580.515320 263.561554,587.316284 260.175537,594.097473 
	C258.872314,596.707520 257.961487,599.514221 256.882751,602.235596 
	C255.248184,606.359375 253.586304,610.472839 252.006882,614.617676 
	C250.944473,617.405762 250.004379,620.240479 249.009552,623.054382 
	C248.390259,623.101990 247.770966,623.149658 247.151672,623.197327 
	C245.375259,620.336426 243.787598,617.330933 241.749023,614.670959 
	C240.592819,613.162292 238.697495,612.220154 237.100800,610.568604 
	C237.037994,607.076233 237.009445,604.038147 236.995117,600.531860 
	C237.027679,594.047913 237.046021,588.031982 237.425659,581.931458 
	C238.703369,579.279663 239.211716,576.459900 240.614227,574.193604 
	C244.525162,567.873596 248.585098,561.618347 253.014816,555.655884 
	C256.340027,551.180176 260.328674,547.197388 264.265289,542.997925 
	C264.508667,543.000732 264.995789,543.013550 264.998932,543.006775 
	C265.002075,543.000000 264.988251,543.000061 265.099243,543.221008 
	C265.412689,543.717468 265.676575,543.907776 266.001587,544.005859 
	C266.001221,543.998718 265.987030,543.998108 266.097046,544.220520 
	C266.408112,544.722290 266.673157,544.912354 267.001648,545.005249 
	C267.001007,544.997559 266.986237,545.002014 267.105408,545.271484 
	C267.816711,546.032043 268.408844,546.523193 269.001099,547.006836 
	C269.001221,546.999329 268.987183,546.993408 269.009277,547.298706 
	C269.374268,548.074951 269.717194,548.546021 270.465363,549.012939 
	C271.684509,548.960083 272.498444,548.911316 273.312347,548.862549 
z"/>
    <path fill="#9479FF" opacity="1.000000" stroke="none"
      d="
M264.021912,542.995117 
	C260.328674,547.197388 256.340027,551.180176 253.014816,555.655884 
	C248.585098,561.618347 244.525162,567.873596 240.614227,574.193604 
	C239.211716,576.459900 238.703369,579.279663 237.396881,581.465820 
	C236.650330,573.834351 236.532822,566.560913 235.840744,559.342529 
	C235.471024,555.486328 234.109970,551.725220 233.196320,547.921204 
	C233.048767,532.908447 230.576233,518.390686 224.245087,504.250244 
	C225.021393,503.053131 225.556503,502.351624 226.091614,501.650085 
	C226.255203,501.726715 226.418808,501.803314 226.882477,502.191711 
	C227.318542,502.702820 227.494019,502.857300 227.708984,502.966949 
	C239.737045,514.794434 251.765091,526.621887 263.638336,538.743774 
	C262.918915,539.116333 262.354279,539.194458 261.946838,539.250854 
	C262.694855,540.600586 263.358368,541.797852 264.021912,542.995117 
z"/>
    <path fill="#B5AEFF" opacity="1.000000" stroke="none"
      d="
M339.998779,738.000000 
	C340.217133,738.015076 340.435516,738.030090 340.981506,738.088501 
	C340.750397,740.967285 340.191711,743.802673 339.164673,746.637573 
	C336.126923,745.590576 333.473267,744.710815 331.005402,743.463501 
	C325.619720,740.741455 320.328552,737.832581 314.956055,734.679993 
	C314.273834,733.908264 313.634308,733.456543 312.663330,732.974487 
	C311.220062,732.296997 310.108215,731.649902 308.954590,730.682495 
	C308.273468,729.909729 307.634064,729.457275 306.745667,729.004517 
	C306.496704,729.004150 305.998779,729.001465 305.998779,729.001465 
	C303.411530,726.374329 301.062286,723.447388 298.196320,721.171204 
	C284.781586,710.516724 273.307739,698.036682 262.976685,684.445923 
	C262.587372,683.933716 262.371490,683.289612 262.382874,682.390930 
	C266.048279,685.447021 269.204102,689.053528 272.801453,692.146545 
	C282.821167,700.761597 292.789093,709.466064 303.218658,717.567322 
	C314.377319,726.234985 326.596161,733.246582 339.998779,738.000000 
z"/>
    <path fill="#B5BFFF" opacity="1.000000" stroke="none"
      d="
M314.998779,735.000000 
	C320.328552,737.832581 325.619720,740.741455 331.005402,743.463501 
	C333.473267,744.710815 336.126923,745.590576 338.932281,746.945190 
	C338.571228,749.291199 337.974213,751.329102 337.217804,753.684326 
	C328.565857,750.022217 320.061951,746.066956 311.587555,742.049316 
	C308.929688,740.789185 306.351318,739.361328 303.364349,738.005981 
	C296.081848,729.876831 289.171570,721.751892 282.105682,713.328979 
	C284.843781,714.732300 287.857239,716.261414 290.604950,718.172729 
	C295.586700,721.637695 300.410095,725.330505 305.649170,728.964844 
	C305.998779,729.001465 306.496704,729.004150 306.789734,729.323669 
	C307.720612,730.096436 308.358490,730.549622 308.996338,731.002869 
	C310.108215,731.649902 311.220062,732.296997 312.707489,733.293701 
	C313.721619,734.095520 314.360199,734.547791 314.998779,735.000000 
z"/>
    <path fill="#B0A2FD" opacity="1.000000" stroke="none"
      d="
M343.837402,699.573425 
	C342.947357,698.864807 342.105286,697.728516 341.423523,696.015381 
	C341.244751,691.697021 341.236542,687.890442 340.513763,684.224670 
	C335.082184,656.676941 325.096619,630.773132 311.818726,605.714661 
	C309.450928,601.272095 307.201965,597.153809 305.087128,592.928589 
	C305.221222,592.821655 305.490753,592.609558 305.490753,592.609558 
	C311.960327,604.171326 319.010406,615.452515 324.765289,627.359741 
	C333.697174,645.840393 339.547760,665.410522 342.410797,685.795959 
	C343.033234,690.227539 343.400543,694.694946 343.837402,699.573425 
z"/>
    <path fill="#B7A0FF" opacity="1.000000" stroke="none"
      d="
M279.033508,562.995850 
	C277.215332,560.080261 275.236725,557.247437 273.666656,554.203857 
	C273.122345,553.148804 273.591248,551.571045 273.921265,550.098511 
	C274.759949,550.444092 275.274750,550.923218 275.906799,551.967834 
	C276.383392,553.003906 276.742706,553.474426 277.102020,553.944946 
	C277.102020,553.944946 277.043762,554.005005 277.142822,554.203064 
	C277.521149,554.584167 277.800446,554.767273 278.079742,554.950317 
	C278.079742,554.950317 278.011444,554.996155 278.122375,555.200439 
	C278.513275,555.591309 278.793213,555.777954 279.073120,555.964661 
	C279.073120,555.964661 279.009857,555.995605 279.128235,556.212830 
	C279.550903,556.614990 279.855164,556.799927 280.159454,556.984863 
	C280.458435,557.078064 280.682800,557.262207 280.928223,558.057251 
	C281.384979,559.034363 281.746002,559.491577 282.107025,559.948730 
	C282.107025,559.948730 282.030090,559.912537 282.032867,560.178528 
	C282.029449,560.628113 282.023285,560.811646 282.187134,561.243958 
	C282.923370,561.648132 283.489532,561.803467 284.055695,561.958801 
	C284.055695,561.958801 284.020538,562.006226 284.112305,562.210388 
	C284.392059,562.708496 284.652985,562.906250 284.986786,563.007751 
	C284.986786,563.007751 285.000000,563.000000 285.015991,563.308472 
	C285.389069,564.061462 285.746155,564.505981 286.103210,564.950500 
	C286.103210,564.950500 286.035339,564.997070 286.136414,565.197815 
	C286.515259,565.587402 286.793030,565.776245 287.070801,565.965088 
	C287.070801,565.965088 287.007294,565.995605 287.112061,566.201050 
	C287.485901,566.602722 287.754944,566.799011 288.023987,566.995239 
	C288.024017,566.995239 287.996948,566.999390 287.995972,567.364746 
	C287.999664,568.483582 288.004333,569.237061 287.741516,570.114502 
	C286.977875,570.829346 286.481689,571.420105 285.714722,571.815979 
	C283.307129,568.745972 281.170319,565.870911 279.033508,562.995850 
z"/>
    <path fill="#B9AAFE" opacity="1.000000" stroke="none"
      d="
M318.163879,609.310181 
	C320.273621,612.072021 322.680908,615.049255 324.566101,618.326843 
	C325.766205,620.413269 326.191803,622.945190 326.943420,625.666321 
	C324.028229,620.587769 321.134308,615.120239 318.163879,609.310181 
z"/>
    <path fill="#8A79DF" opacity="1.000000" stroke="none"
      d="
M225.914871,501.389404 
	C225.556503,502.351624 225.021393,503.053131 224.176453,503.886383 
	C222.228119,501.598755 220.589615,499.179413 218.841110,496.428345 
	C221.066772,497.774017 223.402451,499.451355 225.914871,501.389404 
z"/>
    <path fill="#B0A2FD" opacity="1.000000" stroke="none"
      d="
M300.449188,584.639832 
	C302.064240,587.077576 303.679260,589.515381 305.392517,592.281372 
	C305.490753,592.609558 305.221222,592.821655 304.794006,592.763367 
	C302.891327,590.151855 301.415833,587.598572 300.066864,584.943115 
	C300.193420,584.840942 300.449188,584.639832 300.449188,584.639832 
z"/>
    <path fill="#B9AAFE" opacity="1.000000" stroke="none"
      d="
M331.902435,638.427246 
	C332.929108,640.456787 333.951569,642.863281 334.948181,645.664917 
	C333.914307,643.641479 332.906281,641.222839 331.902435,638.427246 
z"/>
    <path fill="#B9AAFE" opacity="1.000000" stroke="none"
      d="
M326.897491,626.420715 
	C327.930939,628.131348 328.954010,630.208069 329.951050,632.670471 
	C328.912384,630.966370 327.899719,628.876587 326.897491,626.420715 
z"/>
    <path fill="#9B8CFF" opacity="1.000000" stroke="none"
      d="
M273.189331,548.558960 
	C272.498444,548.911316 271.684509,548.960083 270.428162,548.710632 
	C269.652893,547.939392 269.320038,547.466431 268.987183,546.993408 
	C268.987183,546.993408 269.001221,546.999329 269.000305,546.678101 
	C268.984375,545.919861 268.969299,545.482727 269.082520,544.934387 
	C269.210754,544.823120 269.467896,544.601257 269.467896,544.601257 
	C270.667358,545.819336 271.866821,547.037354 273.189331,548.558960 
z"/>
    <path fill="#9B8CFF" opacity="1.000000" stroke="none"
      d="
M264.969208,539.900818 
	C266.374603,541.274048 267.779999,542.647217 269.326630,544.310852 
	C269.467896,544.601257 269.210754,544.823120 268.755371,544.920166 
	C267.862061,545.012207 267.424164,545.007141 266.986237,545.002075 
	C266.986237,545.002014 267.001007,544.997559 266.896912,544.778625 
	C266.591614,544.275879 266.322998,544.088684 265.987030,543.998108 
	C265.987030,543.998108 266.001221,543.998718 265.896942,543.779541 
	C265.591980,543.276855 265.323822,543.090027 264.988251,543.000061 
	C264.988251,543.000061 265.002075,543.000000 265.002899,542.618286 
	C264.992218,541.458008 264.980713,540.679443 264.969208,539.900818 
z"/>
    <path fill="#B9AAFE" opacity="1.000000" stroke="none"
      d="
M313.958740,601.405029 
	C314.942963,602.482056 315.954865,603.897156 316.943298,605.684326 
	C315.942017,604.618713 314.964203,603.180908 313.958740,601.405029 
z"/>
    <path fill="#B9AAFE" opacity="1.000000" stroke="none"
      d="
M336.887512,652.424316 
	C337.597046,654.112000 338.290009,656.185791 338.961975,658.659912 
	C338.250977,656.976990 337.560944,654.893677 336.887512,652.424316 
z"/>
    <path fill="#B7A0FF" opacity="1.000000" stroke="none"
      d="
M264.887909,539.704468 
	C264.980713,540.679443 264.992218,541.458008 264.999756,542.625122 
	C264.995789,543.013550 264.508667,543.000732 264.265259,542.997925 
	C263.358368,541.797852 262.694855,540.600586 261.946838,539.250854 
	C262.354279,539.194458 262.918915,539.116333 263.798279,539.045166 
	C264.408203,539.106873 264.639404,539.258850 264.887909,539.704468 
z"/>
    <path fill="#B9AAFE" opacity="1.000000" stroke="none"
      d="
M329.902954,633.405151 
	C330.599396,634.468323 331.288055,635.887024 331.950531,637.682129 
	C331.247955,636.625916 330.571594,635.193298 329.902954,633.405151 
z"/>
    <path fill="#B0A2FD" opacity="1.000000" stroke="none"
      d="
M295.298370,576.898193 
	C295.889923,577.672424 296.481506,578.446594 297.069153,579.582153 
	C297.065216,579.943420 296.903931,580.092590 296.596130,580.020386 
	C295.522064,578.970093 294.755768,577.992065 294.317383,576.992920 
	C294.862976,576.947327 295.080658,576.922791 295.298370,576.898193 
z"/>
    <path fill="#A092FF" opacity="1.000000" stroke="none"
      d="
M288.009003,569.990479 
	C288.004333,569.237061 287.999664,568.483582 288.003479,567.353210 
	C288.671295,567.739014 289.330627,568.501770 290.004974,569.625244 
	C290.019989,569.985962 289.918610,570.104797 289.601440,570.082153 
	C288.859192,570.036438 288.434082,570.013489 288.009003,569.990479 
z"/>
    <path fill="#B0A2FD" opacity="1.000000" stroke="none"
      d="
M298.430328,581.649902 
	C299.034851,582.452759 299.639374,583.255615 300.346558,584.349121 
	C300.449188,584.639832 300.193420,584.840942 299.790283,584.787903 
	C298.904327,583.837769 298.421478,582.940674 298.061279,581.944824 
	C298.183960,581.846130 298.430328,581.649902 298.430328,581.649902 
z"/>
    <path fill="#A092FF" opacity="1.000000" stroke="none"
      d="
M291.036316,570.965576 
	C291.680481,571.740906 292.324646,572.516235 292.990051,573.642944 
	C293.011261,573.994263 292.920746,574.096375 292.588318,574.020264 
	C291.795532,572.994263 291.335205,572.044373 290.915680,571.062744 
	C290.956451,571.031128 291.036285,570.965576 291.036316,570.965576 
z"/>
    <path fill="#B9AAFE" opacity="1.000000" stroke="none"
      d="
M310.972473,596.377319 
	C311.616364,596.819275 312.290833,597.577759 312.942749,598.696533 
	C312.281128,598.269104 311.642120,597.481445 310.972473,596.377319 
z"/>
    <path fill="#B9AAFE" opacity="1.000000" stroke="none"
      d="
M304.002869,585.352051 
	C304.622162,585.820801 305.279785,586.602722 305.941101,587.710999 
	C305.310272,587.246643 304.675720,586.455872 304.002869,585.352051 
z"/>
    <path fill="#B9AAFE" opacity="1.000000" stroke="none"
      d="
M334.884003,646.379272 
	C335.261658,646.815552 335.617096,647.592285 335.949615,648.715942 
	C335.571747,648.281799 335.216736,647.500671 334.884003,646.379272 
z"/>
    <path fill="#B9AAFE" opacity="1.000000" stroke="none"
      d="
M335.892944,649.375732 
	C336.261566,649.812744 336.615906,650.590820 336.946289,651.715942 
	C336.574463,651.280945 336.226562,650.498901 335.892944,649.375732 
z"/>
    <path fill="#B9AAFE" opacity="1.000000" stroke="none"
      d="
M338.907837,659.384094 
	C339.258759,659.889099 339.602570,660.753479 339.911438,662.003357 
	C339.551239,661.507080 339.225952,660.625244 338.907837,659.384094 
z"/>
    <path fill="#B9AAFE" opacity="1.000000" stroke="none"
      d="
M339.932892,663.308960 
	C340.268860,663.827820 340.609253,664.712280 340.915039,665.984253 
	C340.566040,665.472717 340.251709,664.573669 339.932892,663.308960 
z"/>
    <path fill="#B9AAFE" opacity="1.000000" stroke="none"
      d="
M306.900696,589.355225 
	C307.257507,589.510132 307.597809,589.971130 307.936493,590.738159 
	C307.584656,590.583252 307.234406,590.122192 306.900696,589.355225 
z"/>
    <path fill="#B9AAFE" opacity="1.000000" stroke="none"
      d="
M300.920074,580.347229 
	C301.263031,580.500488 301.605438,580.954285 301.953674,581.710754 
	C301.612823,581.558228 301.266174,581.102966 300.920074,580.347229 
z"/>
    <path fill="#B0A2FD" opacity="1.000000" stroke="none"
      d="
M297.146423,579.869446 
	C297.557373,580.241699 297.887085,580.687927 298.323547,581.392029 
	C298.430328,581.649902 298.183960,581.846130 297.830902,581.770935 
	C297.286530,581.161377 297.095215,580.626953 296.903931,580.092590 
	C296.903931,580.092590 297.065216,579.943420 297.146423,579.869446 
z"/>
    <path fill="#B9AAFE" opacity="1.000000" stroke="none"
      d="
M297.865540,576.344238 
	C298.171417,576.483643 298.560059,576.902100 298.974243,577.624512 
	C298.649292,577.493408 298.298798,577.058350 297.865540,576.344238 
z"/>
    <path fill="#A092FF" opacity="1.000000" stroke="none"
      d="
M295.196045,576.618652 
	C295.080658,576.922791 294.862976,576.947327 294.303894,576.671387 
	C293.935089,575.943787 293.907715,575.516602 293.914001,575.063965 
	C293.947693,575.038452 294.014343,574.986389 294.014343,574.986389 
	C294.374146,575.437317 294.733948,575.888245 295.196045,576.618652 
z"/>
    <path fill="#9B8CFF" opacity="1.000000" stroke="none"
      d="
M277.111633,553.633301 
	C276.742706,553.474426 276.383392,553.003906 276.012329,552.215576 
	C276.374146,552.372437 276.747681,552.846985 277.111633,553.633301 
z"/>
    <path fill="#A092FF" opacity="1.000000" stroke="none"
      d="
M286.086182,564.651978 
	C285.746155,564.505981 285.389069,564.061462 285.010559,563.314453 
	C285.349091,563.459167 285.709076,563.906311 286.086182,564.651978 
z"/>
    <path fill="#A092FF" opacity="1.000000" stroke="none"
      d="
M283.996490,561.736389 
	C283.489532,561.803467 282.923370,561.648132 282.504272,561.226013 
	C282.862030,560.936401 283.072662,560.913513 283.283325,560.890564 
	C283.583313,561.012329 283.801300,561.220154 283.996490,561.736389 
z"/>
    <path fill="#B9AAFE" opacity="1.000000" stroke="none"
      d="
M309.914490,594.352173 
	C310.262024,594.507996 310.601715,594.967957 310.940613,595.733276 
	C310.595428,595.577759 310.251007,595.117065 309.914490,594.352173 
z"/>
    <path fill="#B9AAFE" opacity="1.000000" stroke="none"
      d="
M312.912964,599.352417 
	C313.260162,599.509399 313.599274,599.971558 313.936157,600.739868 
	C313.590881,600.583252 313.247864,600.120361 312.912964,599.352417 
z"/>
    <path fill="#B9AAFE" opacity="1.000000" stroke="none"
      d="
M302.919250,583.348633 
	C303.262817,583.502686 303.604462,583.958496 303.949402,584.717896 
	C303.607574,584.564392 303.262421,584.107361 302.919250,583.348633 
z"/>
    <path fill="#9B8CFF" opacity="1.000000" stroke="none"
      d="
M282.097839,559.643311 
	C281.746002,559.491577 281.384979,559.034363 281.002502,558.266663 
	C281.350250,558.416748 281.719452,558.877319 282.097839,559.643311 
z"/>
    <path fill="#B9AAFE" opacity="1.000000" stroke="none"
      d="
M308.872620,592.364014 
	C309.249451,592.515869 309.590240,592.977112 309.927307,593.745117 
	C309.561249,593.592407 309.198944,593.132996 308.872620,592.364014 
z"/>
    <path fill="#B9AAFE" opacity="1.000000" stroke="none"
      d="
M316.913116,606.366821 
	C317.258362,606.569092 317.595673,607.093201 317.913788,607.956116 
	C317.564789,607.759521 317.234985,607.224060 316.913116,606.366821 
z"/>
    <path fill="#8A79DF" opacity="1.000000" stroke="none"
      d="
M227.683807,502.775391 
	C227.494019,502.857300 227.318542,502.702820 227.105316,502.345886 
	C227.310394,502.205292 227.520569,502.337158 227.683807,502.775391 
z"/>
    <path fill="#A092FF" opacity="1.000000" stroke="none"
      d="
M290.073425,569.928955 
	C290.461914,569.976990 290.713776,570.183472 290.959351,570.728516 
	C291.036285,570.965576 290.956451,571.031128 290.718933,570.937317 
	C290.235107,570.642090 290.047485,570.395813 289.918610,570.104797 
	C289.918610,570.104797 290.019989,569.985962 290.073425,569.928955 
z"/>
    <path fill="#A092FF" opacity="1.000000" stroke="none"
      d="
M287.941742,566.749939 
	C287.754944,566.799011 287.485901,566.602722 287.125793,566.168579 
	C287.309662,566.121948 287.584564,566.313293 287.941742,566.749939 
z"/>
    <path fill="#B9AAFE" opacity="1.000000" stroke="none"
      d="
M306.031311,588.291260 
	C306.302734,588.116272 306.571136,588.301758 306.852905,588.831543 
	C306.663696,588.890137 306.384338,588.715393 306.031311,588.291260 
z"/>
    <path fill="#A092FF" opacity="1.000000" stroke="none"
      d="
M286.989258,565.714478 
	C286.793030,565.776245 286.515259,565.587402 286.145935,565.157776 
	C286.338776,565.099304 286.623260,565.281616 286.989258,565.714478 
z"/>
    <path fill="#B9AAFE" opacity="1.000000" stroke="none"
      d="
M308.011963,591.305176 
	C308.216492,591.232239 308.486816,591.416077 308.848328,591.833618 
	C308.652283,591.898804 308.365051,591.730347 308.011963,591.305176 
z"/>
    <path fill="#9B8CFF" opacity="1.000000" stroke="none"
      d="
M283.140564,560.664551 
	C283.072662,560.913513 282.862030,560.936401 282.334229,560.977173 
	C282.023285,560.811646 282.029449,560.628113 282.074738,560.171082 
	C282.408508,560.077942 282.703156,560.258240 283.140564,560.664551 
z"/>
    <path fill="#A092FF" opacity="1.000000" stroke="none"
      d="
M284.907837,562.766113 
	C284.652985,562.906250 284.392059,562.708496 284.114624,562.181030 
	C284.293091,562.139832 284.560974,562.332153 284.907837,562.766113 
z"/>
    <path fill="#A092FF" opacity="1.000000" stroke="none"
      d="
M293.058533,573.945068 
	C293.361023,574.099548 293.616180,574.303101 293.942871,574.746582 
	C294.014343,574.986389 293.947693,575.038452 293.715637,574.939209 
	C293.234680,574.638550 293.047058,574.390686 292.920746,574.096375 
	C292.920746,574.096375 293.011261,573.994263 293.058533,573.945068 
z"/>
    <path fill="#B9AAFE" opacity="1.000000" stroke="none"
      d="
M299.127869,578.253784 
	C299.378845,578.116943 299.623169,578.307129 299.877808,578.812012 
	C299.608826,578.986755 299.353149,578.804749 299.127869,578.253784 
z"/>
    <path fill="#B9AAFE" opacity="1.000000" stroke="none"
      d="
M300.040710,579.285278 
	C300.307892,579.116211 300.575104,579.302551 300.856232,579.830933 
	C300.669861,579.886353 300.393372,579.708862 300.040710,579.285278 
z"/>
    <path fill="#9B8CFF" opacity="1.000000" stroke="none"
      d="
M278.019623,554.685852 
	C277.800446,554.767273 277.521149,554.584167 277.150024,554.161865 
	C277.358643,554.088867 277.659058,554.255127 278.019623,554.685852 
z"/>
    <path fill="#9B8CFF" opacity="1.000000" stroke="none"
      d="
M278.996521,555.709961 
	C278.793213,555.777954 278.513275,555.591309 278.140930,555.163696 
	C278.338989,555.100281 278.629486,555.277832 278.996521,555.709961 
z"/>
    <path fill="#B9AAFE" opacity="1.000000" stroke="none"
      d="
M302.053162,582.280762 
	C302.319916,582.115540 302.583191,582.303589 302.857697,582.830994 
	C302.672699,582.884033 302.399597,582.705261 302.053162,582.280762 
z"/>
    <path fill="#9B8CFF" opacity="1.000000" stroke="none"
      d="
M280.038696,556.742065 
	C279.855164,556.799927 279.550903,556.614990 279.139709,556.179565 
	C279.327881,556.119080 279.622925,556.309204 280.038696,556.742065 
z"/>
    <path fill="#C0BEFF" opacity="1.000000" stroke="none"
      d="
M425.422729,638.817444 
	C423.639923,639.575195 421.938629,639.827454 420.645264,640.690796 
	C394.135803,658.385193 364.684753,652.162598 342.686310,633.174744 
	C321.765961,615.117493 310.611664,591.894165 306.974121,564.825378 
	C304.508698,546.479187 305.518555,528.459412 312.794525,511.126770 
	C313.484985,509.482056 313.608154,507.599152 314.368286,505.574829 
	C323.491730,506.225983 332.241638,507.129120 340.955963,508.385559 
	C339.693329,510.892975 338.564697,513.110657 337.222260,515.190308 
	C331.047607,524.755920 327.635559,535.381714 327.130493,546.571960 
	C325.986603,571.915344 333.830658,594.033142 352.944000,611.381348 
	C366.418182,623.611206 382.210663,627.764526 399.536926,621.814026 
	C412.299072,617.431030 420.217285,607.378418 425.863770,595.326416 
	C428.585510,589.517090 432.157196,584.110168 435.248108,578.468506 
	C438.234619,573.017334 441.097809,567.498718 444.015198,562.009766 
	C445.790649,559.649231 447.566101,557.288696 449.341583,554.928223 
	C449.946289,555.252869 450.550995,555.577515 451.155701,555.902161 
	C452.016754,558.065735 452.877838,560.229248 453.891479,562.733826 
	C447.044189,581.721802 440.044281,600.368713 433.044434,619.015625 
	C430.594299,625.542603 428.144287,632.069580 425.422729,638.817444 
z"/>
    <path fill="#B0A2FD" opacity="1.000000" stroke="none"
      d="
M452.035645,579.702271 
	C451.533539,580.193542 451.026733,580.493713 450.241486,580.886719 
	C450.778534,578.473145 451.594086,575.966553 452.655334,573.214783 
	C453.118317,574.164429 453.335571,575.359253 453.031921,576.946960 
	C452.343292,577.936401 452.175568,578.532959 452.007874,579.129578 
	C452.007874,579.129578 452.030975,579.511169 452.035645,579.702271 
z"/>
    <path fill="#B0A2FD" opacity="1.000000" stroke="none"
      d="
M440.661133,605.161255 
	C440.142883,607.830688 439.333618,610.706360 438.218567,613.770447 
	C438.731873,611.095032 439.550964,608.231262 440.661133,605.161255 
z"/>
    <path fill="#B0A2FD" opacity="1.000000" stroke="none"
      d="
M442.643188,600.134277 
	C442.492584,601.524719 442.047241,603.099548 441.267944,604.823486 
	C441.405487,603.421265 441.876984,601.869934 442.643188,600.134277 
z"/>
    <path fill="#B0A2FD" opacity="1.000000" stroke="none"
      d="
M443.681549,597.154297 
	C443.803162,597.838806 443.649902,598.718201 443.210815,599.784790 
	C443.085541,599.097778 443.246124,598.223389 443.681549,597.154297 
z"/>
    <path fill="#B0A2FD" opacity="1.000000" stroke="none"
      d="
M445.654541,592.137390 
	C445.791138,592.832886 445.641296,593.711975 445.205933,594.778992 
	C445.069672,594.084900 445.218872,593.203003 445.654541,592.137390 
z"/>
    <path fill="#B0A2FD" opacity="1.000000" stroke="none"
      d="
M446.682648,589.156982 
	C446.805084,589.841370 446.652527,590.719849 446.214752,591.785645 
	C446.088898,591.099060 446.248291,590.225098 446.682648,589.156982 
z"/>
    <path fill="#B0A2FD" opacity="1.000000" stroke="none"
      d="
M449.701691,581.173218 
	C449.815613,581.850769 449.659637,582.726013 449.220032,583.788330 
	C449.101562,583.107239 449.266693,582.239075 449.701691,581.173218 
z"/>
    <path fill="#B0A2FD" opacity="1.000000" stroke="none"
      d="
M448.662354,584.142578 
	C448.794464,584.835327 448.642242,585.713013 448.205688,586.779358 
	C448.073547,586.087830 448.225739,585.207764 448.662354,584.142578 
z"/>
    <path fill="#B0A2FD" opacity="1.000000" stroke="none"
      d="
M444.653015,595.081787 
	C444.778320,595.521851 444.626068,596.096802 444.207825,596.825317 
	C444.086365,596.391479 444.230927,595.804077 444.653015,595.081787 
z"/>
    <path fill="#B0A2FD" opacity="1.000000" stroke="none"
      d="
M447.655457,587.082581 
	C447.780182,587.521240 447.628540,588.096191 447.211304,588.824829 
	C447.090149,588.391968 447.234619,587.805420 447.655457,587.082581 
z"/>
    <path fill="#7B68D5" opacity="1.000000" stroke="none"
      d="
M236.980896,601.000000 
	C237.009445,604.038147 237.037994,607.076233 237.063354,611.028320 
	C237.065598,615.965149 237.071030,619.987915 237.052689,624.459473 
	C237.023529,627.605469 237.018158,630.302734 236.988739,633.422974 
	C236.669312,637.900391 236.373932,641.954956 236.078537,646.009460 
	C236.005463,647.361389 235.932388,648.713379 235.788055,650.460571 
	C234.874237,649.962463 233.611038,649.212097 233.251617,648.154602 
	C226.950623,629.615540 220.760117,611.038818 214.273758,592.212036 
	C213.668304,589.573486 213.334717,587.193237 213.007629,584.405945 
	C214.311523,581.559082 215.957657,579.236877 216.829727,576.653442 
	C218.384232,572.048279 219.470886,567.285278 220.907959,562.229614 
	C221.373383,561.986450 221.634399,562.171753 221.937927,563.038147 
	C226.000916,575.192505 229.919998,586.754150 234.024384,598.249573 
	C234.426163,599.374817 235.968155,600.092957 236.980896,601.000000 
z"/>
    <path fill="#C0BEFF" opacity="1.000000" stroke="none"
      d="
M452.255005,578.938721 
	C452.175568,578.532959 452.343292,577.936401 452.774414,577.166626 
	C452.859314,577.578247 452.680725,578.163086 452.255005,578.938721 
z"/>
    <path fill="#B5BFFF" opacity="1.000000" stroke="none"
      d="
M451.438477,99.999474 
	C451.764771,99.663666 452.546936,99.330147 453.668823,98.990158 
	C458.364716,98.985428 462.720886,98.987144 467.542572,98.982010 
	C469.723114,98.982056 471.438141,98.988945 473.582703,98.998299 
	C469.981476,99.337868 465.950775,99.674965 461.458801,100.020370 
	C457.963165,100.019714 454.928741,100.010735 451.438477,99.999474 
z"/>
    <path fill="#BFB8FF" opacity="1.000000" stroke="none"
      d="
M489.330933,98.995117 
	C489.566040,98.844757 490.134918,98.697258 490.851746,98.770325 
	C490.554688,98.993248 490.109711,98.995605 489.330933,98.995117 
z"/>
    <path fill="#4E01B3" opacity="1.000000" stroke="none"
      d="
M465.138062,340.061249 
	C464.822968,340.826874 464.507874,341.592529 464.046570,342.635101 
	C456.793335,349.266174 449.466614,355.396210 442.667389,362.064117 
	C438.988281,365.672180 435.523621,365.385986 431.245697,362.815674 
	C429.671844,349.976044 428.385254,337.870087 426.940186,325.783112 
	C426.820618,324.783173 425.627106,323.911621 424.953125,322.547028 
	C424.948792,319.816132 424.923920,317.518585 424.928528,314.750793 
	C423.971741,304.774536 423.099426,295.255005 421.970215,285.766022 
	C420.588013,274.151215 418.908112,262.571930 417.507812,250.959076 
	C415.910431,237.711792 414.479248,224.444458 413.444763,211.133331 
	C424.949005,211.378433 435.984344,211.676056 447.019653,211.973663 
	C447.019653,211.973663 447.000183,212.015869 447.049866,212.429123 
	C447.621826,215.386627 448.386993,217.909042 448.618164,220.479477 
	C449.179291,226.719452 449.492035,232.981766 449.611206,239.077606 
	C448.247589,238.510162 446.845978,237.458725 446.169037,237.808746 
	C444.008057,238.926193 442.116150,240.563980 440.120331,242.000824 
	C440.556030,242.372330 440.991730,242.743851 441.427429,243.115356 
	C442.095551,244.202286 442.763672,245.289215 443.553619,246.574326 
	C446.330597,244.141144 448.421051,242.309509 450.649811,240.856293 
	C451.209808,242.220947 451.631500,243.207153 451.878967,244.469971 
	C449.873383,246.112183 448.041931,247.477798 446.056152,248.958511 
	C446.993347,250.321030 447.709198,251.361801 448.482208,252.485611 
	C450.124268,251.615326 451.562653,250.853012 453.007812,250.448944 
	C453.450104,251.576920 453.885590,252.346649 454.127686,253.388641 
	C452.783173,254.393250 451.632019,255.125580 449.381805,256.557129 
	C451.476471,257.739777 452.739929,258.453125 454.042542,259.615173 
	C454.201782,260.651672 454.321899,261.239502 454.268921,262.109955 
	C454.410858,263.883484 454.725922,265.374359 455.033997,267.236694 
	C455.426056,268.439148 455.825073,269.270111 456.195679,270.455078 
	C456.504303,272.180267 456.841309,273.551483 456.898499,275.119141 
	C456.836029,276.253906 457.053406,277.192230 457.201477,278.482788 
	C457.484772,280.195587 457.837341,281.556122 457.897644,283.141113 
	C457.935028,284.357605 458.264709,285.349609 458.467712,286.692474 
	C458.258118,288.286255 458.175232,289.529205 458.066101,291.203857 
	C458.038147,292.788879 458.036469,293.942169 458.006287,295.399384 
	C458.353363,297.000946 458.728943,298.298553 459.076813,300.002075 
	C459.033173,301.221558 459.017242,302.035095 458.625549,302.888062 
	C454.854126,305.808655 455.038239,306.374786 460.076355,309.035278 
	C460.032867,310.254425 460.017273,311.067780 459.654114,311.916321 
	C457.814331,311.485413 456.322113,311.019287 454.565186,310.470459 
	C454.100708,311.932068 453.724762,313.115082 453.287079,314.492340 
	C455.980591,315.702911 458.486237,316.829041 460.995514,318.375580 
	C462.378784,325.884430 463.758423,332.972839 465.138062,340.061249 
M436.365784,235.755447 
	C434.073456,238.823746 436.189362,239.602951 438.741089,240.376343 
	C440.503143,238.169876 442.197815,236.047806 444.062592,233.712708 
	C442.356537,232.612534 441.159027,231.840302 439.817352,230.975113 
	C438.681610,232.540726 437.724854,233.859589 436.365784,235.755447 
M440.734314,321.972443 
	C440.852295,319.722412 440.970306,317.472382 441.127655,314.472015 
	C439.207031,314.885315 436.901855,315.006500 436.835266,315.457855 
	C436.464691,317.970551 436.636902,320.563293 436.623413,323.128693 
	C437.921051,323.005554 439.218658,322.882446 440.734314,321.972443 
M435.760345,229.476578 
	C434.611664,228.365387 433.462982,227.254196 431.810913,225.656052 
	C430.372253,229.076721 429.314789,231.591064 428.209503,234.219101 
	C434.111359,238.460220 433.324524,231.836929 435.760345,229.476578 
M456.869293,326.419861 
	C457.724823,324.932556 458.580322,323.445251 459.625458,321.628357 
	C456.855621,320.418396 454.709991,319.481110 452.292908,318.425232 
	C451.919556,321.129242 451.634796,323.191681 451.314972,325.507996 
	C453.086060,325.962524 454.647034,326.363129 456.869293,326.419861 
M423.344757,232.954361 
	C424.894775,230.485535 426.444763,228.016708 428.578979,224.617355 
	C425.482727,224.297546 423.987305,224.143082 421.304077,223.865921 
	C421.788483,227.351959 422.170288,230.099640 423.344757,232.954361 
M444.209351,323.808228 
	C448.463989,325.105804 449.001221,324.259674 448.993958,316.113892 
	C447.797668,315.902863 446.590057,315.689850 444.958282,315.402008 
	C444.604767,318.215240 444.302155,320.623535 444.209351,323.808228 
M432.952454,317.639496 
	C433.327759,313.746674 431.363098,313.617828 428.467682,314.631927 
	C428.467682,317.484131 428.467682,320.075592 428.467682,322.567139 
	C433.033447,324.178009 433.082214,321.447876 432.952454,317.639496 
z"/>
    <path fill="#5301B9" opacity="1.000000" stroke="none"
      d="
M424.932617,322.980408 
	C425.627106,323.911621 426.820618,324.783173 426.940186,325.783112 
	C428.385254,337.870087 429.671844,349.976044 430.999329,362.539825 
	C423.504272,358.329163 415.723053,354.047028 408.617401,348.842560 
	C403.995636,345.457428 400.357605,340.729248 396.511383,336.252075 
	C397.495667,333.292145 398.247467,330.682892 399.340942,327.928528 
	C404.239929,326.175873 400.968811,323.184967 400.604828,320.962646 
	C400.461670,320.088470 398.261383,319.551208 396.996857,318.446381 
	C395.406677,306.763611 393.673981,295.512848 392.266357,284.221619 
	C390.673340,271.443024 389.372040,258.628082 388.072876,245.536621 
	C388.336731,243.953339 389.000793,242.373886 388.489166,241.435303 
	C387.599060,239.802231 385.983337,238.564667 384.979065,236.978378 
	C385.975525,236.154526 386.664703,235.513565 387.622986,235.042603 
	C389.392670,236.914856 390.893280,238.617111 392.641571,240.600342 
	C393.817566,239.672119 394.880676,238.832977 396.067078,237.896545 
	C394.269318,235.337341 392.714294,233.123734 391.135742,230.876617 
	C389.576538,231.805115 388.464264,232.467468 387.010254,232.919128 
	C385.446564,226.131378 384.224640,219.554321 383.385406,212.812805 
	C393.504028,212.160858 403.239929,211.673340 412.975830,211.185837 
	C414.479248,224.444458 415.910431,237.711792 417.507812,250.959076 
	C418.908112,262.571930 420.588013,274.151215 421.970215,285.766022 
	C423.099426,295.255005 423.971741,304.774536 424.593414,314.584076 
	C422.915527,314.974670 420.468567,314.995544 420.459045,315.158691 
	C420.318634,317.563812 420.257385,320.045502 420.802368,322.361938 
	C420.920532,322.864197 423.491425,322.789429 424.932617,322.980408 
M397.299011,227.050278 
	C392.140015,230.060242 397.854370,232.061890 398.198730,234.540649 
	C398.247528,234.892105 400.948883,234.875092 402.422485,235.028610 
	C402.662323,234.459106 402.902161,233.889603 403.141998,233.320099 
	C401.407288,231.147873 399.672546,228.975647 397.299011,227.050278 
M406.792328,223.957458 
	C405.851257,224.871597 403.975098,226.028870 404.138153,226.655899 
	C404.709137,228.851761 405.983124,230.864822 406.990143,232.947311 
	C407.954346,232.310135 409.816254,231.504562 409.733521,231.063751 
	C409.278168,228.636200 408.347595,226.297775 406.792328,223.957458 
M405.310760,324.994507 
	C406.689911,325.076324 408.069031,325.158112 409.900574,325.266754 
	C409.133392,321.755310 408.556305,319.113861 407.936005,316.274658 
	C406.299072,316.693390 405.100616,316.999939 403.619232,317.378845 
	C404.152649,319.865326 404.625183,322.068054 405.310760,324.994507 
M417.036926,321.993225 
	C416.970520,320.666229 417.200714,319.226562 416.751801,318.044891 
	C416.328278,316.930115 415.190002,316.086853 414.366119,315.124176 
	C413.598663,316.261597 412.259308,317.367706 412.194916,318.543610 
	C412.092926,320.406891 412.843933,322.316833 413.368225,324.857452 
	C414.958771,323.964722 415.991364,323.385132 417.036926,321.993225 
z"/>
    <path fill="#5802BF" opacity="1.000000" stroke="none"
      d="
M387.353912,234.872620 
	C386.664703,235.513565 385.975525,236.154526 384.648529,237.004883 
	C382.867249,238.236862 381.723755,239.259399 379.975494,240.822739 
	C383.060944,242.761215 385.502411,244.295074 387.943848,245.828949 
	C389.372040,258.628082 390.673340,271.443024 392.266357,284.221619 
	C393.673981,295.512848 395.406677,306.763611 396.680298,318.661926 
	C397.242950,322.218933 398.121124,325.146301 398.999268,328.073639 
	C398.247467,330.682892 397.495667,333.292145 396.360596,335.955109 
	C394.687347,334.472260 393.397369,332.935699 392.225464,330.834259 
	C398.039337,326.601135 391.344330,324.250275 392.091278,321.108185 
	C391.407410,320.989258 390.723511,320.870361 390.039642,320.751434 
	C389.542328,322.305084 389.045044,323.858734 388.547729,325.412384 
	C388.296387,325.532654 388.045105,325.652954 387.392181,325.889038 
	C386.101257,324.745300 385.211975,323.485748 384.017395,321.724731 
	C382.499084,320.164246 381.285980,319.105316 380.072906,318.046356 
	C380.015289,317.285828 379.957703,316.525330 379.905396,315.001770 
	C379.756500,310.958893 377.491425,310.884491 375.068420,311.049927 
	C374.823303,310.278015 374.578186,309.506104 374.566650,308.370697 
	C375.574585,306.639801 376.348969,305.272400 377.123383,303.905029 
	C376.686646,303.614899 376.249939,303.324799 375.813232,303.034668 
	C374.229034,303.338989 372.644836,303.643311 371.060638,303.947632 
	C370.452332,303.129517 369.844055,302.311371 369.494385,301.058716 
	C371.997864,299.531433 376.902954,300.822510 374.287048,295.056305 
	C372.609436,295.165741 370.859589,295.279877 369.080139,294.982788 
	C369.033569,293.747314 369.016632,292.923065 369.411987,292.008484 
	C373.149750,291.957764 375.367310,291.171051 373.437744,287.117737 
	C371.559540,287.019348 369.779999,286.926147 368.000244,286.467285 
	C368.000122,285.126587 368.000244,284.151520 368.416870,283.117432 
	C370.443054,283.058380 372.052765,283.058380 373.561066,283.058380 
	C375.278503,280.108673 374.509766,278.608948 371.353851,278.314301 
	C369.901062,278.178650 368.451141,278.012817 366.999969,277.488831 
	C366.998901,276.125275 366.997772,275.133606 367.389221,274.146118 
	C370.799683,274.446686 374.819305,277.223206 375.813904,270.369385 
	C372.253326,270.369385 369.223969,270.369385 366.107178,269.945068 
	C363.680237,251.344574 361.340729,233.168411 359.381073,214.826874 
	C366.515686,214.081207 373.270447,213.500916 380.397156,212.934448 
	C381.513672,212.957932 382.258209,212.967590 383.002716,212.977264 
	C384.224640,219.554321 385.446564,226.131378 386.979767,233.209045 
	C387.312012,234.097305 387.332977,234.484970 387.353912,234.872620 
M380.125153,255.291229 
	C377.839905,254.151321 375.554657,253.011414 372.991974,251.733124 
	C372.245056,253.701462 371.749237,255.008087 371.173553,256.525208 
	C374.012878,257.707184 376.527557,258.753998 379.448151,259.969818 
	C379.927948,258.220734 380.258118,257.017120 380.125153,255.291229 
M382.418854,247.040100 
	C380.934906,246.069702 379.450928,245.099304 377.778259,244.005493 
	C376.834137,245.495377 376.071625,246.698669 375.115814,248.207047 
	C377.739929,249.760498 380.091766,251.152771 382.443604,252.545044 
	C382.964874,252.363739 383.486115,252.182419 384.007385,252.001114 
	C383.663025,250.484131 383.318695,248.967148 382.418854,247.040100 
M372.565704,261.152039 
	C368.552765,259.299744 368.929352,262.472076 368.184296,264.570068 
	C375.725494,268.049866 376.552521,267.907806 377.351318,263.043243 
	C376.007385,262.502289 374.632965,261.949097 372.565704,261.152039 
z"/>
    <path fill="#40DFEF" opacity="1.000000" stroke="none"
      d="
M388.516083,325.528870 
	C389.045044,323.858734 389.542328,322.305084 390.039642,320.751434 
	C390.723511,320.870361 391.407410,320.989258 392.091278,321.108185 
	C391.344330,324.250275 398.039337,326.601135 392.097931,330.511688 
	C391.080750,329.686005 390.309082,328.618042 389.294067,327.050934 
	C388.792603,326.290466 388.534515,326.029083 388.276398,325.767731 
	C388.276398,325.767731 388.484436,325.645325 388.516083,325.528870 
z"/>
    <path fill="#1EE0F0" opacity="1.000000" stroke="none"
      d="
M382.392303,334.031860 
	C381.253387,332.752686 380.501312,331.527252 379.429871,329.781464 
	C381.499054,328.823486 383.340302,327.971039 385.542114,327.173584 
	C386.393799,328.707062 386.884918,330.185577 387.533203,332.137207 
	C385.861755,332.822205 384.320435,333.453888 382.392303,334.031860 
z"/>
    <path fill="#5802BF" opacity="1.000000" stroke="none"
      d="
M388.273712,326.059296 
	C388.534515,326.029083 388.792603,326.290466 389.067932,326.856140 
	C388.813782,326.890594 388.542419,326.620728 388.273712,326.059296 
z"/>
    <path fill="#4500AA" opacity="1.000000" stroke="none"
      d="
M465.423340,339.898071 
	C463.758423,332.972839 462.378784,325.884430 461.245789,318.153351 
	C461.982574,316.294800 462.472748,315.078918 463.001526,313.767242 
	C461.906860,313.078979 460.954285,312.480042 460.001709,311.881104 
	C460.017273,311.067780 460.032867,310.254425 460.487854,309.087524 
	C464.791382,309.592407 465.588776,307.827240 464.682251,304.527374 
	C462.704163,303.942841 460.852722,303.395721 459.001312,302.848633 
	C459.017242,302.035095 459.033173,301.221558 459.512115,300.045593 
	C462.828796,299.482727 467.549591,302.106903 466.524689,295.095428 
	C463.488739,295.095428 460.761749,295.095428 458.034790,295.095428 
	C458.036469,293.942169 458.038147,292.788879 458.509247,291.288605 
	C461.586945,290.941589 464.195251,290.941589 466.634094,290.941589 
	C467.792023,287.075714 466.470306,285.818604 463.086243,286.233612 
	C461.606781,286.415100 460.092743,286.314240 458.594391,286.341614 
	C458.264709,285.349609 457.935028,284.357605 458.331879,283.150879 
	C461.611359,282.756012 464.164307,282.575836 467.054779,282.371857 
	C466.809143,280.361267 466.639069,278.968964 466.469696,277.582672 
	C463.145111,277.780670 460.207947,277.955627 457.270813,278.130554 
	C457.053406,277.192230 456.836029,276.253906 457.288635,275.105042 
	C460.484497,274.371704 463.010406,273.848969 465.881989,273.254669 
	C465.437866,271.578613 465.078918,270.224060 464.666870,268.669006 
	C461.677155,269.176117 458.950623,269.638580 456.224091,270.101074 
	C455.825073,269.270111 455.426056,268.439148 455.413208,267.267517 
	C458.282928,266.168243 460.766479,265.409637 463.387878,264.608887 
	C462.859283,261.225128 462.293091,258.625214 458.161499,260.951935 
	C457.095428,261.552307 455.691040,261.551788 454.442017,261.827301 
	C454.321899,261.239502 454.201782,260.651672 454.340546,259.407684 
	C456.406433,257.802917 458.213440,256.854340 460.070099,255.879700 
	C459.127350,252.314575 457.693176,250.567276 454.321075,253.116379 
	C453.885590,252.346649 453.450104,251.576920 453.254150,250.242065 
	C457.094025,246.777115 455.410980,245.265259 452.053162,244.193359 
	C451.631500,243.207153 451.209808,242.220947 450.517273,240.740479 
	C450.132599,239.909164 450.018768,239.572128 449.904907,239.235077 
	C449.492035,232.981766 449.179291,226.719452 448.618164,220.479477 
	C448.386993,217.909042 447.621826,215.386627 447.037384,212.448730 
	C465.405975,212.949585 483.485138,215.646790 500.795990,222.399719 
	C503.733704,223.545731 504.978027,225.187439 505.119507,228.636841 
	C506.654846,266.071045 495.685272,299.611664 474.017426,329.864594 
	C471.520905,333.350281 468.491150,336.454041 465.423340,339.898071 
z"/>
    <path fill="#2E008C" opacity="1.000000" stroke="none"
      d="
M383.385406,212.812805 
	C382.258209,212.967590 381.513672,212.957932 380.388245,212.584137 
	C380.004761,211.278717 380.002197,210.337402 380.439819,209.279724 
	C392.589020,208.489746 404.298096,207.816162 416.467896,207.237183 
	C427.579926,207.350403 438.231201,207.369003 448.882477,207.387619 
	C448.882477,207.387619 448.949493,207.682556 448.996918,207.826050 
	C448.363007,209.054398 447.681671,210.139252 447.010010,211.598877 
	C435.984344,211.676056 424.949005,211.378433 413.444763,211.133331 
	C403.239929,211.673340 393.504028,212.160858 383.385406,212.812805 
z"/>
    <path fill="#B5BFFF" opacity="1.000000" stroke="none"
      d="
M434.464844,101.002243 
	C438.361206,100.669075 442.720825,100.335503 447.544769,100.005737 
	C443.648743,100.340317 439.288422,100.671082 434.464844,101.002243 
z"/>
    <path fill="#725ED0" opacity="1.000000" stroke="none"
      d="
M236.995117,600.531860 
	C235.968155,600.092957 234.426163,599.374817 234.024384,598.249573 
	C229.919998,586.754150 226.000916,575.192505 222.051697,563.251892 
	C224.852524,564.792908 227.631683,566.731445 231.214233,569.230347 
	C231.855377,561.825867 232.420654,555.297363 233.091125,548.345032 
	C234.109970,551.725220 235.471024,555.486328 235.840744,559.342529 
	C236.532822,566.560913 236.650330,573.834351 237.035614,581.550537 
	C237.046021,588.031982 237.027679,594.047913 236.995117,600.531860 
z"/>
    <path fill="#6000C9" opacity="1.000000" stroke="none"
      d="
M330.934326,264.054535 
	C327.523651,262.399719 324.112976,260.744904 320.350342,259.053162 
	C313.221039,256.353333 306.443695,253.690384 299.295410,251.042603 
	C298.924500,251.057785 298.980865,251.123016 298.833984,250.847672 
	C298.108643,250.400833 297.530182,250.229340 296.623962,250.045181 
	C295.861816,249.981949 295.427429,249.931366 294.993042,249.880798 
	C293.864471,249.343262 292.735901,248.805725 291.123901,247.850708 
	C289.098907,246.991150 287.557281,246.549042 286.015686,246.106949 
	C284.742737,246.060196 283.469788,246.013443 281.683228,245.615875 
	C279.568359,244.915359 277.967102,244.565613 276.365814,244.215881 
	C275.007385,244.183533 273.648956,244.151184 271.724365,244.206909 
	C271.158173,244.294983 271.089935,244.185684 271.089935,244.185684 
	C267.367676,243.448120 263.645447,242.710556 259.484497,241.969727 
	C256.384277,241.330704 253.751175,240.348312 251.055679,240.127518 
	C244.360687,239.579102 237.637253,239.378159 230.056793,239.031769 
	C227.494705,239.025864 225.801056,239.025864 224.107407,239.025864 
	C224.117386,238.853409 224.127380,238.680969 224.137360,238.508514 
	C230.438705,236.688538 236.740036,234.868546 243.462219,233.033936 
	C256.858887,230.535294 269.833252,228.043518 282.811066,225.570068 
	C290.871063,224.033920 298.936371,222.525543 307.429321,221.002899 
	C314.566132,220.288834 321.272919,219.576538 327.986755,219.295547 
	C328.549469,223.304062 329.199982,226.869598 329.642212,230.460770 
	C330.809692,239.941360 332.010559,249.421768 332.881348,258.931244 
	C333.031036,260.565857 331.622864,262.343140 330.934326,264.054535 
z"/>
    <path fill="#1EE0F0" opacity="1.000000" stroke="none"
      d="
M270.712250,244.201126 
	C271.089935,244.185684 271.158173,244.294983 271.221069,244.295593 
	C271.564850,247.087433 271.845673,249.878662 272.120117,252.606155 
	C267.521271,253.891953 267.521271,253.891953 266.676178,245.091202 
	C267.861450,244.807831 269.098022,244.512207 270.712250,244.201126 
z"/>
    <path fill="#1EE0F0" opacity="1.000000" stroke="none"
      d="
M259.822083,255.019775 
	C258.793640,252.541733 257.968048,250.310425 257.161499,247.732788 
	C258.539734,246.960953 259.898895,246.535461 261.582916,246.008270 
	C262.474487,248.951874 263.267548,251.570175 264.250214,254.814453 
	C262.585358,254.992569 261.305145,255.129532 259.822083,255.019775 
z"/>
    <path fill="#1EE0F0" opacity="1.000000" stroke="none"
      d="
M276.304443,244.644196 
	C277.967102,244.565613 279.568359,244.915359 281.301361,245.607849 
	C280.920197,248.367691 280.407318,250.784760 279.762634,253.822845 
	C273.376709,252.654907 277.098877,247.890060 276.304443,244.644196 
z"/>
    <path fill="#1EE0F0" opacity="1.000000" stroke="none"
      d="
M285.959717,246.472412 
	C287.557281,246.549042 289.098907,246.991150 290.824890,247.727203 
	C289.983215,250.405716 288.957153,252.790283 287.822876,255.520981 
	C286.520966,255.451279 285.327271,255.035461 283.742859,254.483536 
	C284.512390,251.760666 285.208069,249.299271 285.959717,246.472412 
z"/>
    <path fill="#1EE0F0" opacity="1.000000" stroke="none"
      d="
M277.886993,344.397888 
	C278.465118,342.691193 279.124146,341.350433 279.783142,340.009644 
	C283.981659,347.873840 283.906219,348.440063 279.567780,349.778229 
	C279.036194,348.112152 278.502045,346.437958 277.886993,344.397888 
z"/>
    <path fill="#1EE0F0" opacity="1.000000" stroke="none"
      d="
M298.384216,337.484314 
	C298.811096,340.342743 298.881470,343.165833 298.724304,346.362183 
	C292.023376,346.578827 296.289734,341.058899 293.649445,338.361206 
	C295.574799,337.960052 296.801270,337.704498 298.384216,337.484314 
z"/>
    <path fill="#1EE0F0" opacity="1.000000" stroke="none"
      d="
M256.520081,257.671295 
	C252.657928,259.892731 252.657928,259.892731 248.197449,252.038208 
	C248.637497,251.871277 249.440460,251.599625 250.214798,251.262283 
	C250.811325,251.002426 251.371841,250.659988 252.394073,250.117874 
	C253.525406,251.947586 254.617294,253.713486 255.941086,255.738083 
	C256.286133,256.439606 256.399231,256.882416 256.520081,257.671295 
z"/>
    <path fill="#1EE0F0" opacity="1.000000" stroke="none"
      d="
M287.121704,346.821655 
	C286.601715,344.174133 286.194916,341.931061 285.621216,338.767548 
	C287.587708,339.214294 289.695740,339.203888 289.905518,339.829742 
	C290.624573,341.974976 290.756104,344.341187 290.820648,346.631317 
	C290.825287,346.795746 288.484955,347.026276 287.121704,346.821655 
z"/>
    <path fill="#1EE0F0" opacity="1.000000" stroke="none"
      d="
M271.555969,351.781677 
	C270.661652,349.043274 270.146820,346.469360 269.887085,343.678040 
	C275.484344,342.188354 273.626587,347.166382 274.959351,349.304535 
	C275.072571,349.486176 272.995148,351.033325 271.555969,351.781677 
z"/>
    <path fill="#4402B9" opacity="1.000000" stroke="none"
      d="
M243.041382,233.048553 
	C236.740036,234.868546 230.438705,236.688538 224.137360,238.508514 
	C224.127380,238.680969 224.117386,238.853409 224.107407,239.025864 
	C225.801056,239.025864 227.494705,239.025864 229.600357,239.044006 
	C225.043335,245.965820 229.323669,253.216690 229.385040,260.280975 
	C229.415375,263.774139 230.879227,267.254822 231.893250,271.307129 
	C232.087601,273.496002 232.083206,275.118927 232.078827,276.741821 
	C232.053085,277.855957 232.027359,278.970123 231.656403,280.495026 
	C227.017914,279.134186 228.073914,282.603638 227.215942,284.562439 
	C229.447723,285.375214 231.265076,286.037048 233.082413,286.698914 
	C233.029968,287.662292 232.977524,288.625702 232.491974,290.006531 
	C230.168167,290.086670 228.277481,289.749329 226.042450,289.350525 
	C225.698837,290.902802 225.404846,292.230896 224.981110,294.145142 
	C228.282455,294.468414 231.146210,294.748871 234.009979,295.029297 
	C233.911301,296.338684 233.812622,297.648041 233.223343,299.197815 
	C231.083069,299.275360 229.431061,299.132996 227.784210,298.945496 
	C223.945694,298.508392 223.668549,300.418854 224.909363,304.139526 
	C227.766357,303.680664 230.556641,303.232513 233.346924,302.784363 
	C234.562851,307.915466 235.996368,313.008392 236.907486,318.193085 
	C237.399765,320.994385 236.999466,323.952545 236.616440,326.893372 
	C232.856812,322.426971 230.174362,327.284821 227.103943,327.063965 
	C227.331055,330.491089 228.422958,331.949371 231.544037,330.642212 
	C233.210312,329.944336 234.961594,329.449432 236.674500,328.862885 
	C237.404129,330.149200 238.133774,331.435516 238.456833,332.991211 
	C235.314941,334.147247 232.579605,335.033875 229.405869,336.062622 
	C230.569107,337.947144 231.292038,339.118317 231.963928,340.206818 
	C234.444855,339.261505 236.452026,338.496674 238.459198,337.731873 
	C238.965134,338.558563 239.471069,339.385315 239.753967,340.856689 
	C237.693665,342.549408 235.856415,343.597473 233.722916,344.814484 
	C234.705505,346.308167 235.472977,347.474823 236.255249,348.663971 
	C238.070724,347.733856 239.539688,346.981232 241.008636,346.228638 
	C241.264908,347.315399 241.521179,348.402130 241.730637,350.081024 
	C237.647888,352.835663 239.449966,354.675446 242.004486,356.473633 
	C243.336136,366.660004 244.667786,376.846405 246.002594,387.447327 
	C238.259491,383.557648 230.513245,379.253418 222.427811,374.854919 
	C220.469162,373.485657 218.849716,372.210663 217.083023,370.215149 
	C216.926468,368.167236 217.062943,366.819977 216.885712,365.515350 
	C214.623199,348.862732 212.278137,332.221313 210.029327,315.566864 
	C207.295029,295.316925 204.632217,275.057281 202.140411,254.535660 
	C208.151718,250.286575 213.961075,246.303665 219.770447,242.320755 
	C219.469009,241.702560 219.167572,241.084351 218.866119,240.466156 
	C208.918793,243.348846 198.971466,246.231522 189.024139,249.114227 
	C188.705841,248.329742 188.387543,247.545242 188.038483,246.443787 
	C195.179230,243.654083 202.350769,241.181366 209.789017,238.476028 
	C219.647568,235.753616 229.239410,233.263794 239.471786,230.545486 
	C240.745255,230.275360 241.378159,230.233719 242.012161,230.516174 
	C242.355957,231.576385 242.698669,232.312469 243.041382,233.048553 
M233.683609,320.837006 
	C233.749680,319.432251 233.815750,318.027466 233.892227,316.401672 
	C230.568970,316.858917 228.012207,317.210724 225.458572,317.562073 
	C224.636414,321.542511 226.162033,322.672211 229.618515,321.790771 
	C230.726257,321.508301 231.847107,321.277161 233.683609,320.837006 
M227.633133,312.888275 
	C230.232681,312.370605 234.554001,313.627625 232.656784,308.248444 
	C229.848618,308.248444 227.274536,308.248444 224.700439,308.248444 
	C224.344894,308.606140 223.989365,308.963837 223.633820,309.321533 
	C224.678665,310.525421 225.723511,311.729340 227.633133,312.888275 
z"/>
    <path fill="#1EE0F0" opacity="1.000000" stroke="none"
      d="
M233.327789,302.491516 
	C230.556641,303.232513 227.766357,303.680664 224.909363,304.139526 
	C223.668549,300.418854 223.945694,298.508392 227.784210,298.945496 
	C229.431061,299.132996 231.083069,299.275360 233.087799,299.671997 
	C233.398132,300.670105 233.353378,301.434387 233.327789,302.491516 
z"/>
    <path fill="#1EE0F0" opacity="1.000000" stroke="none"
      d="
M235.264252,266.819397 
	C235.960403,263.644531 237.439301,262.292175 239.972549,264.752655 
	C241.802460,266.529968 246.782745,267.401001 242.113235,271.862183 
	C239.898865,270.319000 237.629257,268.737305 235.264252,266.819397 
z"/>
    <path fill="#1EE0F0" opacity="1.000000" stroke="none"
      d="
M245.297455,256.809662 
	C247.068710,258.747223 248.584747,260.446564 250.712967,262.832062 
	C249.513321,263.663025 248.493500,264.369415 247.206329,265.261017 
	C245.102615,263.318481 243.087997,261.458221 240.409225,258.984680 
	C242.259598,258.020844 243.650909,257.296112 245.297455,256.809662 
z"/>
    <path fill="#1EE0F0" opacity="1.000000" stroke="none"
      d="
M245.100616,360.763184 
	C246.821365,359.073761 248.559341,357.753052 250.604660,356.198822 
	C251.854065,358.082855 252.834717,359.561584 254.089035,361.453003 
	C252.099533,362.657227 250.323349,363.732361 248.356842,364.922668 
	C247.240997,363.616760 246.179413,362.374359 245.100616,360.763184 
z"/>
    <path fill="#1EE0F0" opacity="1.000000" stroke="none"
      d="
M233.447052,286.733795 
	C231.265076,286.037048 229.447723,285.375214 227.215942,284.562439 
	C228.073914,282.603638 227.017914,279.134186 231.657196,280.913025 
	C233.454956,281.612671 234.906662,282.305084 237.540634,283.561371 
	C236.076431,284.820740 234.944061,285.794708 233.447052,286.733795 
z"/>
    <path fill="#1EE0F0" opacity="1.000000" stroke="none"
      d="
M234.046326,294.715118 
	C231.146210,294.748871 228.282455,294.468414 224.981110,294.145142 
	C225.404846,292.230896 225.698837,290.902802 226.042450,289.350525 
	C228.277481,289.749329 230.168167,290.086670 232.445450,290.486694 
	C233.248932,291.833221 233.665817,293.117096 234.046326,294.715118 
z"/>
    <path fill="#1EE0F0" opacity="1.000000" stroke="none"
      d="
M242.297287,356.263184 
	C239.449966,354.675446 237.647888,352.835663 241.858856,350.396973 
	C244.257065,348.314301 246.492126,346.398987 248.227493,351.304749 
	C246.453995,352.798431 244.522034,354.425568 242.297287,356.263184 
z"/>
    <path fill="#1EE0F0" opacity="1.000000" stroke="none"
      d="
M236.683502,328.652649 
	C234.961594,329.449432 233.210312,329.944336 231.544037,330.642212 
	C228.422958,331.949371 227.331055,330.491089 227.103943,327.063965 
	C230.174362,327.284821 232.856812,322.426971 236.440826,327.278870 
	C236.599503,327.891418 236.613464,328.168579 236.683502,328.652649 
z"/>
    <path fill="#1EE0F0" opacity="1.000000" stroke="none"
      d="
M232.442993,276.820312 
	C232.083206,275.118927 232.087601,273.496002 232.217712,271.544586 
	C234.805618,272.479126 237.267822,273.742188 239.879395,275.081879 
	C238.949753,282.035919 235.337784,277.323639 232.442993,276.820312 
z"/>
    <path fill="#1EE0F0" opacity="1.000000" stroke="none"
      d="
M238.681534,337.420959 
	C236.452026,338.496674 234.444855,339.261505 231.963928,340.206818 
	C231.292038,339.118317 230.569107,337.947144 229.405869,336.062622 
	C232.579605,335.033875 235.314941,334.147247 238.392181,333.395416 
	C238.790680,334.723511 238.847275,335.916779 238.681534,337.420959 
z"/>
    <path fill="#1EE0F0" opacity="1.000000" stroke="none"
      d="
M261.130249,348.140381 
	C262.223389,347.138702 263.292145,346.507599 264.682709,345.686493 
	C265.934723,348.563446 267.018341,351.053436 268.060364,353.447845 
	C264.738281,356.433624 264.465576,356.265717 261.130249,348.140381 
z"/>
    <path fill="#1EE0F0" opacity="1.000000" stroke="none"
      d="
M241.278137,345.984924 
	C239.539688,346.981232 238.070724,347.733856 236.255249,348.663971 
	C235.472977,347.474823 234.705505,346.308167 233.722916,344.814484 
	C235.856415,343.597473 237.693665,342.549408 239.765747,341.247559 
	C243.705292,341.537018 244.103043,343.157959 241.278137,345.984924 
z"/>
    <path fill="#1EE0F0" opacity="1.000000" stroke="none"
      d="
M256.316833,357.700592 
	C255.154160,355.684357 254.192734,353.971222 253.012421,351.868103 
	C254.223434,351.131561 255.349930,350.446442 256.827148,349.548004 
	C258.256775,352.210907 259.482910,354.494812 261.366730,358.003723 
	C259.269318,358.003723 257.893707,358.003723 256.316833,357.700592 
z"/>
    <path fill="#1EE0F0" opacity="1.000000" stroke="none"
      d="
M324.214264,340.540588 
	C327.972198,341.217102 327.072418,343.533325 325.876312,344.970093 
	C324.996246,346.027191 321.893982,346.890808 321.701324,346.594086 
	C320.475372,344.706451 319.782684,342.472443 318.502563,339.347351 
	C321.371307,339.903320 322.605896,340.142578 324.214264,340.540588 
z"/>
    <path fill="#1EE0F0" opacity="1.000000" stroke="none"
      d="
M324.682068,313.365936 
	C326.966064,313.243103 328.938812,313.243103 331.381805,313.243103 
	C331.472382,314.897339 331.546753,316.255432 331.637054,317.904510 
	C329.759521,317.989258 328.304840,318.054932 326.427002,318.178406 
	C324.858185,317.624939 323.712494,317.013672 322.566833,316.402405 
	C323.168182,315.431183 323.769501,314.459991 324.682068,313.365936 
z"/>
    <path fill="#1EE0F0" opacity="1.000000" stroke="none"
      d="
M325.599426,322.111023 
	C327.594696,322.388702 329.191010,322.725830 332.062012,323.332153 
	C330.735260,325.090179 329.797882,326.332306 328.482483,327.575867 
	C327.011932,327.365417 325.807373,327.371704 324.856628,326.883575 
	C323.791901,326.336975 322.957092,325.342590 322.022247,324.543060 
	C323.081665,323.752197 324.141113,322.961365 325.599426,322.111023 
z"/>
    <path fill="#1EE0F0" opacity="1.000000" stroke="none"
      d="
M325.026062,295.382507 
	C328.438019,294.414734 329.899048,295.617645 329.586548,299.303925 
	C328.346588,299.598145 326.976746,299.923157 325.287323,300.404144 
	C321.988007,301.386261 320.183472,300.713562 320.537140,296.881226 
	C321.946625,296.457123 323.343903,296.036713 325.026062,295.382507 
z"/>
    <path fill="#1EE0F0" opacity="1.000000" stroke="none"
      d="
M294.738373,250.118805 
	C295.427429,249.931366 295.861816,249.981949 296.792969,250.294037 
	C297.853455,250.744705 298.417145,250.933853 298.980865,251.123016 
	C298.980865,251.123016 298.924500,251.057785 298.890167,251.084320 
	C297.772675,253.546982 296.847260,256.076996 295.493134,258.351807 
	C295.162994,258.906342 293.202362,259.023529 292.412506,258.584412 
	C291.882294,258.289642 291.752411,256.549500 292.044983,255.652191 
	C292.643280,253.817108 293.646973,252.114182 294.738373,250.118805 
z"/>
    <path fill="#1EE0F0" opacity="1.000000" stroke="none"
      d="
M318.569122,270.870361 
	C318.858795,271.748108 318.876617,272.451508 318.747040,273.490051 
	C317.308075,274.524109 316.084839,275.535217 314.706329,275.837067 
	C313.229309,276.160492 311.606079,275.816254 309.961060,274.775604 
	C312.933807,273.328491 313.532501,267.295105 318.569122,270.870361 
z"/>
    <path fill="#1EE0F0" opacity="1.000000" stroke="none"
      d="
M307.637024,342.765381 
	C306.674255,344.291901 305.705414,345.392975 304.736542,346.494080 
	C304.284607,346.206451 303.832672,345.918854 303.380737,345.631256 
	C303.380737,343.033600 303.380737,340.435944 303.380737,337.753693 
	C307.433289,336.578430 307.433289,336.578430 307.637024,342.765381 
z"/>
    <path fill="#1EE0F0" opacity="1.000000" stroke="none"
      d="
M327.618225,331.750458 
	C328.341003,333.219666 328.676331,334.685028 328.971863,336.491791 
	C326.124329,336.182434 323.316589,335.531647 320.306091,334.833862 
	C320.752808,328.588318 324.576630,331.581390 327.618225,331.750458 
z"/>
    <path fill="#1EE0F0" opacity="1.000000" stroke="none"
      d="
M322.835175,286.587219 
	C324.353058,286.894531 325.601837,287.420197 326.850647,287.945862 
	C326.052948,289.021088 325.255249,290.096344 324.156738,291.352112 
	C322.439453,291.898224 321.022980,292.263733 319.452545,292.668976 
	C315.783234,288.246979 320.032867,287.962097 322.835175,286.587219 
z"/>
    <path fill="#1EE0F0" opacity="1.000000" stroke="none"
      d="
M312.299133,266.476135 
	C310.529236,267.933136 309.020844,269.158783 307.174377,270.659119 
	C302.257782,265.068634 309.330688,264.621674 310.063934,261.765289 
	C310.591644,261.705719 311.119385,261.646179 311.647095,261.586609 
	C311.951569,263.139343 312.256073,264.692078 312.299133,266.476135 
z"/>
    <path fill="#1EE0F0" opacity="1.000000" stroke="none"
      d="
M305.674561,256.418945 
	C304.846558,259.274353 303.764221,261.894379 302.681885,264.514404 
	C301.964355,264.483124 301.246796,264.451843 300.529266,264.420532 
	C300.106995,263.088898 299.087128,260.744934 299.356995,260.585632 
	C301.528625,259.303589 300.864441,253.963974 305.674561,256.418945 
z"/>
    <path fill="#1EE0F0" opacity="1.000000" stroke="none"
      d="
M324.800842,304.674561 
	C326.883911,304.386993 328.627441,304.231140 330.740112,304.042297 
	C330.825317,305.735962 330.893616,307.094208 330.974243,308.697357 
	C329.034668,308.889130 327.443542,309.046478 325.428406,309.316895 
	C324.010223,308.632324 323.016113,307.834625 322.021973,307.036957 
	C322.835114,306.293396 323.648224,305.549835 324.800842,304.674561 
z"/>
    <path fill="#1EE0F0" opacity="1.000000" stroke="none"
      d="
M315.877899,343.610229 
	C314.718506,344.837158 313.586487,345.628082 311.323547,347.209167 
	C311.550781,342.821381 311.684235,340.244812 311.816071,337.698975 
	C316.129639,336.871002 316.129639,336.871002 315.877899,343.610229 
z"/>
    <path fill="#1EE0F0" opacity="1.000000" stroke="none"
      d="
M320.783539,277.293152 
	C322.715271,278.515900 325.563812,279.797394 321.774475,282.540344 
	C319.826630,283.368561 318.114075,283.954773 316.025848,284.669617 
	C312.574341,279.021790 318.756622,279.620972 320.783539,277.293152 
z"/>
    <path fill="#5C00C4" opacity="1.000000" stroke="none"
      d="
M331.107544,264.347290 
	C331.622864,262.343140 333.031036,260.565857 332.881348,258.931244 
	C332.010559,249.421768 330.809692,239.941360 329.642212,230.460770 
	C329.199982,226.869598 328.549469,223.304062 328.272614,219.040878 
	C338.701324,217.234024 348.851257,216.113129 359.001221,214.992249 
	C361.340729,233.168411 363.680237,251.344574 366.154846,270.281189 
	C366.525543,272.075104 366.761108,273.108521 366.996643,274.141937 
	C366.997772,275.133606 366.998901,276.125275 366.656128,277.613770 
	C364.840515,280.477173 363.794891,282.701752 368.000366,283.176483 
	C368.000244,284.151520 368.000122,285.126587 367.613373,286.538422 
	C366.544556,288.011047 365.862396,289.046906 365.180237,290.082703 
	C366.453400,290.754730 367.726532,291.426758 368.999664,292.098755 
	C369.016632,292.923065 369.033569,293.747314 368.825562,295.153259 
	C367.788055,295.845398 366.975494,295.955841 366.162933,296.066315 
	C361.656311,291.137604 357.149689,286.208862 352.348602,281.128601 
	C345.129669,275.531403 338.205200,270.085724 331.107544,264.347290 
z"/>
    <path fill="#40DFEF" opacity="1.000000" stroke="none"
      d="
M366.138672,296.461243 
	C366.975494,295.955841 367.788055,295.845398 368.855194,295.564453 
	C370.859589,295.279877 372.609436,295.165741 374.287048,295.056305 
	C376.902954,300.822510 371.997864,299.531433 369.393341,300.769501 
	C365.693024,301.264893 366.303711,298.772858 366.138672,296.461243 
z"/>
    <path fill="#1EE0F0" opacity="1.000000" stroke="none"
      d="
M374.907837,311.370728 
	C377.491425,310.884491 379.756500,310.958893 379.856628,314.623444 
	C377.387268,315.930084 374.971954,316.852020 372.340271,317.856537 
	C371.592743,316.694122 370.827637,315.504364 369.902649,314.065979 
	C371.629822,313.219452 373.188568,312.455475 374.907837,311.370728 
z"/>
    <path fill="#40DFEF" opacity="1.000000" stroke="none"
      d="
M370.735779,304.105042 
	C372.644836,303.643311 374.229034,303.338989 375.813232,303.034668 
	C376.249939,303.324799 376.686646,303.614899 377.123383,303.905029 
	C376.348969,305.272400 375.574585,306.639801 374.426392,308.096436 
	C371.167603,309.031708 368.092010,310.374939 367.445282,305.230286 
	C368.300262,304.951263 369.355591,304.606873 370.735779,304.105042 
z"/>
    <path fill="#1EE0F0" opacity="1.000000" stroke="none"
      d="
M379.910370,318.371368 
	C381.285980,319.105316 382.499084,320.164246 383.738617,321.546387 
	C381.532715,323.188660 379.300385,324.507690 377.090759,325.813324 
	C373.826874,321.840515 373.971893,321.472626 379.910370,318.371368 
z"/>
    <path fill="#4700BF" opacity="1.000000" stroke="none"
      d="
M201.938477,254.801849 
	C204.632217,275.057281 207.295029,295.316925 210.029327,315.566864 
	C212.278137,332.221313 214.623199,348.862732 216.885712,365.515350 
	C217.062943,366.819977 216.926468,368.167236 216.896317,369.965088 
	C204.762070,362.157684 194.512222,351.918701 185.101318,340.353516 
	C184.598709,333.350281 184.523453,326.624756 183.750046,319.980530 
	C182.394989,308.339508 180.589432,296.751373 179.015579,285.135223 
	C177.973724,277.445618 177.006866,269.745850 176.456177,261.575745 
	C185.901840,261.591217 193.997086,258.502258 201.938477,254.801849 
z"/>
    <path fill="#9A8AEA" opacity="1.000000" stroke="none"
      d="
M202.140411,254.535660 
	C193.997086,258.502258 185.901840,261.591217 176.455566,261.165283 
	C173.276733,260.923492 170.548264,260.617249 167.819778,260.311005 
	C167.730316,259.873108 167.640869,259.435211 167.551422,258.997314 
	C174.547958,255.868835 181.544510,252.740356 188.782593,249.363037 
	C198.971466,246.231522 208.918793,243.348846 218.866119,240.466156 
	C219.167572,241.084351 219.469009,241.702560 219.770447,242.320755 
	C213.961075,246.303665 208.151718,250.286575 202.140411,254.535660 
z"/>
    <path fill="#C3C7FF" opacity="1.000000" stroke="none"
      d="
M448.915710,206.937836 
	C438.231201,207.369003 427.579926,207.350403 416.465576,206.790527 
	C416.328033,203.300888 417.147125,200.310272 416.899170,197.410919 
	C415.250916,178.136581 406.589722,163.489426 388.474884,155.226227 
	C387.454498,154.760773 386.769318,153.560410 386.128174,152.481598 
	C387.229431,151.507965 388.130646,150.754791 389.013306,149.997589 
	C388.994720,149.993530 388.997620,150.031433 389.344818,150.014877 
	C391.471497,148.667145 393.250977,147.335953 395.013367,146.000275 
	C394.996246,145.995789 395.001984,146.030670 395.353363,146.019226 
	C399.146759,143.006668 402.588776,140.005585 406.013123,136.999237 
	C405.995453,136.993988 405.996552,137.030884 406.266174,136.977539 
	C406.700836,136.615021 406.865845,136.305832 407.011871,135.994781 
	C406.992889,135.992920 406.996704,136.030853 407.266296,135.977509 
	C407.700867,135.614990 407.865845,135.305801 408.014709,134.994797 
	C407.998627,134.992981 408.003723,135.024002 408.319305,134.929932 
	C410.307709,133.176743 411.980530,131.517609 413.653351,129.858490 
	C439.495544,148.917801 451.418121,174.388489 448.915710,206.937836 
z"/>
    <path fill="#725CFF" opacity="1.000000" stroke="none"
      d="
M413.751038,129.576294 
	C411.980530,131.517609 410.307709,133.176743 408.228333,134.571808 
	C409.730011,132.062424 411.638306,129.817093 413.699280,127.714676 
	C413.851990,127.857582 414.158539,128.142166 414.158539,128.142166 
	C414.055298,128.526154 413.952026,128.910141 413.751038,129.576294 
z"/>
    <path fill="#725CFF" opacity="1.000000" stroke="none"
      d="
M418.181396,122.160095 
	C417.020569,124.029243 415.859741,125.898399 414.428741,127.954857 
	C414.158539,128.142166 413.851990,127.857582 413.811890,127.410416 
	C415.059967,125.198097 416.348145,123.432945 417.772400,121.791092 
	C417.908478,121.914398 418.181396,122.160103 418.181396,122.160095 
z"/>
    <path fill="#725CFF" opacity="1.000000" stroke="none"
      d="
M420.275482,118.256836 
	C419.751770,119.429375 419.228058,120.601913 418.442871,121.967285 
	C418.181396,122.160103 417.908478,121.914398 417.859924,121.472488 
	C417.889099,120.362549 417.966797,119.694504 418.044495,119.026459 
	C418.044495,119.026459 418.018311,118.992851 418.266846,118.936722 
	C418.695984,118.584778 418.876556,118.288956 419.057129,117.993126 
	C419.057129,117.993126 418.994293,117.998360 419.200958,117.960098 
	C419.407623,117.921837 419.818298,117.822617 419.932373,117.931381 
	C420.046478,118.040138 420.275482,118.256828 420.275482,118.256836 
z"/>
    <path fill="#725CFF" opacity="1.000000" stroke="none"
      d="
M421.247681,116.224045 
	C421.067902,116.771851 420.888153,117.319656 420.491943,118.062149 
	C420.275482,118.256828 420.046478,118.040138 419.974182,117.627083 
	C419.953522,116.804695 420.005157,116.395370 420.056793,115.986046 
	C420.056793,115.986046 419.992706,115.997475 420.216614,115.977264 
	C420.440521,115.957062 420.878510,115.882614 420.970490,115.968307 
	C421.062469,116.054008 421.247681,116.224045 421.247681,116.224045 
z"/>
    <path fill="#725CFF" opacity="1.000000" stroke="none"
      d="
M421.096283,113.987656 
	C421.096283,113.987656 421.579834,114.020866 421.822205,114.023926 
	C421.945618,114.621773 421.826660,115.216560 421.477692,116.017700 
	C421.247681,116.224045 421.062469,116.054008 420.992310,115.652290 
	C420.980164,114.829597 421.038208,114.408630 421.096283,113.987656 
z"/>
    <path fill="#BEB5FF" opacity="1.000000" stroke="none"
      d="
M242.011078,230.192078 
	C241.378159,230.233719 240.745255,230.275360 239.795898,230.331726 
	C237.999954,225.242615 235.781372,220.221939 235.195786,215.017502 
	C233.999176,204.382797 233.115662,193.645538 233.186310,182.957672 
	C233.239197,174.957779 234.987671,166.969070 235.999237,158.576660 
	C248.733444,160.470764 261.449585,162.763626 274.529114,165.491302 
	C269.972992,182.988922 271.331879,200.097519 274.621429,217.195206 
	C274.970886,219.011475 275.997131,220.697510 276.330994,222.622009 
	C264.638763,225.264069 253.324921,227.728073 242.011078,230.192078 
z"/>
    <path fill="#9B8CFF" opacity="1.000000" stroke="none"
      d="
M296.017883,165.855804 
	C287.637146,164.886368 279.256439,163.916946 270.448242,162.908905 
	C271.999817,161.054199 273.785126,158.950180 275.988434,157.467239 
	C294.556702,144.969864 314.622589,135.945740 336.275513,129.944031 
	C358.971252,123.653290 381.954773,122.227196 405.252808,123.034721 
	C407.214569,123.102715 409.159668,123.649628 411.396851,124.284454 
	C407.760620,128.391724 403.840057,132.188568 399.469910,135.990417 
	C386.640808,135.012711 374.201080,133.816513 362.006073,137.063339 
	C349.902435,140.285812 337.813568,143.664551 325.959808,147.686661 
	C318.953247,150.064041 312.280426,153.568527 305.717438,157.055374 
	C301.861816,159.103806 296.679108,160.119461 296.017883,165.855804 
z"/>
    <path fill="#BEB5FF" opacity="1.000000" stroke="none"
      d="
M399.919495,135.985413 
	C403.840057,132.188568 407.760620,128.391724 411.816833,124.293823 
	C413.752930,122.334496 415.553406,120.676231 417.699219,119.022217 
	C417.966797,119.694504 417.889099,120.362549 417.723877,121.349190 
	C416.348145,123.432945 415.059967,125.198097 413.659180,127.267502 
	C411.638306,129.817093 409.730011,132.062424 407.912720,134.665878 
	C408.003723,135.024002 407.998627,134.992981 407.719055,135.006775 
	C407.291901,135.357346 407.144287,135.694092 406.996704,136.030853 
	C406.996704,136.030853 406.992889,135.992920 406.716309,136.007294 
	C406.292023,136.358093 406.144287,136.694489 405.996552,137.030884 
	C405.996552,137.030884 405.995453,136.993988 405.653625,136.909332 
	C401.875183,139.893341 398.438599,142.962006 395.001984,146.030670 
	C395.001984,146.030670 394.996246,145.995789 394.648254,145.920563 
	C392.532715,147.240707 390.765167,148.636078 388.997620,150.031433 
	C388.997620,150.031433 388.994720,149.993530 388.632019,149.915955 
	C386.545654,150.268494 384.822052,150.698608 383.191101,150.800446 
	C388.829010,145.643280 394.374237,140.814346 399.919495,135.985413 
z"/>
    <path fill="#BEB5FF" opacity="1.000000" stroke="none"
      d="
M420.824127,114.145966 
	C421.038208,114.408630 420.980164,114.829597 420.900330,115.566589 
	C420.878510,115.882614 420.440521,115.957062 420.224426,116.008865 
	C420.189545,115.475212 420.370758,114.889748 420.824127,114.145966 
z"/>
    <path fill="#BEB5FF" opacity="1.000000" stroke="none"
      d="
M419.780853,116.137733 
	C420.005157,116.395370 419.953522,116.804695 419.860107,117.518326 
	C419.818298,117.822617 419.407623,117.921837 419.207886,117.990860 
	C419.173706,117.469727 419.339294,116.879570 419.780853,116.137733 
z"/>
    <path fill="#BEB5FF" opacity="1.000000" stroke="none"
      d="
M418.806702,118.078171 
	C418.876556,118.288956 418.695984,118.584778 418.264038,118.957756 
	C418.193878,118.744339 418.375092,118.453773 418.806702,118.078171 
z"/>
    <path fill="#C1BFFF" opacity="1.000000" stroke="none"
      d="
M276.709412,222.443954 
	C275.997131,220.697510 274.970886,219.011475 274.621429,217.195206 
	C271.331879,200.097519 269.972992,182.988922 274.951050,165.559158 
	C288.407501,166.183197 301.805389,167.174179 315.507385,168.627472 
	C310.088531,169.410767 304.362579,169.687805 298.644287,170.077637 
	C296.760803,170.206055 294.897217,170.626083 293.024506,170.912766 
	C293.090576,171.137756 293.156647,171.362747 293.222717,171.587723 
	C298.150085,172.047791 303.077423,172.507843 308.002869,173.403046 
	C307.980072,174.668457 308.102936,175.532486 307.916992,176.323944 
	C304.693390,190.043686 305.843506,203.529663 309.695129,216.971191 
	C308.577484,217.352631 307.768951,217.627441 306.524780,217.866837 
	C296.295898,219.368912 286.502655,220.906433 276.709412,222.443954 
z"/>
    <path fill="#A092FF" opacity="1.000000" stroke="none"
      d="
M399.469910,135.990433 
	C394.374237,140.814346 388.829010,145.643280 383.165161,150.781830 
	C383.046539,151.091476 383.036591,151.029129 382.799316,151.120544 
	C382.381897,151.489624 382.201813,151.767273 382.019592,152.019836 
	C382.017487,151.994736 382.044922,152.038010 381.713623,152.037796 
	C380.587219,152.710953 379.792114,153.384308 378.997345,154.027344 
	C378.997711,153.997025 379.056427,154.012177 378.745117,154.031967 
	C377.954315,154.389420 377.474823,154.727097 377.002319,155.364502 
	C377.009674,155.864090 377.009979,156.063950 376.879822,156.496414 
	C376.503448,157.194000 376.257507,157.658981 375.738556,158.099274 
	C375.288513,158.029007 375.111511,157.983414 374.696838,157.669434 
	C368.951660,158.884155 363.426086,160.305511 357.952148,161.903732 
	C356.887238,162.214661 356.023346,163.214035 354.637512,163.976685 
	C349.812408,164.705933 345.416473,165.354370 341.020569,166.002808 
	C326.327362,165.980453 311.634125,165.958084 296.479401,165.895767 
	C296.679108,160.119461 301.861816,159.103806 305.717438,157.055374 
	C312.280426,153.568527 318.953247,150.064041 325.959808,147.686661 
	C337.813568,143.664551 349.902435,140.285812 362.006073,137.063339 
	C374.201080,133.816513 386.640808,135.012711 399.469910,135.990433 
z"/>
    <path fill="#F3EDFE" opacity="1.000000" stroke="none"
      d="
M340.811584,166.352692 
	C345.416473,165.354370 349.812408,164.705933 355.025574,163.980682 
	C362.206696,161.915176 368.570618,159.926514 374.934509,157.937836 
	C375.111511,157.983414 375.288513,158.029007 375.949585,158.327301 
	C378.360718,158.119781 380.287781,157.659515 382.214813,157.199265 
	C381.644714,158.566116 380.897156,159.541977 379.913544,159.952957 
	C373.355804,162.692825 366.859863,165.654175 360.121063,167.864304 
	C354.538116,169.695358 348.649445,170.594330 342.439819,171.921860 
	C330.657196,172.280930 319.330994,172.624405 308.004791,172.967896 
	C303.077423,172.507843 298.150085,172.047791 293.222717,171.587723 
	C293.156647,171.362747 293.090576,171.137756 293.024506,170.912766 
	C294.897217,170.626083 296.760803,170.206055 298.644287,170.077637 
	C304.362579,169.687805 310.088531,169.410767 315.971893,168.737747 
	C324.289062,167.824661 332.445831,167.263626 340.811584,166.352692 
z"/>
    <path fill="#B0A2FD" opacity="1.000000" stroke="none"
      d="
M236.421234,646.051270 
	C236.373932,641.954956 236.669312,637.900391 237.338501,633.464478 
	C238.599579,633.980408 239.682663,634.753235 240.343857,635.794128 
	C246.935699,646.171631 253.458038,656.593262 260.000000,667.002441 
	C263.371094,671.863708 266.360413,677.050720 270.180664,681.528809 
	C285.218231,699.155762 301.831665,715.090027 321.789642,727.159119 
	C326.189056,729.819519 330.966736,731.848145 335.509949,734.280334 
	C337.065613,735.113098 338.437012,736.290100 339.945679,737.654968 
	C326.596161,733.246582 314.377319,726.234985 303.218658,717.567322 
	C292.789093,709.466064 282.821167,700.761597 272.801453,692.146545 
	C269.204102,689.053528 266.048279,685.447021 262.346466,682.042297 
	C261.827271,681.452454 261.652557,680.895203 261.193237,679.848816 
	C260.272156,678.911377 259.635712,678.463013 258.999268,678.014648 
	C254.859787,672.063171 250.723099,666.109741 246.579926,660.160828 
	C243.312073,655.468689 240.036224,650.782104 236.421234,646.051270 
z"/>
    <path fill="#B5AEFF" opacity="1.000000" stroke="none"
      d="
M259.042603,678.331787 
	C259.635712,678.463013 260.272156,678.911377 260.948181,679.678833 
	C260.353851,679.548218 259.719879,679.098572 259.042603,678.331787 
z"/>
    <path fill="#BFC7FC" opacity="1.000000" stroke="none"
      d="
M443.982361,561.700317 
	C441.097809,567.498718 438.234619,573.017334 435.248108,578.468506 
	C432.157196,584.110168 428.585510,589.517090 425.863770,595.326416 
	C420.217285,607.378418 412.299072,617.431030 399.536926,621.814026 
	C382.210663,627.764526 366.418182,623.611206 352.944000,611.381348 
	C333.830658,594.033142 325.986603,571.915344 327.130493,546.571960 
	C327.635559,535.381714 331.047607,524.755920 337.222260,515.190308 
	C338.564697,513.110657 339.693329,510.892975 341.423584,508.372620 
	C355.976593,507.960083 370.026398,507.913879 384.519348,507.882904 
	C390.003265,507.991150 395.089325,508.548523 400.073822,508.063049 
	C406.734741,507.414276 413.316864,505.956421 419.932861,504.846069 
	C423.042389,507.600555 426.144897,510.363007 429.266113,513.104187 
	C430.112274,513.847290 431.015015,514.526001 431.591675,515.560547 
	C423.599609,512.020386 415.493378,509.416504 406.845795,510.116791 
	C385.181061,511.871155 368.027740,521.667358 357.272705,540.750916 
	C348.518860,556.283508 349.515869,574.277527 364.242859,585.746948 
	C373.838257,593.219849 384.973816,594.930115 396.794128,593.097656 
	C417.759521,589.847290 432.762604,578.303833 442.888275,559.971863 
	C443.242035,560.444885 443.595795,560.917847 443.982361,561.700317 
z"/>
    <path fill="#3EECB4" opacity="1.000000" stroke="none"
      d="
M442.934296,559.584106 
	C432.762604,578.303833 417.759521,589.847290 396.794128,593.097656 
	C384.973816,594.930115 373.838257,593.219849 364.242859,585.746948 
	C349.515869,574.277527 348.518860,556.283508 357.272705,540.750916 
	C368.027740,521.667358 385.181061,511.871155 406.845795,510.116791 
	C415.493378,509.416504 423.599609,512.020386 431.657440,515.894531 
	C434.253296,518.094727 436.697113,520.110962 438.675446,522.510986 
	C446.390137,531.870056 447.826538,542.499329 444.591766,553.958679 
	C444.095612,555.716187 443.519470,557.451050 442.934296,559.584106 
M393.333282,570.270142 
	C392.548096,571.494690 391.762878,572.719238 390.383209,574.281677 
	C389.305939,575.863464 388.228668,577.445312 387.038910,579.192261 
	C395.710632,581.275391 404.373657,579.663025 411.241455,574.583069 
	C409.015533,572.134827 406.905273,569.658875 404.631500,567.343506 
	C399.007294,561.616394 398.566223,561.689575 394.332275,568.530640 
	C394.078552,568.940552 394.013336,569.467102 393.333282,570.270142 
M375.293854,538.197388 
	C364.432068,549.666077 364.093048,567.376221 375.187714,573.178467 
	C380.572357,565.544128 386.035614,557.851929 391.441162,550.119324 
	C396.918915,542.283569 402.408447,542.140198 408.679291,549.395081 
	C412.591431,553.921021 416.809814,558.203857 421.159729,562.310913 
	C421.990112,563.094910 424.899719,563.210632 425.462158,562.514038 
	C433.738586,552.263550 434.018646,533.873840 419.294250,526.539612 
	C413.110199,523.459412 406.644348,523.281616 400.268188,524.132996 
	C390.477997,525.440430 381.965149,529.677795 376.002136,537.991455 
	C376.002136,537.991455 375.906036,537.901550 375.293854,538.197388 
z"/>
    <path fill="#FAF7FF" opacity="1.000000" stroke="none"
      d="
M420.194092,504.603210 
	C413.316864,505.956421 406.734741,507.414276 400.073822,508.063049 
	C395.089325,508.548523 390.003265,507.991150 384.462067,507.566467 
	C382.956390,506.148132 381.951080,505.061462 380.945770,503.974762 
	C384.815430,503.424957 388.671326,502.736328 392.557251,502.350281 
	C406.691833,500.946045 420.836487,499.643036 435.125946,498.287781 
	C434.766968,498.957245 434.400970,499.639862 433.958374,500.626038 
	C429.406342,502.073242 424.930817,503.216827 420.194092,504.603210 
z"/>
    <path fill="#E6D6FF" opacity="1.000000" stroke="none"
      d="
M380.482666,503.977722 
	C381.951080,505.061462 382.956390,506.148132 384.018982,507.551270 
	C370.026398,507.913879 355.976593,507.960083 341.459137,508.019287 
	C332.241638,507.129120 323.491730,506.225983 314.366852,505.174622 
	C306.286560,503.667175 298.581238,502.307861 290.454102,500.933228 
	C285.569946,499.382111 281.107635,497.846313 275.466003,495.904663 
	C288.820343,497.727234 300.957764,499.383728 313.549042,501.058228 
	C317.509430,501.716797 321.003479,502.825378 324.524658,502.919586 
	C343.019196,503.414612 361.520569,503.653107 380.482666,503.977722 
z"/>
    <path fill="#A992FF" opacity="1.000000" stroke="none"
      d="
M260.346466,667.038086 
	C253.458038,656.593262 246.935699,646.171631 240.343857,635.794128 
	C239.682663,634.753235 238.599579,633.980408 237.362549,633.041565 
	C237.018158,630.302734 237.023529,627.605469 237.409698,624.463501 
	C239.172272,625.310303 240.882248,626.389160 241.880615,627.929260 
	C246.931870,635.721436 251.616348,643.755737 256.797058,651.457886 
	C259.929077,656.114319 263.573792,660.461304 267.330475,664.639587 
	C268.393036,665.821411 270.661469,665.919006 272.376862,666.513794 
	C272.634399,664.702026 273.198364,662.868591 273.071747,661.084045 
	C272.914673,658.870728 271.454193,656.563232 271.828613,654.530640 
	C273.592255,644.955688 275.821655,635.467285 277.807526,625.931885 
	C278.176666,624.159302 277.786682,622.151489 278.435425,620.527161 
	C282.159607,611.202393 286.100037,601.964233 289.946930,592.688354 
	C291.009674,590.125793 292.003662,587.534790 293.329681,585.124146 
	C294.571106,586.833435 295.578278,588.339294 296.441742,589.923401 
	C300.631226,597.609436 304.782166,605.316467 308.995605,613.367676 
	C309.697235,615.479553 310.350037,617.239746 311.002808,619.000000 
	C308.936493,623.812317 306.842743,628.613281 304.828979,633.447449 
	C304.462769,634.326538 303.952728,635.593750 304.306641,636.254883 
	C307.566711,642.346069 303.783875,646.998352 301.469269,652.052368 
	C300.740845,653.642883 300.715729,655.691284 300.831787,657.500427 
	C300.998779,660.103149 301.972046,662.685059 301.928680,665.264648 
	C301.786652,673.712036 301.100403,682.156128 301.165771,690.597351 
	C301.184082,692.960632 303.255920,695.249756 304.046295,697.683167 
	C304.705170,699.711670 304.867126,701.901550 305.249176,704.019958 
	C303.295685,703.738037 300.919525,704.066833 299.466827,703.061401 
	C294.851715,699.867126 290.244019,696.519409 286.247772,692.604004 
	C278.214569,684.733154 270.596619,676.439087 262.772827,668.352966 
	C262.224518,667.786316 261.392822,667.493835 260.346466,667.038086 
z"/>
    <path fill="#C3C7FF" opacity="1.000000" stroke="none"
      d="
M311.279877,619.207458 
	C310.350037,617.239746 309.697235,615.479553 309.285278,613.109863 
	C310.329956,610.346558 311.133759,608.192688 311.937561,606.038879 
	C325.096619,630.773132 335.082184,656.676941 340.513763,684.224670 
	C341.236542,687.890442 341.244751,691.697021 341.298462,695.702393 
	C337.019775,684.195374 333.421295,672.271423 328.931488,660.692993 
	C323.536346,646.779968 317.382355,633.161133 311.279877,619.207458 
z"/>
    <path fill="#A38AFF" opacity="1.000000" stroke="none"
      d="
M293.029205,584.956848 
	C292.003662,587.534790 291.009674,590.125793 289.946930,592.688354 
	C286.100037,601.964233 282.159607,611.202393 278.435425,620.527161 
	C277.786682,622.151489 278.176666,624.159302 277.807526,625.931885 
	C275.821655,635.467285 273.592255,644.955688 271.828613,654.530640 
	C271.454193,656.563232 272.914673,658.870728 273.071747,661.084045 
	C273.198364,662.868591 272.634399,664.702026 272.376862,666.513794 
	C270.661469,665.919006 268.393036,665.821411 267.330475,664.639587 
	C263.573792,660.461304 259.929077,656.114319 256.797058,651.457886 
	C251.616348,643.755737 246.931870,635.721436 241.880615,627.929260 
	C240.882248,626.389160 239.172272,625.310303 237.433472,624.014771 
	C237.071030,619.987915 237.065598,615.965149 237.097595,611.482605 
	C238.697495,612.220154 240.592819,613.162292 241.749023,614.670959 
	C243.787598,617.330933 245.375259,620.336426 247.151672,623.197327 
	C247.770966,623.149658 248.390259,623.101990 249.009552,623.054382 
	C250.004379,620.240479 250.944473,617.405762 252.006882,614.617676 
	C253.586304,610.472839 255.248184,606.359375 256.882751,602.235596 
	C257.961487,599.514221 258.872314,596.707520 260.175537,594.097473 
	C263.561554,587.316284 266.934784,580.515320 270.686066,573.934937 
	C272.865479,570.111816 275.764069,566.698730 278.686279,563.048523 
	C281.170319,565.870911 283.307129,568.745972 285.859772,572.127686 
	C288.526794,576.741821 290.778015,580.849304 293.029205,584.956848 
z"/>
    <path fill="#B7A0FF" opacity="1.000000" stroke="none"
      d="
M267.105408,545.271484 
	C267.424164,545.007141 267.862061,545.012207 268.627136,545.031494 
	C268.969299,545.482727 268.984375,545.919861 269.000183,546.685669 
	C268.408844,546.523193 267.816711,546.032043 267.105408,545.271484 
z"/>
    <path fill="#B7A0FF" opacity="1.000000" stroke="none"
      d="
M269.009277,547.298706 
	C269.320038,547.466431 269.652893,547.939392 270.022949,548.714722 
	C269.717194,548.546021 269.374268,548.074951 269.009277,547.298706 
z"/>
    <path fill="#B7A0FF" opacity="1.000000" stroke="none"
      d="
M266.097046,544.220520 
	C266.322998,544.088684 266.591614,544.275879 266.897552,544.786377 
	C266.673157,544.912354 266.408112,544.722290 266.097046,544.220520 
z"/>
    <path fill="#B7A0FF" opacity="1.000000" stroke="none"
      d="
M265.099243,543.221008 
	C265.323822,543.090027 265.591980,543.276855 265.897278,543.786682 
	C265.676575,543.907776 265.412689,543.717468 265.099243,543.221008 
z"/>
    <path fill="#B6B2FF" opacity="1.000000" stroke="none"
      d="
M308.954590,730.682495 
	C308.358490,730.549622 307.720612,730.096436 307.038696,729.324036 
	C307.634064,729.457275 308.273468,729.909729 308.954590,730.682495 
z"/>
    <path fill="#B6B2FF" opacity="1.000000" stroke="none"
      d="
M314.956055,734.679993 
	C314.360199,734.547791 313.721619,734.095520 313.038910,733.324097 
	C313.634308,733.456543 314.273834,733.908264 314.956055,734.679993 
z"/>
    <path fill="#BFB8FF" opacity="1.000000" stroke="none"
      d="
M293.329681,585.124146 
	C290.778015,580.849304 288.526794,576.741821 286.130554,572.322632 
	C286.481689,571.420105 286.977875,570.829346 287.741516,570.114502 
	C288.434082,570.013489 288.859192,570.036438 289.601440,570.082153 
	C290.047485,570.395813 290.235107,570.642090 290.678162,570.968994 
	C291.335205,572.044373 291.795532,572.994263 292.588318,574.020264 
	C293.047058,574.390686 293.234680,574.638550 293.681946,574.964722 
	C293.907715,575.516602 293.935089,575.943787 293.975952,576.692444 
	C294.755768,577.992065 295.522064,578.970093 296.596130,580.020386 
	C297.095215,580.626953 297.286530,581.161377 297.708221,581.869629 
	C298.421478,582.940674 298.904327,583.837769 299.663757,584.890137 
	C301.415833,587.598572 302.891327,590.151855 304.659912,592.870239 
	C307.201965,597.153809 309.450928,601.272095 311.818726,605.714661 
	C311.133759,608.192688 310.329956,610.346558 309.236450,612.758240 
	C304.782166,605.316467 300.631226,597.609436 296.441742,589.923401 
	C295.578278,588.339294 294.571106,586.833435 293.329681,585.124146 
z"/>
    <path fill="#40DFEF" opacity="1.000000" stroke="none"
      d="
M457.201508,278.482788 
	C460.207947,277.955627 463.145111,277.780670 466.469696,277.582672 
	C466.639069,278.968964 466.809143,280.361267 467.054779,282.371857 
	C464.164307,282.575836 461.611359,282.756012 458.624176,282.926392 
	C457.837341,281.556122 457.484772,280.195587 457.201508,278.482788 
z"/>
    <path fill="#40DFEF" opacity="1.000000" stroke="none"
      d="
M454.268921,262.109955 
	C455.691040,261.551788 457.095428,261.552307 458.161499,260.951935 
	C462.293091,258.625214 462.859283,261.225128 463.387878,264.608887 
	C460.766479,265.409637 458.282928,266.168243 455.420197,266.896057 
	C454.725922,265.374359 454.410858,263.883484 454.268921,262.109955 
z"/>
    <path fill="#40DFEF" opacity="1.000000" stroke="none"
      d="
M436.566956,235.466949 
	C437.724854,233.859589 438.681610,232.540726 439.817352,230.975113 
	C441.159027,231.840302 442.356537,232.612534 444.062592,233.712708 
	C442.197815,236.047806 440.503143,238.169876 438.741089,240.376343 
	C436.189362,239.602951 434.073456,238.823746 436.566956,235.466949 
z"/>
    <path fill="#40DFEF" opacity="1.000000" stroke="none"
      d="
M454.127686,253.388641 
	C457.693176,250.567276 459.127350,252.314575 460.070099,255.879700 
	C458.213440,256.854340 456.406433,257.802917 454.301392,258.958984 
	C452.739929,258.453125 451.476471,257.739777 449.381805,256.557129 
	C451.632019,255.125580 452.783173,254.393250 454.127686,253.388641 
z"/>
    <path fill="#40DFEF" opacity="1.000000" stroke="none"
      d="
M459.654114,311.916321 
	C460.954285,312.480042 461.906860,313.078979 463.001526,313.767242 
	C462.472748,315.078918 461.982574,316.294800 461.242126,317.732910 
	C458.486237,316.829041 455.980591,315.702911 453.287079,314.492340 
	C453.724762,313.115082 454.100708,311.932068 454.565186,310.470459 
	C456.322113,311.019287 457.814331,311.485413 459.654114,311.916321 
z"/>
    <path fill="#40DFEF" opacity="1.000000" stroke="none"
      d="
M451.878967,244.469971 
	C455.410980,245.265259 457.094025,246.777115 453.247375,249.883789 
	C451.562653,250.853012 450.124268,251.615326 448.482208,252.485611 
	C447.709198,251.361801 446.993347,250.321030 446.056152,248.958511 
	C448.041931,247.477798 449.873383,246.112183 451.878967,244.469971 
z"/>
    <path fill="#40DFEF" opacity="1.000000" stroke="none"
      d="
M440.625305,322.365875 
	C439.218658,322.882446 437.921051,323.005554 436.623413,323.128662 
	C436.636902,320.563293 436.464691,317.970551 436.835266,315.457855 
	C436.901855,315.006500 439.207031,314.885315 441.127655,314.472015 
	C440.970306,317.472382 440.852295,319.722412 440.625305,322.365875 
z"/>
    <path fill="#40DFEF" opacity="1.000000" stroke="none"
      d="
M435.591583,229.790741 
	C433.324524,231.836929 434.111359,238.460220 428.209503,234.219101 
	C429.314789,231.591064 430.372253,229.076721 431.810913,225.656052 
	C433.462982,227.254196 434.611664,228.365387 435.591583,229.790741 
z"/>
    <path fill="#40DFEF" opacity="1.000000" stroke="none"
      d="
M456.195679,270.455078 
	C458.950623,269.638580 461.677155,269.176117 464.666870,268.669006 
	C465.078918,270.224060 465.437866,271.578613 465.881989,273.254669 
	C463.010406,273.848969 460.484497,274.371704 457.568451,274.908569 
	C456.841309,273.551483 456.504303,272.180267 456.195679,270.455078 
z"/>
    <path fill="#40DFEF" opacity="1.000000" stroke="none"
      d="
M449.611206,239.077606 
	C450.018768,239.572128 450.132599,239.909164 450.378967,240.362030 
	C448.421051,242.309509 446.330597,244.141144 443.553619,246.574326 
	C442.763672,245.289215 442.095551,244.202286 441.427429,243.115356 
	C440.991730,242.743851 440.556030,242.372330 440.120331,242.000824 
	C442.116150,240.563980 444.008057,238.926193 446.169037,237.808746 
	C446.845978,237.458725 448.247589,238.510162 449.611206,239.077606 
z"/>
    <path fill="#40DFEF" opacity="1.000000" stroke="none"
      d="
M456.538635,326.591797 
	C454.647034,326.363129 453.086060,325.962524 451.314972,325.507996 
	C451.634796,323.191681 451.919556,321.129242 452.292908,318.425232 
	C454.709991,319.481110 456.855621,320.418396 459.625458,321.628357 
	C458.580322,323.445251 457.724823,324.932556 456.538635,326.591797 
z"/>
    <path fill="#40DFEF" opacity="1.000000" stroke="none"
      d="
M422.948425,232.900833 
	C422.170288,230.099640 421.788483,227.351959 421.304077,223.865921 
	C423.987305,224.143082 425.482727,224.297546 428.578979,224.617355 
	C426.444763,228.016708 424.894775,230.485535 422.948425,232.900833 
z"/>
    <path fill="#40DFEF" opacity="1.000000" stroke="none"
      d="
M424.953125,322.547028 
	C423.491425,322.789429 420.920532,322.864197 420.802368,322.361938 
	C420.257385,320.045502 420.318634,317.563812 420.459045,315.158691 
	C420.468567,314.995544 422.915527,314.974670 424.563965,315.054352 
	C424.923920,317.518585 424.948792,319.816132 424.953125,322.547028 
z"/>
    <path fill="#40DFEF" opacity="1.000000" stroke="none"
      d="
M458.006287,295.399384 
	C460.761749,295.095428 463.488739,295.095428 466.524689,295.095428 
	C467.549591,302.106903 462.828796,299.482727 459.539825,299.639648 
	C458.728943,298.298553 458.353363,297.000946 458.006287,295.399384 
z"/>
    <path fill="#40DFEF" opacity="1.000000" stroke="none"
      d="
M444.104431,323.420044 
	C444.302155,320.623535 444.604767,318.215240 444.958282,315.402008 
	C446.590057,315.689850 447.797668,315.902863 448.993958,316.113892 
	C449.001221,324.259674 448.463989,325.105804 444.104431,323.420044 
z"/>
    <path fill="#40DFEF" opacity="1.000000" stroke="none"
      d="
M458.467712,286.692474 
	C460.092743,286.314240 461.606781,286.415100 463.086243,286.233612 
	C466.470306,285.818604 467.792023,287.075714 466.634094,290.941589 
	C464.195251,290.941589 461.586945,290.941589 458.535492,290.856873 
	C458.175232,289.529205 458.258118,288.286255 458.467712,286.692474 
z"/>
    <path fill="#40DFEF" opacity="1.000000" stroke="none"
      d="
M458.625549,302.888062 
	C460.852722,303.395721 462.704163,303.942841 464.682251,304.527374 
	C465.588776,307.827240 464.791382,309.592407 460.515808,308.681702 
	C455.038239,306.374786 454.854126,305.808655 458.625549,302.888062 
z"/>
    <path fill="#40DFEF" opacity="1.000000" stroke="none"
      d="
M432.945129,318.081360 
	C433.082214,321.447876 433.033447,324.178009 428.467682,322.567139 
	C428.467682,320.075592 428.467682,317.484131 428.467682,314.631927 
	C431.363098,313.617828 433.327759,313.746674 432.945129,318.081360 
z"/>
    <path fill="#40DFEF" opacity="1.000000" stroke="none"
      d="
M387.622986,235.042603 
	C387.332977,234.484970 387.312012,234.097305 387.321533,233.419739 
	C388.464264,232.467468 389.576538,231.805115 391.135742,230.876617 
	C392.714294,233.123734 394.269318,235.337341 396.067078,237.896545 
	C394.880676,238.832977 393.817566,239.672119 392.641571,240.600342 
	C390.893280,238.617111 389.392670,236.914856 387.622986,235.042603 
z"/>
    <path fill="#40DFEF" opacity="1.000000" stroke="none"
      d="
M397.618408,226.926849 
	C399.672546,228.975647 401.407288,231.147873 403.141998,233.320099 
	C402.902161,233.889603 402.662323,234.459106 402.422485,235.028610 
	C400.948883,234.875092 398.247528,234.892105 398.198730,234.540649 
	C397.854370,232.061890 392.140015,230.060242 397.618408,226.926849 
z"/>
    <path fill="#40DFEF" opacity="1.000000" stroke="none"
      d="
M388.072876,245.536621 
	C385.502411,244.295074 383.060944,242.761215 379.975494,240.822739 
	C381.723755,239.259399 382.867249,238.236862 384.341248,237.187805 
	C385.983337,238.564667 387.599060,239.802231 388.489166,241.435303 
	C389.000793,242.373886 388.336731,243.953339 388.072876,245.536621 
z"/>
    <path fill="#40DFEF" opacity="1.000000" stroke="none"
      d="
M407.186188,223.943115 
	C408.347595,226.297775 409.278168,228.636200 409.733521,231.063751 
	C409.816254,231.504562 407.954346,232.310135 406.990143,232.947296 
	C405.983124,230.864822 404.709137,228.851761 404.138153,226.655899 
	C403.975098,226.028870 405.851257,224.871597 407.186188,223.943115 
z"/>
    <path fill="#40DFEF" opacity="1.000000" stroke="none"
      d="
M405.204224,324.632629 
	C404.625183,322.068054 404.152649,319.865326 403.619232,317.378845 
	C405.100616,316.999939 406.299072,316.693390 407.936005,316.274658 
	C408.556305,319.113861 409.133392,321.755310 409.900574,325.266754 
	C408.069031,325.158112 406.689911,325.076324 405.204224,324.632629 
z"/>
    <path fill="#40DFEF" opacity="1.000000" stroke="none"
      d="
M417.030457,322.399414 
	C415.991364,323.385132 414.958771,323.964722 413.368225,324.857452 
	C412.843933,322.316833 412.092926,320.406891 412.194916,318.543610 
	C412.259308,317.367706 413.598663,316.261597 414.366150,315.124176 
	C415.190002,316.086853 416.328278,316.930115 416.751801,318.044891 
	C417.200714,319.226562 416.970520,320.666229 417.030457,322.399414 
z"/>
    <path fill="#40DFEF" opacity="1.000000" stroke="none"
      d="
M399.340942,327.928528 
	C398.121124,325.146301 397.242950,322.218933 396.681335,319.076050 
	C398.261383,319.551208 400.461670,320.088470 400.604828,320.962646 
	C400.968811,323.184967 404.239929,326.175873 399.340942,327.928528 
z"/>
    <path fill="#35009A" opacity="1.000000" stroke="none"
      d="
M306.960388,217.902267 
	C307.768951,217.627441 308.577484,217.352631 310.102356,217.011353 
	C321.578125,215.486267 332.337555,214.027649 343.549988,212.582138 
	C356.001831,211.528870 368.000763,210.462479 379.999664,209.396088 
	C380.002197,210.337402 380.004761,211.278717 380.016235,212.570312 
	C373.270447,213.500916 366.515686,214.081207 359.381104,214.826874 
	C348.851257,216.113129 338.701324,217.234024 328.265503,218.609589 
	C321.272919,219.576538 314.566132,220.288834 307.428314,220.614990 
	C306.984985,219.453339 306.972687,218.677811 306.960388,217.902267 
z"/>
    <path fill="#40DFEF" opacity="1.000000" stroke="none"
      d="
M380.356689,255.552368 
	C380.258118,257.017120 379.927948,258.220734 379.448151,259.969818 
	C376.527557,258.753998 374.012878,257.707184 371.173553,256.525208 
	C371.749237,255.008087 372.245056,253.701462 372.991974,251.733124 
	C375.554657,253.011414 377.839905,254.151321 380.356689,255.552368 
z"/>
    <path fill="#40DFEF" opacity="1.000000" stroke="none"
      d="
M367.389221,274.146118 
	C366.761108,273.108521 366.525543,272.075104 366.242279,270.705536 
	C369.223969,270.369385 372.253326,270.369385 375.813904,270.369385 
	C374.819305,277.223206 370.799683,274.446686 367.389221,274.146118 
z"/>
    <path fill="#40DFEF" opacity="1.000000" stroke="none"
      d="
M382.696594,247.245132 
	C383.318695,248.967148 383.663025,250.484131 384.007385,252.001114 
	C383.486115,252.182419 382.964874,252.363739 382.443604,252.545044 
	C380.091766,251.152771 377.739929,249.760498 375.115814,248.207047 
	C376.071625,246.698669 376.834137,245.495377 377.778259,244.005493 
	C379.450928,245.099304 380.934906,246.069702 382.696594,247.245132 
z"/>
    <path fill="#40DFEF" opacity="1.000000" stroke="none"
      d="
M372.912109,261.273956 
	C374.632965,261.949097 376.007385,262.502289 377.351318,263.043243 
	C376.552521,267.907806 375.725494,268.049866 368.184296,264.570068 
	C368.929352,262.472076 368.552765,259.299744 372.912109,261.273956 
z"/>
    <path fill="#40DFEF" opacity="1.000000" stroke="none"
      d="
M368.416870,283.117432 
	C363.794891,282.701752 364.840515,280.477173 366.656067,277.985657 
	C368.451141,278.012817 369.901062,278.178650 371.353851,278.314301 
	C374.509766,278.608948 375.278503,280.108673 373.561066,283.058380 
	C372.052765,283.058380 370.443054,283.058380 368.416870,283.117432 
z"/>
    <path fill="#40DFEF" opacity="1.000000" stroke="none"
      d="
M369.411987,292.008453 
	C367.726532,291.426758 366.453400,290.754730 365.180237,290.082703 
	C365.862396,289.046906 366.544556,288.011047 367.613586,286.904053 
	C369.779999,286.926147 371.559540,287.019348 373.437744,287.117737 
	C375.367310,291.171051 373.149750,291.957764 369.411987,292.008453 
z"/>
    <path fill="#C6CFFF" opacity="1.000000" stroke="none"
      d="
M380.439819,209.279724 
	C368.000763,210.462479 356.001831,211.528870 343.505249,212.154099 
	C338.855652,199.728958 338.623322,187.818954 343.417908,175.906113 
	C343.855469,174.818924 343.098511,173.250961 342.896240,171.906265 
	C348.649445,170.594330 354.538116,169.695358 360.121063,167.864304 
	C366.859863,165.654175 373.355804,162.692825 379.913544,159.952957 
	C380.897156,159.541977 381.644714,158.566116 382.214813,157.199265 
	C380.287781,157.659515 378.360718,158.119781 376.222656,158.352005 
	C376.257507,157.658981 376.503448,157.194000 377.236023,156.448441 
	C378.927185,155.556015 380.131653,154.944153 381.679138,154.269135 
	C383.324188,153.704697 384.626160,153.203400 385.928131,152.702087 
	C386.769318,153.560410 387.454498,154.760773 388.474884,155.226227 
	C406.589722,163.489426 415.250916,178.136581 416.899170,197.410919 
	C417.147125,200.310272 416.328033,203.300888 416.004852,206.695923 
	C404.298096,207.816162 392.589020,208.489746 380.439819,209.279724 
z"/>
    <path fill="#3D01AB" opacity="1.000000" stroke="none"
      d="
M306.524780,217.866837 
	C306.972687,218.677811 306.984985,219.453339 306.998291,220.616791 
	C298.936371,222.525543 290.871063,224.033920 282.811066,225.570068 
	C269.833252,228.043518 256.858887,230.535294 243.462219,233.033936 
	C242.698669,232.312469 242.355957,231.576385 242.012161,230.516190 
	C253.324921,227.728073 264.638763,225.264069 276.330994,222.622009 
	C286.502655,220.906433 296.295898,219.368912 306.524780,217.866837 
z"/>
    <path fill="#3902A3" opacity="1.000000" stroke="none"
      d="
M298.833984,250.847656 
	C298.417145,250.933853 297.853455,250.744705 297.120728,250.306702 
	C297.530182,250.229340 298.108643,250.400833 298.833984,250.847656 
z"/>
    <path fill="#1EE0F0" opacity="1.000000" stroke="none"
      d="
M233.322784,320.929779 
	C231.847107,321.277161 230.726257,321.508301 229.618515,321.790771 
	C226.162033,322.672211 224.636414,321.542511 225.458572,317.562073 
	C228.012207,317.210724 230.568970,316.858917 233.892227,316.401672 
	C233.815750,318.027466 233.749680,319.432251 233.322784,320.929779 
z"/>
    <path fill="#1EE0F0" opacity="1.000000" stroke="none"
      d="
M227.200745,312.910767 
	C225.723511,311.729340 224.678665,310.525421 223.633820,309.321533 
	C223.989365,308.963837 224.344894,308.606140 224.700439,308.248444 
	C227.274536,308.248444 229.848618,308.248444 232.656784,308.248444 
	C234.554001,313.627625 230.232681,312.370605 227.200745,312.910767 
z"/>
    <path fill="#725CFF" opacity="1.000000" stroke="none"
      d="
M395.353363,146.019226 
	C398.438599,142.962006 401.875183,139.893341 405.671295,136.914581 
	C402.588776,140.005585 399.146759,143.006668 395.353363,146.019226 
z"/>
    <path fill="#725CFF" opacity="1.000000" stroke="none"
      d="
M386.128174,152.481613 
	C384.626160,153.203400 383.324188,153.704697 381.561005,154.147491 
	C381.099823,154.088974 380.871155,153.838501 381.009186,153.602478 
	C381.446442,152.923645 381.745697,152.480820 382.044922,152.038010 
	C382.044922,152.038010 382.017487,151.994736 382.290955,151.967865 
	C382.721832,151.637039 382.879211,151.333084 383.036591,151.029129 
	C383.036591,151.029129 383.046539,151.091476 383.072479,151.110092 
	C384.822052,150.698608 386.545654,150.268494 388.650574,149.920013 
	C388.130646,150.754791 387.229431,151.507965 386.128174,152.481613 
z"/>
    <path fill="#725CFF" opacity="1.000000" stroke="none"
      d="
M389.344818,150.014893 
	C390.765167,148.636078 392.532715,147.240707 394.665344,145.925049 
	C393.250977,147.335953 391.471497,148.667145 389.344818,150.014893 
z"/>
    <path fill="#725CFF" opacity="1.000000" stroke="none"
      d="
M407.266296,135.977509 
	C407.144287,135.694092 407.291901,135.357346 407.735168,135.008606 
	C407.865845,135.305801 407.700867,135.614990 407.266296,135.977509 
z"/>
    <path fill="#725CFF" opacity="1.000000" stroke="none"
      d="
M406.266174,136.977539 
	C406.144287,136.694489 406.292023,136.358093 406.735291,136.009171 
	C406.865845,136.305832 406.700836,136.615021 406.266174,136.977539 
z"/>
    <path fill="#C3C7FF" opacity="1.000000" stroke="none"
      d="
M342.439819,171.921860 
	C343.098511,173.250961 343.855469,174.818924 343.417908,175.906113 
	C338.623322,187.818954 338.855652,199.728958 343.052307,212.140976 
	C332.337555,214.027649 321.578125,215.486267 310.411438,216.904739 
	C305.843506,203.529663 304.693390,190.043686 307.916992,176.323944 
	C308.102936,175.532486 307.980072,174.668457 308.002869,173.403046 
	C319.330994,172.624405 330.657196,172.280930 342.439819,171.921860 
z"/>
    <path fill="#725CFF" opacity="1.000000" stroke="none"
      d="
M374.696838,157.669434 
	C368.570618,159.926514 362.206696,161.915176 355.454773,163.899841 
	C356.023346,163.214035 356.887238,162.214661 357.952148,161.903732 
	C363.426086,160.305511 368.951660,158.884155 374.696838,157.669434 
z"/>
    <path fill="#725CFF" opacity="1.000000" stroke="none"
      d="
M381.217957,154.210632 
	C380.131653,154.944153 378.927185,155.556015 377.366516,156.215851 
	C377.009979,156.063950 377.009674,155.864090 377.298767,155.312378 
	C378.077606,154.644394 378.567017,154.328278 379.056427,154.012177 
	C379.056427,154.012177 378.997711,153.997025 379.310730,153.993225 
	C380.039551,153.939117 380.455353,153.888809 380.871155,153.838501 
	C380.871155,153.838501 381.099823,154.088974 381.217957,154.210632 
z"/>
    <path fill="#BEB5FF" opacity="1.000000" stroke="none"
      d="
M381.009186,153.602478 
	C380.455353,153.888809 380.039551,153.939117 379.310364,154.023560 
	C379.792114,153.384308 380.587219,152.710953 381.713623,152.037796 
	C381.745697,152.480820 381.446442,152.923645 381.009186,153.602478 
z"/>
    <path fill="#BEB5FF" opacity="1.000000" stroke="none"
      d="
M378.745117,154.031952 
	C378.567017,154.328278 378.077606,154.644394 377.291748,155.012634 
	C377.474823,154.727097 377.954315,154.389420 378.745117,154.031952 
z"/>
    <path fill="#BEB5FF" opacity="1.000000" stroke="none"
      d="
M382.799316,151.120544 
	C382.879211,151.333084 382.721832,151.637039 382.293091,151.992966 
	C382.201813,151.767273 382.381897,151.489624 382.799316,151.120544 
z"/>
    <path fill="#A4D3EB" opacity="1.000000" stroke="none"
      d="
M375.902344,537.908203 
	C381.965149,529.677795 390.477997,525.440430 400.268188,524.132996 
	C406.644348,523.281616 413.110199,523.459412 419.294250,526.539612 
	C434.018646,533.873840 433.738586,552.263550 425.462158,562.514038 
	C424.899719,563.210632 421.990112,563.094910 421.159729,562.310913 
	C416.809814,558.203857 412.591431,553.921021 408.679291,549.395081 
	C402.408447,542.140198 396.918915,542.283569 391.441162,550.119324 
	C386.035614,557.851929 380.572357,565.544128 375.187714,573.178467 
	C364.093048,567.376221 364.432068,549.666077 375.637146,538.443848 
	C374.790771,541.157227 373.904541,543.836853 372.353058,546.050171 
	C368.134949,552.067810 368.032318,558.488464 370.240295,565.053162 
	C371.266083,568.102966 373.731934,568.855774 375.843567,565.998840 
	C379.774323,560.680725 383.610413,555.265869 387.076477,549.639099 
	C390.127594,544.686035 394.074921,541.811157 400.393555,541.970337 
	C402.735107,542.677795 405.110596,542.888000 406.537109,544.161316 
	C410.836945,547.999390 414.754547,552.264221 418.846954,556.336731 
	C421.550171,559.026794 423.967834,558.469482 425.694916,555.329407 
	C430.786957,546.071350 426.615692,533.737366 417.283722,528.859497 
	C408.368713,524.199463 399.737122,525.347046 390.649658,529.044556 
	C385.501129,532.020691 380.701752,534.964478 375.902344,537.908203 
z"/>
    <path fill="#A4D3EB" opacity="1.000000" stroke="none"
      d="
M393.860352,569.939392 
	C394.013336,569.467102 394.078552,568.940552 394.332275,568.530640 
	C398.566223,561.689575 399.007294,561.616394 404.631500,567.343506 
	C406.905273,569.658875 409.015533,572.134827 411.241455,574.583069 
	C404.373657,579.663025 395.710632,581.275391 387.038910,579.192261 
	C388.228668,577.445312 389.305939,575.863464 390.702942,574.518127 
	C391.462585,579.282776 395.097107,578.290161 397.468018,577.816895 
	C400.357056,577.240112 403.026459,575.493713 405.700043,574.081299 
	C405.858093,573.997742 405.378510,572.282288 404.906677,571.500671 
	C401.890259,566.503662 397.990204,567.310303 393.860352,569.939392 
z"/>
    <path fill="#B6D3FF" opacity="1.000000" stroke="none"
      d="
M393.596832,570.104736 
	C397.990204,567.310303 401.890259,566.503662 404.906677,571.500671 
	C405.378510,572.282288 405.858093,573.997742 405.700043,574.081299 
	C403.026459,575.493713 400.357056,577.240112 397.468018,577.816895 
	C395.097107,578.290161 391.462585,579.282776 391.000183,574.349182 
	C391.762878,572.719238 392.548096,571.494690 393.596832,570.104736 
z"/>
    <path fill="#C1C8FD" opacity="1.000000" stroke="none"
      d="
M390.998779,529.012207 
	C399.737122,525.347046 408.368713,524.199463 417.283722,528.859497 
	C426.615692,533.737366 430.786957,546.071350 425.694916,555.329407 
	C423.967834,558.469482 421.550171,559.026794 418.846954,556.336731 
	C414.754547,552.264221 410.836945,547.999390 406.537109,544.161316 
	C405.110596,542.888000 402.735107,542.677795 400.342712,541.639893 
	C396.850555,537.258606 391.089020,535.187988 390.998779,529.012207 
z"/>
    <path fill="#C6CFFF" opacity="1.000000" stroke="none"
      d="
M390.649658,529.044556 
	C391.089020,535.187988 396.850555,537.258606 399.942749,541.628662 
	C394.074921,541.811157 390.127594,544.686035 387.076477,549.639099 
	C383.610413,555.265869 379.774323,560.680725 375.843567,565.998840 
	C373.731934,568.855774 371.266083,568.102966 370.240295,565.053162 
	C368.032318,558.488464 368.134949,552.067810 372.353058,546.050171 
	C373.904541,543.836853 374.790771,541.157227 375.943237,538.295898 
	C375.906036,537.901550 376.002136,537.991455 375.952240,537.949829 
	C380.701752,534.964478 385.501129,532.020691 390.649658,529.044556 
z"/>
  </svg>
)

export default LogoIcon;